var Cn = Object.defineProperty;
var In = (e, t, n) => t in e ? Cn(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var It = (e, t, n) => In(e, typeof t != "symbol" ? t + "" : t, n);
const Y = {
  MATCH_TYPE: {
    WORD: "WORD"
  },
  GRADING: {
    PASS_FAIL: "PASS_FAIL",
    NONE: "NONE",
    PARTIAL_CREDIT: "PARTIAL_CREDIT"
  },
  ANNOTATION_TOOL: {
    HIGHLIGHT: "HIGHLIGHT",
    UNDERLINE: "UNDERLINE",
    STRIKE_THROUGH: "STRIKE_THROUGH"
  },
  COLOR: {
    BLUE: "BLUE",
    GREEN: "GREEN",
    YELLOW: "YELLOW",
    PURPLE: "PURPLE",
    ORANGE: "ORANGE",
    PINK: "PINK",
    BLACK: "BLACK"
  }
};
let We;
function Oa(e, t) {
  if (We)
    return We;
  const n = new e(
    {
      createdBy: {
        type: e.Types.ObjectId,
        required: function() {
          return this.default !== !0;
        }
      },
      default: Boolean,
      // If no creator (createdBy) then it is a default question
      createdFor: e.Types.ObjectId,
      // Some questions can be created for specific simulations
      version: P(Number, { default: 1 }),
      media: [At(e)],
      scoreValue: { type: Number, default: 1 }
    },
    { discriminatorKey: "type" }
  ), r = new e({
    current: P(n),
    previous: {
      type: [n],
      get: (a) => a || []
    },
    deleted: Boolean
  });
  for (const a in De) {
    const i = de[a].getSchema(e);
    r.path("current").discriminator(a, i), r.path("previous").discriminator(a, i);
  }
  return We = t.model(
    "Question",
    r
  ), We;
}
function At(e) {
  return new e({
    type: P(String, { enum: Ce }),
    url: P(String)
  });
}
function P(e, t = {}) {
  return {
    type: e,
    required: !0,
    ...t
  };
}
function Fe(e, t, n = {}) {
  return P([e], {
    validate: {
      validator: function(r) {
        return Array.isArray(r) && (r == null ? void 0 : r.length) > 0;
      },
      message: t
    },
    ...n
  });
}
function Ln(e, t) {
  if (!e.length)
    return null;
  let n = null, r = !1, a = e.length - 1, i = 0;
  for (; i <= a; ) {
    const o = i + Math.floor((a - i + 1) / 2), s = t(e[o]);
    s < 0 ? i = o + 1 : s > 0 ? (r || (n = o), a = o - 1) : s === 0 && (n = o, r = !0, i = o + 1);
  }
  return n;
}
function Nn(e, t) {
  if (!e.length)
    return null;
  let n = null, r = !1, a = e.length - 1, i = 0;
  for (; i <= a; ) {
    const o = i + Math.floor((a - i + 1) / 2), s = t(e[o]);
    s < 0 ? (r || (n = o), i = o + 1) : s > 0 ? a = o - 1 : s === 0 && (n = o, r = !0, a = o - 1);
  }
  return n;
}
const Rn = /* @__PURE__ */ new Set([
  "paragraph",
  "root",
  "list",
  "listItem",
  "blockquote",
  "heading",
  "strong",
  "emphasis",
  "delete",
  "mdxJsxFlowElement",
  "mdxJsxTextElement"
]);
function qn(e, t) {
  var a, i, o, s, c;
  const n = [e];
  let r;
  for (; r = n.pop(); ) {
    if (Rn.has(r.type)) {
      n.push(...r.children);
      continue;
    }
    if (r.type === "text") {
      const l = r, g = (a = l.position) == null ? void 0 : a.start.offset, f = (i = l.position) == null ? void 0 : i.end.offset;
      g != null && f != null && t.push({
        range: {
          start: g,
          end: f
        },
        text: l.value
      });
      continue;
    }
    if (r.type === "code") {
      const l = r;
      if (!(l.lang === null || l.lang === "code"))
        continue;
      const g = (o = l.position) == null ? void 0 : o.start.offset, f = (s = l.position) == null ? void 0 : s.end.offset;
      g != null && f != null && t.push({
        range: {
          start: g + 3 + (((c = l.lang) == null ? void 0 : c.length) ?? 0) + 1,
          // +3 to ignore the triple ticks ```, +1 to ignore the new line after the language
          end: f
        },
        text: l.value
      });
      continue;
    }
    if (r.type === "inlineCode") {
      const l = r, {
        language: g,
        codeSnippet: f,
        codeSnippetRange: m
      } = Dn(l.value, r.position ?? null);
      if (g !== "code" || !m)
        return;
      t.push({
        range: {
          start: m.start,
          end: m.end
        },
        text: f
      });
    }
  }
}
function sn(e) {
  const t = [];
  qn(e, t);
  const n = [];
  for (const r of t)
    for (const a of r.text.matchAll(/\w+/g)) {
      const i = a[0];
      n.push({
        range: {
          start: r.range.start + (a.index || 0),
          end: r.range.start + (a.index || 0) + i.length
        },
        text: i
      });
    }
  return n.sort((r, a) => r.range.start - a.range.start);
}
function Dn(e, t) {
  let n = "code", r = e, a = (t == null ? void 0 : t.start.offset) != null && (t != null && t.end.offset) ? {
    start: t.start.offset + 1,
    // +1 to ignore the starting tick `
    end: t.end.offset
  } : null;
  if (typeof e == "string" && e.startsWith("lang-")) {
    const o = e.match(/^lang-[^\s]*\s/);
    if (o != null && o.length) {
      const s = o[0];
      n = s.slice(
        0,
        // remove tailing space
        s.length - 1
      ), r = e.slice(
        // ignore text describing the language to use
        n.length + 1,
        e.length
      ), a && (a = {
        start: a.start + n.length + 1,
        end: a.end
      });
    }
  }
  return {
    language: n == null ? void 0 : n.replace("lang-", ""),
    codeSnippet: r,
    codeSnippetRange: a
  };
}
function On(e) {
  return un(sn(e));
}
function un(e) {
  return (t) => {
    const n = rt(
      t,
      e
    );
    if (n == null)
      return null;
    const { firstElementIndex: r, lastElementIndex: a } = n, i = e[r], o = e[a];
    if (!i || !o)
      throw new Error(
        "firstTextElement or lastTextElement is undefined. This should be impossible"
      );
    return {
      range: {
        start: i.range.start,
        end: o.range.end
      },
      rangeOverlappingNextSelectableElement: {
        start: r === 0 ? i.range.start : (
          // we just checked that firstElementIndex is not 0, so we can safely access the previous element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[r - 1].range.end - 1
        ),
        end: a === e.length - 1 ? o.range.end : (
          // we just checked that lastElementIndex is not the last index, so we can safely access the next element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[a + 1].range.start + 1
        )
      },
      extendedRangeToNextSelectableElements: {
        start: r === 0 ? i.range.start : (
          // we just checked that firstElementIndex is not 0, so we can safely access the previous element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[r - 1].range.end
        ),
        end: a === e.length - 1 ? o.range.end : (
          // we just checked that lastElementIndex is not the last index, so we can safely access the next element
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          e[a + 1].range.start
        )
      }
    };
  };
}
function _n(e) {
  return (t) => {
    const n = rt(
      t,
      e
    );
    if (n == null)
      return null;
    const { firstElementIndex: r, lastElementIndex: a } = n, i = {
      start: Math.max(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        e[r].range.start,
        t.start
      ),
      end: Math.min(
        // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        e[a].range.end,
        t.end
      )
    };
    return {
      range: i,
      rangeOverlappingNextSelectableElement: {
        start: (
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          i.start - 1 >= e[r].range.start ? i.start - 1 : r === 0 ? i.start : (
            // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
            e[r - 1].range.end - 1
          )
        ),
        end: (
          // NOTE: < is used as .end is exclusive
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          i.end + 1 < e[a].range.end ? i.end + 1 : a === e.length - 1 ? i.end : (
            // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
            e[a + 1].range.start + 1
          )
        )
      },
      extendedRangeToNextSelectableElements: {
        start: i.start - 1 >= // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
        e[r].range.start || r === 0 ? i.start : (
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          e[r - 1].range.end
        ),
        end: (
          // NOTE: < is used as .end is exclusive
          // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
          i.end + 1 < e[a].range.end || a === e.length - 1 ? i.end : (
            // @ts-expect-error TS2345 SUPPRESS ERRORS FROM INTRODUCING noUncheckedIndexedAccess
            e[a + 1].range.start
          )
        )
      }
    };
  };
}
function rt(e, t) {
  const n = Ln(
    t,
    (a) => Lt(a.range, e.start) ? 0 : a.range.end - 1 - e.start
  ), r = Nn(
    t,
    (a) => Lt(
      a.range,
      e.end - 1
      // -1 since end is exclusive
    ) ? 0 : a.range.start - (e.end - 1)
  );
  return r == null || n == null || r < n || r === n && zn(
    e,
    // we assume that firstElementIndex is a valid index
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    t[n].range
  ) == null ? null : {
    firstElementIndex: n,
    lastElementIndex: r
  };
}
function Lt(e, t) {
  return e.start <= t && t < e.end;
}
function zn(e, t) {
  const n = Math.max(e.start, t.start), r = Math.min(e.end, t.end);
  return n >= r ? null : { start: n, end: r };
}
function ln(e, t, n) {
  var c, l, g, f, m;
  const r = /* @__PURE__ */ new Map();
  for (const p of e) {
    const T = p.style.tool ?? null, C = r.get(T) ?? /* @__PURE__ */ new Map();
    r.set(T, C);
    const q = p.style.color ?? null, x = C.get(q) ?? [];
    C.set(q, x), x.push(p);
  }
  const a = /* @__PURE__ */ new Map();
  for (const [p, T] of r.entries())
    for (const [C, q] of T.entries()) {
      const x = [];
      for (const y of q) {
        const E = n(y.buffer), I = n(y.range);
        E && x.push(E), I && x.push(I);
      }
      const D = a.get(p) ?? /* @__PURE__ */ new Map();
      a.set(p, D), D.set(C, {
        unsatisfiedTargets: q.sort(
          (y, E) => y.range.start - E.range.end
        ),
        buffers: Mn(x)
      });
    }
  const i = /* @__PURE__ */ new Map();
  let o = 0;
  for (const p of t) {
    const T = [];
    let C = 0;
    for (const D of [
      // this is a list of all the possible target annotation data which could apply to this annotation
      (c = a.get(p.style.tool)) == null ? void 0 : c.get(p.style.color),
      (l = a.get(null)) == null ? void 0 : l.get(p.style.color),
      (g = a.get(p.style.tool)) == null ? void 0 : g.get(null),
      (f = a.get(null)) == null ? void 0 : f.get(null)
    ])
      D && (T.push(D), C += D.unsatisfiedTargets.length);
    if (!T.length || C === 0)
      continue;
    const q = (m = i.get(p.style.tool)) == null ? void 0 : m.get(p.style.color);
    let x;
    if (q)
      x = q;
    else {
      x = [];
      for (const y of T)
        x = Bn(
          x,
          y.buffers
        );
      const D = i.get(p.style.tool) ?? /* @__PURE__ */ new Map();
      i.set(p.style.tool, D), D.set(p.style.color, x);
    }
    if (Nt(p.range, x))
      for (const D of T)
        for (let y = 0; y < D.unsatisfiedTargets.length; y++) {
          const E = D.unsatisfiedTargets[y];
          if (!E)
            throw new Error(
              "targetAnnotation is undefined. This should be impossible"
            );
          Nt(E.range, [
            p
          ]) && (o += E.score, Fn(D.unsatisfiedTargets, y), y -= 1);
        }
  }
  let s = 0;
  for (const p of a.values())
    for (const { unsatisfiedTargets: T } of p.values())
      for (const C of T)
        C.required && (s += 1);
  return {
    score: o,
    allRequiredTargetsSatisfied: s === 0
  };
}
function Fn(e, t) {
  e.length !== 0 && (e[t] = e[e.length - 1], e.length = e.length - 1);
}
function Nt(e, t) {
  const n = rt(e, t);
  if (!n || n.firstElementIndex !== n.lastElementIndex)
    return !1;
  const r = t[n.firstElementIndex], a = t[n.lastElementIndex];
  if (!r || !a)
    throw new Error(
      "firstRange or lastRange is undefined. This should be impossible"
    );
  return !(e.start < r.range.start || a.range.end < e.end);
}
function Mn(e) {
  const t = [];
  if (!e.length)
    return t;
  if (e.length === 1)
    return e;
  e.sort((i, o) => i.range.start - o.range.start);
  let n = {
    startIndex: 0,
    endIndex: 0,
    rangeData: {
      // we just checked that ranges.length is not 0, so we can safely access the first element
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      ...e[0].range
    }
  };
  for (let i = 1; i < e.length; i++) {
    const o = e[i];
    if (n.rangeData.end < o.rangeOverlappingNextSelectableElement.start) {
      const s = e[n.startIndex], c = e[n.endIndex];
      if (!s || !c)
        throw new Error(
          "startingRangeData or endingRangeData is undefined. This should be impossible"
        );
      t.push({
        range: n.rangeData,
        extendedRangeToNextSelectableElements: {
          start: s.extendedRangeToNextSelectableElements.start,
          end: c.extendedRangeToNextSelectableElements.end
        },
        rangeOverlappingNextSelectableElement: {
          start: s.rangeOverlappingNextSelectableElement.start,
          end: c.rangeOverlappingNextSelectableElement.end
        }
      }), n = {
        rangeData: { ...o.range },
        startIndex: i,
        endIndex: i
      };
      continue;
    }
    n.rangeData.end < o.range.end && (n.rangeData.end = o.range.end, n.endIndex = i);
  }
  const r = e[n.startIndex], a = e[n.endIndex];
  if (!r || !a)
    throw new Error(
      "startingRangeData or endingRangeData is undefined. This should be impossible"
    );
  return t.push({
    range: n.rangeData,
    extendedRangeToNextSelectableElements: {
      start: r.extendedRangeToNextSelectableElements.start,
      end: a.extendedRangeToNextSelectableElements.end
    },
    rangeOverlappingNextSelectableElement: {
      start: r.rangeOverlappingNextSelectableElement.start,
      end: a.rangeOverlappingNextSelectableElement.end
    }
  }), t;
}
function Bn(e, t) {
  if (e.length === 0)
    return t;
  if (t.length === 0)
    return e;
  const n = [], r = e[0], a = t[0];
  let i = r.range.start < a.range.start ? r : a, o = 0, s = 0;
  for (; o < e.length || s < t.length; ) {
    const c = e[o];
    if (c && c.rangeOverlappingNextSelectableElement.start < i.range.end) {
      i = Rt(c, i), o += 1;
      continue;
    }
    const l = t[s];
    if (l && l.rangeOverlappingNextSelectableElement.start < i.range.end) {
      i = Rt(l, i), s += 1;
      continue;
    }
    if (n.push(i), c && l && c.range.start < l.range.start) {
      o += 1, i = c;
      continue;
    }
    if (c) {
      o += 1, i = c;
      continue;
    }
    if (l) {
      s += 1, i = l;
      continue;
    }
    break;
  }
  return n.push(i), n;
}
function lt(e, t) {
  return {
    start: Math.min(e.start, t.start),
    end: Math.max(e.end, t.end)
  };
}
function Rt(e, t) {
  return {
    range: lt(e.range, t.range),
    rangeOverlappingNextSelectableElement: lt(
      e.rangeOverlappingNextSelectableElement,
      t.rangeOverlappingNextSelectableElement
    ),
    extendedRangeToNextSelectableElements: lt(
      e.extendedRangeToNextSelectableElements,
      t.extendedRangeToNextSelectableElements
    )
  };
}
const Pn = {};
function vn(e, t) {
  const n = Pn, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, a = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return cn(e, r, a);
}
function cn(e, t, n) {
  if (Jn(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return qt(e.children, t, n);
  }
  return Array.isArray(e) ? qt(e, t, n) : "";
}
function qt(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length; )
    r[a] = cn(e[a], t, n);
  return r.join("");
}
function Jn(e) {
  return !!(e && typeof e == "object");
}
const Dt = {
  AElig: "Æ",
  AMP: "&",
  Aacute: "Á",
  Abreve: "Ă",
  Acirc: "Â",
  Acy: "А",
  Afr: "𝔄",
  Agrave: "À",
  Alpha: "Α",
  Amacr: "Ā",
  And: "⩓",
  Aogon: "Ą",
  Aopf: "𝔸",
  ApplyFunction: "⁡",
  Aring: "Å",
  Ascr: "𝒜",
  Assign: "≔",
  Atilde: "Ã",
  Auml: "Ä",
  Backslash: "∖",
  Barv: "⫧",
  Barwed: "⌆",
  Bcy: "Б",
  Because: "∵",
  Bernoullis: "ℬ",
  Beta: "Β",
  Bfr: "𝔅",
  Bopf: "𝔹",
  Breve: "˘",
  Bscr: "ℬ",
  Bumpeq: "≎",
  CHcy: "Ч",
  COPY: "©",
  Cacute: "Ć",
  Cap: "⋒",
  CapitalDifferentialD: "ⅅ",
  Cayleys: "ℭ",
  Ccaron: "Č",
  Ccedil: "Ç",
  Ccirc: "Ĉ",
  Cconint: "∰",
  Cdot: "Ċ",
  Cedilla: "¸",
  CenterDot: "·",
  Cfr: "ℭ",
  Chi: "Χ",
  CircleDot: "⊙",
  CircleMinus: "⊖",
  CirclePlus: "⊕",
  CircleTimes: "⊗",
  ClockwiseContourIntegral: "∲",
  CloseCurlyDoubleQuote: "”",
  CloseCurlyQuote: "’",
  Colon: "∷",
  Colone: "⩴",
  Congruent: "≡",
  Conint: "∯",
  ContourIntegral: "∮",
  Copf: "ℂ",
  Coproduct: "∐",
  CounterClockwiseContourIntegral: "∳",
  Cross: "⨯",
  Cscr: "𝒞",
  Cup: "⋓",
  CupCap: "≍",
  DD: "ⅅ",
  DDotrahd: "⤑",
  DJcy: "Ђ",
  DScy: "Ѕ",
  DZcy: "Џ",
  Dagger: "‡",
  Darr: "↡",
  Dashv: "⫤",
  Dcaron: "Ď",
  Dcy: "Д",
  Del: "∇",
  Delta: "Δ",
  Dfr: "𝔇",
  DiacriticalAcute: "´",
  DiacriticalDot: "˙",
  DiacriticalDoubleAcute: "˝",
  DiacriticalGrave: "`",
  DiacriticalTilde: "˜",
  Diamond: "⋄",
  DifferentialD: "ⅆ",
  Dopf: "𝔻",
  Dot: "¨",
  DotDot: "⃜",
  DotEqual: "≐",
  DoubleContourIntegral: "∯",
  DoubleDot: "¨",
  DoubleDownArrow: "⇓",
  DoubleLeftArrow: "⇐",
  DoubleLeftRightArrow: "⇔",
  DoubleLeftTee: "⫤",
  DoubleLongLeftArrow: "⟸",
  DoubleLongLeftRightArrow: "⟺",
  DoubleLongRightArrow: "⟹",
  DoubleRightArrow: "⇒",
  DoubleRightTee: "⊨",
  DoubleUpArrow: "⇑",
  DoubleUpDownArrow: "⇕",
  DoubleVerticalBar: "∥",
  DownArrow: "↓",
  DownArrowBar: "⤓",
  DownArrowUpArrow: "⇵",
  DownBreve: "̑",
  DownLeftRightVector: "⥐",
  DownLeftTeeVector: "⥞",
  DownLeftVector: "↽",
  DownLeftVectorBar: "⥖",
  DownRightTeeVector: "⥟",
  DownRightVector: "⇁",
  DownRightVectorBar: "⥗",
  DownTee: "⊤",
  DownTeeArrow: "↧",
  Downarrow: "⇓",
  Dscr: "𝒟",
  Dstrok: "Đ",
  ENG: "Ŋ",
  ETH: "Ð",
  Eacute: "É",
  Ecaron: "Ě",
  Ecirc: "Ê",
  Ecy: "Э",
  Edot: "Ė",
  Efr: "𝔈",
  Egrave: "È",
  Element: "∈",
  Emacr: "Ē",
  EmptySmallSquare: "◻",
  EmptyVerySmallSquare: "▫",
  Eogon: "Ę",
  Eopf: "𝔼",
  Epsilon: "Ε",
  Equal: "⩵",
  EqualTilde: "≂",
  Equilibrium: "⇌",
  Escr: "ℰ",
  Esim: "⩳",
  Eta: "Η",
  Euml: "Ë",
  Exists: "∃",
  ExponentialE: "ⅇ",
  Fcy: "Ф",
  Ffr: "𝔉",
  FilledSmallSquare: "◼",
  FilledVerySmallSquare: "▪",
  Fopf: "𝔽",
  ForAll: "∀",
  Fouriertrf: "ℱ",
  Fscr: "ℱ",
  GJcy: "Ѓ",
  GT: ">",
  Gamma: "Γ",
  Gammad: "Ϝ",
  Gbreve: "Ğ",
  Gcedil: "Ģ",
  Gcirc: "Ĝ",
  Gcy: "Г",
  Gdot: "Ġ",
  Gfr: "𝔊",
  Gg: "⋙",
  Gopf: "𝔾",
  GreaterEqual: "≥",
  GreaterEqualLess: "⋛",
  GreaterFullEqual: "≧",
  GreaterGreater: "⪢",
  GreaterLess: "≷",
  GreaterSlantEqual: "⩾",
  GreaterTilde: "≳",
  Gscr: "𝒢",
  Gt: "≫",
  HARDcy: "Ъ",
  Hacek: "ˇ",
  Hat: "^",
  Hcirc: "Ĥ",
  Hfr: "ℌ",
  HilbertSpace: "ℋ",
  Hopf: "ℍ",
  HorizontalLine: "─",
  Hscr: "ℋ",
  Hstrok: "Ħ",
  HumpDownHump: "≎",
  HumpEqual: "≏",
  IEcy: "Е",
  IJlig: "Ĳ",
  IOcy: "Ё",
  Iacute: "Í",
  Icirc: "Î",
  Icy: "И",
  Idot: "İ",
  Ifr: "ℑ",
  Igrave: "Ì",
  Im: "ℑ",
  Imacr: "Ī",
  ImaginaryI: "ⅈ",
  Implies: "⇒",
  Int: "∬",
  Integral: "∫",
  Intersection: "⋂",
  InvisibleComma: "⁣",
  InvisibleTimes: "⁢",
  Iogon: "Į",
  Iopf: "𝕀",
  Iota: "Ι",
  Iscr: "ℐ",
  Itilde: "Ĩ",
  Iukcy: "І",
  Iuml: "Ï",
  Jcirc: "Ĵ",
  Jcy: "Й",
  Jfr: "𝔍",
  Jopf: "𝕁",
  Jscr: "𝒥",
  Jsercy: "Ј",
  Jukcy: "Є",
  KHcy: "Х",
  KJcy: "Ќ",
  Kappa: "Κ",
  Kcedil: "Ķ",
  Kcy: "К",
  Kfr: "𝔎",
  Kopf: "𝕂",
  Kscr: "𝒦",
  LJcy: "Љ",
  LT: "<",
  Lacute: "Ĺ",
  Lambda: "Λ",
  Lang: "⟪",
  Laplacetrf: "ℒ",
  Larr: "↞",
  Lcaron: "Ľ",
  Lcedil: "Ļ",
  Lcy: "Л",
  LeftAngleBracket: "⟨",
  LeftArrow: "←",
  LeftArrowBar: "⇤",
  LeftArrowRightArrow: "⇆",
  LeftCeiling: "⌈",
  LeftDoubleBracket: "⟦",
  LeftDownTeeVector: "⥡",
  LeftDownVector: "⇃",
  LeftDownVectorBar: "⥙",
  LeftFloor: "⌊",
  LeftRightArrow: "↔",
  LeftRightVector: "⥎",
  LeftTee: "⊣",
  LeftTeeArrow: "↤",
  LeftTeeVector: "⥚",
  LeftTriangle: "⊲",
  LeftTriangleBar: "⧏",
  LeftTriangleEqual: "⊴",
  LeftUpDownVector: "⥑",
  LeftUpTeeVector: "⥠",
  LeftUpVector: "↿",
  LeftUpVectorBar: "⥘",
  LeftVector: "↼",
  LeftVectorBar: "⥒",
  Leftarrow: "⇐",
  Leftrightarrow: "⇔",
  LessEqualGreater: "⋚",
  LessFullEqual: "≦",
  LessGreater: "≶",
  LessLess: "⪡",
  LessSlantEqual: "⩽",
  LessTilde: "≲",
  Lfr: "𝔏",
  Ll: "⋘",
  Lleftarrow: "⇚",
  Lmidot: "Ŀ",
  LongLeftArrow: "⟵",
  LongLeftRightArrow: "⟷",
  LongRightArrow: "⟶",
  Longleftarrow: "⟸",
  Longleftrightarrow: "⟺",
  Longrightarrow: "⟹",
  Lopf: "𝕃",
  LowerLeftArrow: "↙",
  LowerRightArrow: "↘",
  Lscr: "ℒ",
  Lsh: "↰",
  Lstrok: "Ł",
  Lt: "≪",
  Map: "⤅",
  Mcy: "М",
  MediumSpace: " ",
  Mellintrf: "ℳ",
  Mfr: "𝔐",
  MinusPlus: "∓",
  Mopf: "𝕄",
  Mscr: "ℳ",
  Mu: "Μ",
  NJcy: "Њ",
  Nacute: "Ń",
  Ncaron: "Ň",
  Ncedil: "Ņ",
  Ncy: "Н",
  NegativeMediumSpace: "​",
  NegativeThickSpace: "​",
  NegativeThinSpace: "​",
  NegativeVeryThinSpace: "​",
  NestedGreaterGreater: "≫",
  NestedLessLess: "≪",
  NewLine: `
`,
  Nfr: "𝔑",
  NoBreak: "⁠",
  NonBreakingSpace: " ",
  Nopf: "ℕ",
  Not: "⫬",
  NotCongruent: "≢",
  NotCupCap: "≭",
  NotDoubleVerticalBar: "∦",
  NotElement: "∉",
  NotEqual: "≠",
  NotEqualTilde: "≂̸",
  NotExists: "∄",
  NotGreater: "≯",
  NotGreaterEqual: "≱",
  NotGreaterFullEqual: "≧̸",
  NotGreaterGreater: "≫̸",
  NotGreaterLess: "≹",
  NotGreaterSlantEqual: "⩾̸",
  NotGreaterTilde: "≵",
  NotHumpDownHump: "≎̸",
  NotHumpEqual: "≏̸",
  NotLeftTriangle: "⋪",
  NotLeftTriangleBar: "⧏̸",
  NotLeftTriangleEqual: "⋬",
  NotLess: "≮",
  NotLessEqual: "≰",
  NotLessGreater: "≸",
  NotLessLess: "≪̸",
  NotLessSlantEqual: "⩽̸",
  NotLessTilde: "≴",
  NotNestedGreaterGreater: "⪢̸",
  NotNestedLessLess: "⪡̸",
  NotPrecedes: "⊀",
  NotPrecedesEqual: "⪯̸",
  NotPrecedesSlantEqual: "⋠",
  NotReverseElement: "∌",
  NotRightTriangle: "⋫",
  NotRightTriangleBar: "⧐̸",
  NotRightTriangleEqual: "⋭",
  NotSquareSubset: "⊏̸",
  NotSquareSubsetEqual: "⋢",
  NotSquareSuperset: "⊐̸",
  NotSquareSupersetEqual: "⋣",
  NotSubset: "⊂⃒",
  NotSubsetEqual: "⊈",
  NotSucceeds: "⊁",
  NotSucceedsEqual: "⪰̸",
  NotSucceedsSlantEqual: "⋡",
  NotSucceedsTilde: "≿̸",
  NotSuperset: "⊃⃒",
  NotSupersetEqual: "⊉",
  NotTilde: "≁",
  NotTildeEqual: "≄",
  NotTildeFullEqual: "≇",
  NotTildeTilde: "≉",
  NotVerticalBar: "∤",
  Nscr: "𝒩",
  Ntilde: "Ñ",
  Nu: "Ν",
  OElig: "Œ",
  Oacute: "Ó",
  Ocirc: "Ô",
  Ocy: "О",
  Odblac: "Ő",
  Ofr: "𝔒",
  Ograve: "Ò",
  Omacr: "Ō",
  Omega: "Ω",
  Omicron: "Ο",
  Oopf: "𝕆",
  OpenCurlyDoubleQuote: "“",
  OpenCurlyQuote: "‘",
  Or: "⩔",
  Oscr: "𝒪",
  Oslash: "Ø",
  Otilde: "Õ",
  Otimes: "⨷",
  Ouml: "Ö",
  OverBar: "‾",
  OverBrace: "⏞",
  OverBracket: "⎴",
  OverParenthesis: "⏜",
  PartialD: "∂",
  Pcy: "П",
  Pfr: "𝔓",
  Phi: "Φ",
  Pi: "Π",
  PlusMinus: "±",
  Poincareplane: "ℌ",
  Popf: "ℙ",
  Pr: "⪻",
  Precedes: "≺",
  PrecedesEqual: "⪯",
  PrecedesSlantEqual: "≼",
  PrecedesTilde: "≾",
  Prime: "″",
  Product: "∏",
  Proportion: "∷",
  Proportional: "∝",
  Pscr: "𝒫",
  Psi: "Ψ",
  QUOT: '"',
  Qfr: "𝔔",
  Qopf: "ℚ",
  Qscr: "𝒬",
  RBarr: "⤐",
  REG: "®",
  Racute: "Ŕ",
  Rang: "⟫",
  Rarr: "↠",
  Rarrtl: "⤖",
  Rcaron: "Ř",
  Rcedil: "Ŗ",
  Rcy: "Р",
  Re: "ℜ",
  ReverseElement: "∋",
  ReverseEquilibrium: "⇋",
  ReverseUpEquilibrium: "⥯",
  Rfr: "ℜ",
  Rho: "Ρ",
  RightAngleBracket: "⟩",
  RightArrow: "→",
  RightArrowBar: "⇥",
  RightArrowLeftArrow: "⇄",
  RightCeiling: "⌉",
  RightDoubleBracket: "⟧",
  RightDownTeeVector: "⥝",
  RightDownVector: "⇂",
  RightDownVectorBar: "⥕",
  RightFloor: "⌋",
  RightTee: "⊢",
  RightTeeArrow: "↦",
  RightTeeVector: "⥛",
  RightTriangle: "⊳",
  RightTriangleBar: "⧐",
  RightTriangleEqual: "⊵",
  RightUpDownVector: "⥏",
  RightUpTeeVector: "⥜",
  RightUpVector: "↾",
  RightUpVectorBar: "⥔",
  RightVector: "⇀",
  RightVectorBar: "⥓",
  Rightarrow: "⇒",
  Ropf: "ℝ",
  RoundImplies: "⥰",
  Rrightarrow: "⇛",
  Rscr: "ℛ",
  Rsh: "↱",
  RuleDelayed: "⧴",
  SHCHcy: "Щ",
  SHcy: "Ш",
  SOFTcy: "Ь",
  Sacute: "Ś",
  Sc: "⪼",
  Scaron: "Š",
  Scedil: "Ş",
  Scirc: "Ŝ",
  Scy: "С",
  Sfr: "𝔖",
  ShortDownArrow: "↓",
  ShortLeftArrow: "←",
  ShortRightArrow: "→",
  ShortUpArrow: "↑",
  Sigma: "Σ",
  SmallCircle: "∘",
  Sopf: "𝕊",
  Sqrt: "√",
  Square: "□",
  SquareIntersection: "⊓",
  SquareSubset: "⊏",
  SquareSubsetEqual: "⊑",
  SquareSuperset: "⊐",
  SquareSupersetEqual: "⊒",
  SquareUnion: "⊔",
  Sscr: "𝒮",
  Star: "⋆",
  Sub: "⋐",
  Subset: "⋐",
  SubsetEqual: "⊆",
  Succeeds: "≻",
  SucceedsEqual: "⪰",
  SucceedsSlantEqual: "≽",
  SucceedsTilde: "≿",
  SuchThat: "∋",
  Sum: "∑",
  Sup: "⋑",
  Superset: "⊃",
  SupersetEqual: "⊇",
  Supset: "⋑",
  THORN: "Þ",
  TRADE: "™",
  TSHcy: "Ћ",
  TScy: "Ц",
  Tab: "	",
  Tau: "Τ",
  Tcaron: "Ť",
  Tcedil: "Ţ",
  Tcy: "Т",
  Tfr: "𝔗",
  Therefore: "∴",
  Theta: "Θ",
  ThickSpace: "  ",
  ThinSpace: " ",
  Tilde: "∼",
  TildeEqual: "≃",
  TildeFullEqual: "≅",
  TildeTilde: "≈",
  Topf: "𝕋",
  TripleDot: "⃛",
  Tscr: "𝒯",
  Tstrok: "Ŧ",
  Uacute: "Ú",
  Uarr: "↟",
  Uarrocir: "⥉",
  Ubrcy: "Ў",
  Ubreve: "Ŭ",
  Ucirc: "Û",
  Ucy: "У",
  Udblac: "Ű",
  Ufr: "𝔘",
  Ugrave: "Ù",
  Umacr: "Ū",
  UnderBar: "_",
  UnderBrace: "⏟",
  UnderBracket: "⎵",
  UnderParenthesis: "⏝",
  Union: "⋃",
  UnionPlus: "⊎",
  Uogon: "Ų",
  Uopf: "𝕌",
  UpArrow: "↑",
  UpArrowBar: "⤒",
  UpArrowDownArrow: "⇅",
  UpDownArrow: "↕",
  UpEquilibrium: "⥮",
  UpTee: "⊥",
  UpTeeArrow: "↥",
  Uparrow: "⇑",
  Updownarrow: "⇕",
  UpperLeftArrow: "↖",
  UpperRightArrow: "↗",
  Upsi: "ϒ",
  Upsilon: "Υ",
  Uring: "Ů",
  Uscr: "𝒰",
  Utilde: "Ũ",
  Uuml: "Ü",
  VDash: "⊫",
  Vbar: "⫫",
  Vcy: "В",
  Vdash: "⊩",
  Vdashl: "⫦",
  Vee: "⋁",
  Verbar: "‖",
  Vert: "‖",
  VerticalBar: "∣",
  VerticalLine: "|",
  VerticalSeparator: "❘",
  VerticalTilde: "≀",
  VeryThinSpace: " ",
  Vfr: "𝔙",
  Vopf: "𝕍",
  Vscr: "𝒱",
  Vvdash: "⊪",
  Wcirc: "Ŵ",
  Wedge: "⋀",
  Wfr: "𝔚",
  Wopf: "𝕎",
  Wscr: "𝒲",
  Xfr: "𝔛",
  Xi: "Ξ",
  Xopf: "𝕏",
  Xscr: "𝒳",
  YAcy: "Я",
  YIcy: "Ї",
  YUcy: "Ю",
  Yacute: "Ý",
  Ycirc: "Ŷ",
  Ycy: "Ы",
  Yfr: "𝔜",
  Yopf: "𝕐",
  Yscr: "𝒴",
  Yuml: "Ÿ",
  ZHcy: "Ж",
  Zacute: "Ź",
  Zcaron: "Ž",
  Zcy: "З",
  Zdot: "Ż",
  ZeroWidthSpace: "​",
  Zeta: "Ζ",
  Zfr: "ℨ",
  Zopf: "ℤ",
  Zscr: "𝒵",
  aacute: "á",
  abreve: "ă",
  ac: "∾",
  acE: "∾̳",
  acd: "∿",
  acirc: "â",
  acute: "´",
  acy: "а",
  aelig: "æ",
  af: "⁡",
  afr: "𝔞",
  agrave: "à",
  alefsym: "ℵ",
  aleph: "ℵ",
  alpha: "α",
  amacr: "ā",
  amalg: "⨿",
  amp: "&",
  and: "∧",
  andand: "⩕",
  andd: "⩜",
  andslope: "⩘",
  andv: "⩚",
  ang: "∠",
  ange: "⦤",
  angle: "∠",
  angmsd: "∡",
  angmsdaa: "⦨",
  angmsdab: "⦩",
  angmsdac: "⦪",
  angmsdad: "⦫",
  angmsdae: "⦬",
  angmsdaf: "⦭",
  angmsdag: "⦮",
  angmsdah: "⦯",
  angrt: "∟",
  angrtvb: "⊾",
  angrtvbd: "⦝",
  angsph: "∢",
  angst: "Å",
  angzarr: "⍼",
  aogon: "ą",
  aopf: "𝕒",
  ap: "≈",
  apE: "⩰",
  apacir: "⩯",
  ape: "≊",
  apid: "≋",
  apos: "'",
  approx: "≈",
  approxeq: "≊",
  aring: "å",
  ascr: "𝒶",
  ast: "*",
  asymp: "≈",
  asympeq: "≍",
  atilde: "ã",
  auml: "ä",
  awconint: "∳",
  awint: "⨑",
  bNot: "⫭",
  backcong: "≌",
  backepsilon: "϶",
  backprime: "‵",
  backsim: "∽",
  backsimeq: "⋍",
  barvee: "⊽",
  barwed: "⌅",
  barwedge: "⌅",
  bbrk: "⎵",
  bbrktbrk: "⎶",
  bcong: "≌",
  bcy: "б",
  bdquo: "„",
  becaus: "∵",
  because: "∵",
  bemptyv: "⦰",
  bepsi: "϶",
  bernou: "ℬ",
  beta: "β",
  beth: "ℶ",
  between: "≬",
  bfr: "𝔟",
  bigcap: "⋂",
  bigcirc: "◯",
  bigcup: "⋃",
  bigodot: "⨀",
  bigoplus: "⨁",
  bigotimes: "⨂",
  bigsqcup: "⨆",
  bigstar: "★",
  bigtriangledown: "▽",
  bigtriangleup: "△",
  biguplus: "⨄",
  bigvee: "⋁",
  bigwedge: "⋀",
  bkarow: "⤍",
  blacklozenge: "⧫",
  blacksquare: "▪",
  blacktriangle: "▴",
  blacktriangledown: "▾",
  blacktriangleleft: "◂",
  blacktriangleright: "▸",
  blank: "␣",
  blk12: "▒",
  blk14: "░",
  blk34: "▓",
  block: "█",
  bne: "=⃥",
  bnequiv: "≡⃥",
  bnot: "⌐",
  bopf: "𝕓",
  bot: "⊥",
  bottom: "⊥",
  bowtie: "⋈",
  boxDL: "╗",
  boxDR: "╔",
  boxDl: "╖",
  boxDr: "╓",
  boxH: "═",
  boxHD: "╦",
  boxHU: "╩",
  boxHd: "╤",
  boxHu: "╧",
  boxUL: "╝",
  boxUR: "╚",
  boxUl: "╜",
  boxUr: "╙",
  boxV: "║",
  boxVH: "╬",
  boxVL: "╣",
  boxVR: "╠",
  boxVh: "╫",
  boxVl: "╢",
  boxVr: "╟",
  boxbox: "⧉",
  boxdL: "╕",
  boxdR: "╒",
  boxdl: "┐",
  boxdr: "┌",
  boxh: "─",
  boxhD: "╥",
  boxhU: "╨",
  boxhd: "┬",
  boxhu: "┴",
  boxminus: "⊟",
  boxplus: "⊞",
  boxtimes: "⊠",
  boxuL: "╛",
  boxuR: "╘",
  boxul: "┘",
  boxur: "└",
  boxv: "│",
  boxvH: "╪",
  boxvL: "╡",
  boxvR: "╞",
  boxvh: "┼",
  boxvl: "┤",
  boxvr: "├",
  bprime: "‵",
  breve: "˘",
  brvbar: "¦",
  bscr: "𝒷",
  bsemi: "⁏",
  bsim: "∽",
  bsime: "⋍",
  bsol: "\\",
  bsolb: "⧅",
  bsolhsub: "⟈",
  bull: "•",
  bullet: "•",
  bump: "≎",
  bumpE: "⪮",
  bumpe: "≏",
  bumpeq: "≏",
  cacute: "ć",
  cap: "∩",
  capand: "⩄",
  capbrcup: "⩉",
  capcap: "⩋",
  capcup: "⩇",
  capdot: "⩀",
  caps: "∩︀",
  caret: "⁁",
  caron: "ˇ",
  ccaps: "⩍",
  ccaron: "č",
  ccedil: "ç",
  ccirc: "ĉ",
  ccups: "⩌",
  ccupssm: "⩐",
  cdot: "ċ",
  cedil: "¸",
  cemptyv: "⦲",
  cent: "¢",
  centerdot: "·",
  cfr: "𝔠",
  chcy: "ч",
  check: "✓",
  checkmark: "✓",
  chi: "χ",
  cir: "○",
  cirE: "⧃",
  circ: "ˆ",
  circeq: "≗",
  circlearrowleft: "↺",
  circlearrowright: "↻",
  circledR: "®",
  circledS: "Ⓢ",
  circledast: "⊛",
  circledcirc: "⊚",
  circleddash: "⊝",
  cire: "≗",
  cirfnint: "⨐",
  cirmid: "⫯",
  cirscir: "⧂",
  clubs: "♣",
  clubsuit: "♣",
  colon: ":",
  colone: "≔",
  coloneq: "≔",
  comma: ",",
  commat: "@",
  comp: "∁",
  compfn: "∘",
  complement: "∁",
  complexes: "ℂ",
  cong: "≅",
  congdot: "⩭",
  conint: "∮",
  copf: "𝕔",
  coprod: "∐",
  copy: "©",
  copysr: "℗",
  crarr: "↵",
  cross: "✗",
  cscr: "𝒸",
  csub: "⫏",
  csube: "⫑",
  csup: "⫐",
  csupe: "⫒",
  ctdot: "⋯",
  cudarrl: "⤸",
  cudarrr: "⤵",
  cuepr: "⋞",
  cuesc: "⋟",
  cularr: "↶",
  cularrp: "⤽",
  cup: "∪",
  cupbrcap: "⩈",
  cupcap: "⩆",
  cupcup: "⩊",
  cupdot: "⊍",
  cupor: "⩅",
  cups: "∪︀",
  curarr: "↷",
  curarrm: "⤼",
  curlyeqprec: "⋞",
  curlyeqsucc: "⋟",
  curlyvee: "⋎",
  curlywedge: "⋏",
  curren: "¤",
  curvearrowleft: "↶",
  curvearrowright: "↷",
  cuvee: "⋎",
  cuwed: "⋏",
  cwconint: "∲",
  cwint: "∱",
  cylcty: "⌭",
  dArr: "⇓",
  dHar: "⥥",
  dagger: "†",
  daleth: "ℸ",
  darr: "↓",
  dash: "‐",
  dashv: "⊣",
  dbkarow: "⤏",
  dblac: "˝",
  dcaron: "ď",
  dcy: "д",
  dd: "ⅆ",
  ddagger: "‡",
  ddarr: "⇊",
  ddotseq: "⩷",
  deg: "°",
  delta: "δ",
  demptyv: "⦱",
  dfisht: "⥿",
  dfr: "𝔡",
  dharl: "⇃",
  dharr: "⇂",
  diam: "⋄",
  diamond: "⋄",
  diamondsuit: "♦",
  diams: "♦",
  die: "¨",
  digamma: "ϝ",
  disin: "⋲",
  div: "÷",
  divide: "÷",
  divideontimes: "⋇",
  divonx: "⋇",
  djcy: "ђ",
  dlcorn: "⌞",
  dlcrop: "⌍",
  dollar: "$",
  dopf: "𝕕",
  dot: "˙",
  doteq: "≐",
  doteqdot: "≑",
  dotminus: "∸",
  dotplus: "∔",
  dotsquare: "⊡",
  doublebarwedge: "⌆",
  downarrow: "↓",
  downdownarrows: "⇊",
  downharpoonleft: "⇃",
  downharpoonright: "⇂",
  drbkarow: "⤐",
  drcorn: "⌟",
  drcrop: "⌌",
  dscr: "𝒹",
  dscy: "ѕ",
  dsol: "⧶",
  dstrok: "đ",
  dtdot: "⋱",
  dtri: "▿",
  dtrif: "▾",
  duarr: "⇵",
  duhar: "⥯",
  dwangle: "⦦",
  dzcy: "џ",
  dzigrarr: "⟿",
  eDDot: "⩷",
  eDot: "≑",
  eacute: "é",
  easter: "⩮",
  ecaron: "ě",
  ecir: "≖",
  ecirc: "ê",
  ecolon: "≕",
  ecy: "э",
  edot: "ė",
  ee: "ⅇ",
  efDot: "≒",
  efr: "𝔢",
  eg: "⪚",
  egrave: "è",
  egs: "⪖",
  egsdot: "⪘",
  el: "⪙",
  elinters: "⏧",
  ell: "ℓ",
  els: "⪕",
  elsdot: "⪗",
  emacr: "ē",
  empty: "∅",
  emptyset: "∅",
  emptyv: "∅",
  emsp13: " ",
  emsp14: " ",
  emsp: " ",
  eng: "ŋ",
  ensp: " ",
  eogon: "ę",
  eopf: "𝕖",
  epar: "⋕",
  eparsl: "⧣",
  eplus: "⩱",
  epsi: "ε",
  epsilon: "ε",
  epsiv: "ϵ",
  eqcirc: "≖",
  eqcolon: "≕",
  eqsim: "≂",
  eqslantgtr: "⪖",
  eqslantless: "⪕",
  equals: "=",
  equest: "≟",
  equiv: "≡",
  equivDD: "⩸",
  eqvparsl: "⧥",
  erDot: "≓",
  erarr: "⥱",
  escr: "ℯ",
  esdot: "≐",
  esim: "≂",
  eta: "η",
  eth: "ð",
  euml: "ë",
  euro: "€",
  excl: "!",
  exist: "∃",
  expectation: "ℰ",
  exponentiale: "ⅇ",
  fallingdotseq: "≒",
  fcy: "ф",
  female: "♀",
  ffilig: "ﬃ",
  fflig: "ﬀ",
  ffllig: "ﬄ",
  ffr: "𝔣",
  filig: "ﬁ",
  fjlig: "fj",
  flat: "♭",
  fllig: "ﬂ",
  fltns: "▱",
  fnof: "ƒ",
  fopf: "𝕗",
  forall: "∀",
  fork: "⋔",
  forkv: "⫙",
  fpartint: "⨍",
  frac12: "½",
  frac13: "⅓",
  frac14: "¼",
  frac15: "⅕",
  frac16: "⅙",
  frac18: "⅛",
  frac23: "⅔",
  frac25: "⅖",
  frac34: "¾",
  frac35: "⅗",
  frac38: "⅜",
  frac45: "⅘",
  frac56: "⅚",
  frac58: "⅝",
  frac78: "⅞",
  frasl: "⁄",
  frown: "⌢",
  fscr: "𝒻",
  gE: "≧",
  gEl: "⪌",
  gacute: "ǵ",
  gamma: "γ",
  gammad: "ϝ",
  gap: "⪆",
  gbreve: "ğ",
  gcirc: "ĝ",
  gcy: "г",
  gdot: "ġ",
  ge: "≥",
  gel: "⋛",
  geq: "≥",
  geqq: "≧",
  geqslant: "⩾",
  ges: "⩾",
  gescc: "⪩",
  gesdot: "⪀",
  gesdoto: "⪂",
  gesdotol: "⪄",
  gesl: "⋛︀",
  gesles: "⪔",
  gfr: "𝔤",
  gg: "≫",
  ggg: "⋙",
  gimel: "ℷ",
  gjcy: "ѓ",
  gl: "≷",
  glE: "⪒",
  gla: "⪥",
  glj: "⪤",
  gnE: "≩",
  gnap: "⪊",
  gnapprox: "⪊",
  gne: "⪈",
  gneq: "⪈",
  gneqq: "≩",
  gnsim: "⋧",
  gopf: "𝕘",
  grave: "`",
  gscr: "ℊ",
  gsim: "≳",
  gsime: "⪎",
  gsiml: "⪐",
  gt: ">",
  gtcc: "⪧",
  gtcir: "⩺",
  gtdot: "⋗",
  gtlPar: "⦕",
  gtquest: "⩼",
  gtrapprox: "⪆",
  gtrarr: "⥸",
  gtrdot: "⋗",
  gtreqless: "⋛",
  gtreqqless: "⪌",
  gtrless: "≷",
  gtrsim: "≳",
  gvertneqq: "≩︀",
  gvnE: "≩︀",
  hArr: "⇔",
  hairsp: " ",
  half: "½",
  hamilt: "ℋ",
  hardcy: "ъ",
  harr: "↔",
  harrcir: "⥈",
  harrw: "↭",
  hbar: "ℏ",
  hcirc: "ĥ",
  hearts: "♥",
  heartsuit: "♥",
  hellip: "…",
  hercon: "⊹",
  hfr: "𝔥",
  hksearow: "⤥",
  hkswarow: "⤦",
  hoarr: "⇿",
  homtht: "∻",
  hookleftarrow: "↩",
  hookrightarrow: "↪",
  hopf: "𝕙",
  horbar: "―",
  hscr: "𝒽",
  hslash: "ℏ",
  hstrok: "ħ",
  hybull: "⁃",
  hyphen: "‐",
  iacute: "í",
  ic: "⁣",
  icirc: "î",
  icy: "и",
  iecy: "е",
  iexcl: "¡",
  iff: "⇔",
  ifr: "𝔦",
  igrave: "ì",
  ii: "ⅈ",
  iiiint: "⨌",
  iiint: "∭",
  iinfin: "⧜",
  iiota: "℩",
  ijlig: "ĳ",
  imacr: "ī",
  image: "ℑ",
  imagline: "ℐ",
  imagpart: "ℑ",
  imath: "ı",
  imof: "⊷",
  imped: "Ƶ",
  in: "∈",
  incare: "℅",
  infin: "∞",
  infintie: "⧝",
  inodot: "ı",
  int: "∫",
  intcal: "⊺",
  integers: "ℤ",
  intercal: "⊺",
  intlarhk: "⨗",
  intprod: "⨼",
  iocy: "ё",
  iogon: "į",
  iopf: "𝕚",
  iota: "ι",
  iprod: "⨼",
  iquest: "¿",
  iscr: "𝒾",
  isin: "∈",
  isinE: "⋹",
  isindot: "⋵",
  isins: "⋴",
  isinsv: "⋳",
  isinv: "∈",
  it: "⁢",
  itilde: "ĩ",
  iukcy: "і",
  iuml: "ï",
  jcirc: "ĵ",
  jcy: "й",
  jfr: "𝔧",
  jmath: "ȷ",
  jopf: "𝕛",
  jscr: "𝒿",
  jsercy: "ј",
  jukcy: "є",
  kappa: "κ",
  kappav: "ϰ",
  kcedil: "ķ",
  kcy: "к",
  kfr: "𝔨",
  kgreen: "ĸ",
  khcy: "х",
  kjcy: "ќ",
  kopf: "𝕜",
  kscr: "𝓀",
  lAarr: "⇚",
  lArr: "⇐",
  lAtail: "⤛",
  lBarr: "⤎",
  lE: "≦",
  lEg: "⪋",
  lHar: "⥢",
  lacute: "ĺ",
  laemptyv: "⦴",
  lagran: "ℒ",
  lambda: "λ",
  lang: "⟨",
  langd: "⦑",
  langle: "⟨",
  lap: "⪅",
  laquo: "«",
  larr: "←",
  larrb: "⇤",
  larrbfs: "⤟",
  larrfs: "⤝",
  larrhk: "↩",
  larrlp: "↫",
  larrpl: "⤹",
  larrsim: "⥳",
  larrtl: "↢",
  lat: "⪫",
  latail: "⤙",
  late: "⪭",
  lates: "⪭︀",
  lbarr: "⤌",
  lbbrk: "❲",
  lbrace: "{",
  lbrack: "[",
  lbrke: "⦋",
  lbrksld: "⦏",
  lbrkslu: "⦍",
  lcaron: "ľ",
  lcedil: "ļ",
  lceil: "⌈",
  lcub: "{",
  lcy: "л",
  ldca: "⤶",
  ldquo: "“",
  ldquor: "„",
  ldrdhar: "⥧",
  ldrushar: "⥋",
  ldsh: "↲",
  le: "≤",
  leftarrow: "←",
  leftarrowtail: "↢",
  leftharpoondown: "↽",
  leftharpoonup: "↼",
  leftleftarrows: "⇇",
  leftrightarrow: "↔",
  leftrightarrows: "⇆",
  leftrightharpoons: "⇋",
  leftrightsquigarrow: "↭",
  leftthreetimes: "⋋",
  leg: "⋚",
  leq: "≤",
  leqq: "≦",
  leqslant: "⩽",
  les: "⩽",
  lescc: "⪨",
  lesdot: "⩿",
  lesdoto: "⪁",
  lesdotor: "⪃",
  lesg: "⋚︀",
  lesges: "⪓",
  lessapprox: "⪅",
  lessdot: "⋖",
  lesseqgtr: "⋚",
  lesseqqgtr: "⪋",
  lessgtr: "≶",
  lesssim: "≲",
  lfisht: "⥼",
  lfloor: "⌊",
  lfr: "𝔩",
  lg: "≶",
  lgE: "⪑",
  lhard: "↽",
  lharu: "↼",
  lharul: "⥪",
  lhblk: "▄",
  ljcy: "љ",
  ll: "≪",
  llarr: "⇇",
  llcorner: "⌞",
  llhard: "⥫",
  lltri: "◺",
  lmidot: "ŀ",
  lmoust: "⎰",
  lmoustache: "⎰",
  lnE: "≨",
  lnap: "⪉",
  lnapprox: "⪉",
  lne: "⪇",
  lneq: "⪇",
  lneqq: "≨",
  lnsim: "⋦",
  loang: "⟬",
  loarr: "⇽",
  lobrk: "⟦",
  longleftarrow: "⟵",
  longleftrightarrow: "⟷",
  longmapsto: "⟼",
  longrightarrow: "⟶",
  looparrowleft: "↫",
  looparrowright: "↬",
  lopar: "⦅",
  lopf: "𝕝",
  loplus: "⨭",
  lotimes: "⨴",
  lowast: "∗",
  lowbar: "_",
  loz: "◊",
  lozenge: "◊",
  lozf: "⧫",
  lpar: "(",
  lparlt: "⦓",
  lrarr: "⇆",
  lrcorner: "⌟",
  lrhar: "⇋",
  lrhard: "⥭",
  lrm: "‎",
  lrtri: "⊿",
  lsaquo: "‹",
  lscr: "𝓁",
  lsh: "↰",
  lsim: "≲",
  lsime: "⪍",
  lsimg: "⪏",
  lsqb: "[",
  lsquo: "‘",
  lsquor: "‚",
  lstrok: "ł",
  lt: "<",
  ltcc: "⪦",
  ltcir: "⩹",
  ltdot: "⋖",
  lthree: "⋋",
  ltimes: "⋉",
  ltlarr: "⥶",
  ltquest: "⩻",
  ltrPar: "⦖",
  ltri: "◃",
  ltrie: "⊴",
  ltrif: "◂",
  lurdshar: "⥊",
  luruhar: "⥦",
  lvertneqq: "≨︀",
  lvnE: "≨︀",
  mDDot: "∺",
  macr: "¯",
  male: "♂",
  malt: "✠",
  maltese: "✠",
  map: "↦",
  mapsto: "↦",
  mapstodown: "↧",
  mapstoleft: "↤",
  mapstoup: "↥",
  marker: "▮",
  mcomma: "⨩",
  mcy: "м",
  mdash: "—",
  measuredangle: "∡",
  mfr: "𝔪",
  mho: "℧",
  micro: "µ",
  mid: "∣",
  midast: "*",
  midcir: "⫰",
  middot: "·",
  minus: "−",
  minusb: "⊟",
  minusd: "∸",
  minusdu: "⨪",
  mlcp: "⫛",
  mldr: "…",
  mnplus: "∓",
  models: "⊧",
  mopf: "𝕞",
  mp: "∓",
  mscr: "𝓂",
  mstpos: "∾",
  mu: "μ",
  multimap: "⊸",
  mumap: "⊸",
  nGg: "⋙̸",
  nGt: "≫⃒",
  nGtv: "≫̸",
  nLeftarrow: "⇍",
  nLeftrightarrow: "⇎",
  nLl: "⋘̸",
  nLt: "≪⃒",
  nLtv: "≪̸",
  nRightarrow: "⇏",
  nVDash: "⊯",
  nVdash: "⊮",
  nabla: "∇",
  nacute: "ń",
  nang: "∠⃒",
  nap: "≉",
  napE: "⩰̸",
  napid: "≋̸",
  napos: "ŉ",
  napprox: "≉",
  natur: "♮",
  natural: "♮",
  naturals: "ℕ",
  nbsp: " ",
  nbump: "≎̸",
  nbumpe: "≏̸",
  ncap: "⩃",
  ncaron: "ň",
  ncedil: "ņ",
  ncong: "≇",
  ncongdot: "⩭̸",
  ncup: "⩂",
  ncy: "н",
  ndash: "–",
  ne: "≠",
  neArr: "⇗",
  nearhk: "⤤",
  nearr: "↗",
  nearrow: "↗",
  nedot: "≐̸",
  nequiv: "≢",
  nesear: "⤨",
  nesim: "≂̸",
  nexist: "∄",
  nexists: "∄",
  nfr: "𝔫",
  ngE: "≧̸",
  nge: "≱",
  ngeq: "≱",
  ngeqq: "≧̸",
  ngeqslant: "⩾̸",
  nges: "⩾̸",
  ngsim: "≵",
  ngt: "≯",
  ngtr: "≯",
  nhArr: "⇎",
  nharr: "↮",
  nhpar: "⫲",
  ni: "∋",
  nis: "⋼",
  nisd: "⋺",
  niv: "∋",
  njcy: "њ",
  nlArr: "⇍",
  nlE: "≦̸",
  nlarr: "↚",
  nldr: "‥",
  nle: "≰",
  nleftarrow: "↚",
  nleftrightarrow: "↮",
  nleq: "≰",
  nleqq: "≦̸",
  nleqslant: "⩽̸",
  nles: "⩽̸",
  nless: "≮",
  nlsim: "≴",
  nlt: "≮",
  nltri: "⋪",
  nltrie: "⋬",
  nmid: "∤",
  nopf: "𝕟",
  not: "¬",
  notin: "∉",
  notinE: "⋹̸",
  notindot: "⋵̸",
  notinva: "∉",
  notinvb: "⋷",
  notinvc: "⋶",
  notni: "∌",
  notniva: "∌",
  notnivb: "⋾",
  notnivc: "⋽",
  npar: "∦",
  nparallel: "∦",
  nparsl: "⫽⃥",
  npart: "∂̸",
  npolint: "⨔",
  npr: "⊀",
  nprcue: "⋠",
  npre: "⪯̸",
  nprec: "⊀",
  npreceq: "⪯̸",
  nrArr: "⇏",
  nrarr: "↛",
  nrarrc: "⤳̸",
  nrarrw: "↝̸",
  nrightarrow: "↛",
  nrtri: "⋫",
  nrtrie: "⋭",
  nsc: "⊁",
  nsccue: "⋡",
  nsce: "⪰̸",
  nscr: "𝓃",
  nshortmid: "∤",
  nshortparallel: "∦",
  nsim: "≁",
  nsime: "≄",
  nsimeq: "≄",
  nsmid: "∤",
  nspar: "∦",
  nsqsube: "⋢",
  nsqsupe: "⋣",
  nsub: "⊄",
  nsubE: "⫅̸",
  nsube: "⊈",
  nsubset: "⊂⃒",
  nsubseteq: "⊈",
  nsubseteqq: "⫅̸",
  nsucc: "⊁",
  nsucceq: "⪰̸",
  nsup: "⊅",
  nsupE: "⫆̸",
  nsupe: "⊉",
  nsupset: "⊃⃒",
  nsupseteq: "⊉",
  nsupseteqq: "⫆̸",
  ntgl: "≹",
  ntilde: "ñ",
  ntlg: "≸",
  ntriangleleft: "⋪",
  ntrianglelefteq: "⋬",
  ntriangleright: "⋫",
  ntrianglerighteq: "⋭",
  nu: "ν",
  num: "#",
  numero: "№",
  numsp: " ",
  nvDash: "⊭",
  nvHarr: "⤄",
  nvap: "≍⃒",
  nvdash: "⊬",
  nvge: "≥⃒",
  nvgt: ">⃒",
  nvinfin: "⧞",
  nvlArr: "⤂",
  nvle: "≤⃒",
  nvlt: "<⃒",
  nvltrie: "⊴⃒",
  nvrArr: "⤃",
  nvrtrie: "⊵⃒",
  nvsim: "∼⃒",
  nwArr: "⇖",
  nwarhk: "⤣",
  nwarr: "↖",
  nwarrow: "↖",
  nwnear: "⤧",
  oS: "Ⓢ",
  oacute: "ó",
  oast: "⊛",
  ocir: "⊚",
  ocirc: "ô",
  ocy: "о",
  odash: "⊝",
  odblac: "ő",
  odiv: "⨸",
  odot: "⊙",
  odsold: "⦼",
  oelig: "œ",
  ofcir: "⦿",
  ofr: "𝔬",
  ogon: "˛",
  ograve: "ò",
  ogt: "⧁",
  ohbar: "⦵",
  ohm: "Ω",
  oint: "∮",
  olarr: "↺",
  olcir: "⦾",
  olcross: "⦻",
  oline: "‾",
  olt: "⧀",
  omacr: "ō",
  omega: "ω",
  omicron: "ο",
  omid: "⦶",
  ominus: "⊖",
  oopf: "𝕠",
  opar: "⦷",
  operp: "⦹",
  oplus: "⊕",
  or: "∨",
  orarr: "↻",
  ord: "⩝",
  order: "ℴ",
  orderof: "ℴ",
  ordf: "ª",
  ordm: "º",
  origof: "⊶",
  oror: "⩖",
  orslope: "⩗",
  orv: "⩛",
  oscr: "ℴ",
  oslash: "ø",
  osol: "⊘",
  otilde: "õ",
  otimes: "⊗",
  otimesas: "⨶",
  ouml: "ö",
  ovbar: "⌽",
  par: "∥",
  para: "¶",
  parallel: "∥",
  parsim: "⫳",
  parsl: "⫽",
  part: "∂",
  pcy: "п",
  percnt: "%",
  period: ".",
  permil: "‰",
  perp: "⊥",
  pertenk: "‱",
  pfr: "𝔭",
  phi: "φ",
  phiv: "ϕ",
  phmmat: "ℳ",
  phone: "☎",
  pi: "π",
  pitchfork: "⋔",
  piv: "ϖ",
  planck: "ℏ",
  planckh: "ℎ",
  plankv: "ℏ",
  plus: "+",
  plusacir: "⨣",
  plusb: "⊞",
  pluscir: "⨢",
  plusdo: "∔",
  plusdu: "⨥",
  pluse: "⩲",
  plusmn: "±",
  plussim: "⨦",
  plustwo: "⨧",
  pm: "±",
  pointint: "⨕",
  popf: "𝕡",
  pound: "£",
  pr: "≺",
  prE: "⪳",
  prap: "⪷",
  prcue: "≼",
  pre: "⪯",
  prec: "≺",
  precapprox: "⪷",
  preccurlyeq: "≼",
  preceq: "⪯",
  precnapprox: "⪹",
  precneqq: "⪵",
  precnsim: "⋨",
  precsim: "≾",
  prime: "′",
  primes: "ℙ",
  prnE: "⪵",
  prnap: "⪹",
  prnsim: "⋨",
  prod: "∏",
  profalar: "⌮",
  profline: "⌒",
  profsurf: "⌓",
  prop: "∝",
  propto: "∝",
  prsim: "≾",
  prurel: "⊰",
  pscr: "𝓅",
  psi: "ψ",
  puncsp: " ",
  qfr: "𝔮",
  qint: "⨌",
  qopf: "𝕢",
  qprime: "⁗",
  qscr: "𝓆",
  quaternions: "ℍ",
  quatint: "⨖",
  quest: "?",
  questeq: "≟",
  quot: '"',
  rAarr: "⇛",
  rArr: "⇒",
  rAtail: "⤜",
  rBarr: "⤏",
  rHar: "⥤",
  race: "∽̱",
  racute: "ŕ",
  radic: "√",
  raemptyv: "⦳",
  rang: "⟩",
  rangd: "⦒",
  range: "⦥",
  rangle: "⟩",
  raquo: "»",
  rarr: "→",
  rarrap: "⥵",
  rarrb: "⇥",
  rarrbfs: "⤠",
  rarrc: "⤳",
  rarrfs: "⤞",
  rarrhk: "↪",
  rarrlp: "↬",
  rarrpl: "⥅",
  rarrsim: "⥴",
  rarrtl: "↣",
  rarrw: "↝",
  ratail: "⤚",
  ratio: "∶",
  rationals: "ℚ",
  rbarr: "⤍",
  rbbrk: "❳",
  rbrace: "}",
  rbrack: "]",
  rbrke: "⦌",
  rbrksld: "⦎",
  rbrkslu: "⦐",
  rcaron: "ř",
  rcedil: "ŗ",
  rceil: "⌉",
  rcub: "}",
  rcy: "р",
  rdca: "⤷",
  rdldhar: "⥩",
  rdquo: "”",
  rdquor: "”",
  rdsh: "↳",
  real: "ℜ",
  realine: "ℛ",
  realpart: "ℜ",
  reals: "ℝ",
  rect: "▭",
  reg: "®",
  rfisht: "⥽",
  rfloor: "⌋",
  rfr: "𝔯",
  rhard: "⇁",
  rharu: "⇀",
  rharul: "⥬",
  rho: "ρ",
  rhov: "ϱ",
  rightarrow: "→",
  rightarrowtail: "↣",
  rightharpoondown: "⇁",
  rightharpoonup: "⇀",
  rightleftarrows: "⇄",
  rightleftharpoons: "⇌",
  rightrightarrows: "⇉",
  rightsquigarrow: "↝",
  rightthreetimes: "⋌",
  ring: "˚",
  risingdotseq: "≓",
  rlarr: "⇄",
  rlhar: "⇌",
  rlm: "‏",
  rmoust: "⎱",
  rmoustache: "⎱",
  rnmid: "⫮",
  roang: "⟭",
  roarr: "⇾",
  robrk: "⟧",
  ropar: "⦆",
  ropf: "𝕣",
  roplus: "⨮",
  rotimes: "⨵",
  rpar: ")",
  rpargt: "⦔",
  rppolint: "⨒",
  rrarr: "⇉",
  rsaquo: "›",
  rscr: "𝓇",
  rsh: "↱",
  rsqb: "]",
  rsquo: "’",
  rsquor: "’",
  rthree: "⋌",
  rtimes: "⋊",
  rtri: "▹",
  rtrie: "⊵",
  rtrif: "▸",
  rtriltri: "⧎",
  ruluhar: "⥨",
  rx: "℞",
  sacute: "ś",
  sbquo: "‚",
  sc: "≻",
  scE: "⪴",
  scap: "⪸",
  scaron: "š",
  sccue: "≽",
  sce: "⪰",
  scedil: "ş",
  scirc: "ŝ",
  scnE: "⪶",
  scnap: "⪺",
  scnsim: "⋩",
  scpolint: "⨓",
  scsim: "≿",
  scy: "с",
  sdot: "⋅",
  sdotb: "⊡",
  sdote: "⩦",
  seArr: "⇘",
  searhk: "⤥",
  searr: "↘",
  searrow: "↘",
  sect: "§",
  semi: ";",
  seswar: "⤩",
  setminus: "∖",
  setmn: "∖",
  sext: "✶",
  sfr: "𝔰",
  sfrown: "⌢",
  sharp: "♯",
  shchcy: "щ",
  shcy: "ш",
  shortmid: "∣",
  shortparallel: "∥",
  shy: "­",
  sigma: "σ",
  sigmaf: "ς",
  sigmav: "ς",
  sim: "∼",
  simdot: "⩪",
  sime: "≃",
  simeq: "≃",
  simg: "⪞",
  simgE: "⪠",
  siml: "⪝",
  simlE: "⪟",
  simne: "≆",
  simplus: "⨤",
  simrarr: "⥲",
  slarr: "←",
  smallsetminus: "∖",
  smashp: "⨳",
  smeparsl: "⧤",
  smid: "∣",
  smile: "⌣",
  smt: "⪪",
  smte: "⪬",
  smtes: "⪬︀",
  softcy: "ь",
  sol: "/",
  solb: "⧄",
  solbar: "⌿",
  sopf: "𝕤",
  spades: "♠",
  spadesuit: "♠",
  spar: "∥",
  sqcap: "⊓",
  sqcaps: "⊓︀",
  sqcup: "⊔",
  sqcups: "⊔︀",
  sqsub: "⊏",
  sqsube: "⊑",
  sqsubset: "⊏",
  sqsubseteq: "⊑",
  sqsup: "⊐",
  sqsupe: "⊒",
  sqsupset: "⊐",
  sqsupseteq: "⊒",
  squ: "□",
  square: "□",
  squarf: "▪",
  squf: "▪",
  srarr: "→",
  sscr: "𝓈",
  ssetmn: "∖",
  ssmile: "⌣",
  sstarf: "⋆",
  star: "☆",
  starf: "★",
  straightepsilon: "ϵ",
  straightphi: "ϕ",
  strns: "¯",
  sub: "⊂",
  subE: "⫅",
  subdot: "⪽",
  sube: "⊆",
  subedot: "⫃",
  submult: "⫁",
  subnE: "⫋",
  subne: "⊊",
  subplus: "⪿",
  subrarr: "⥹",
  subset: "⊂",
  subseteq: "⊆",
  subseteqq: "⫅",
  subsetneq: "⊊",
  subsetneqq: "⫋",
  subsim: "⫇",
  subsub: "⫕",
  subsup: "⫓",
  succ: "≻",
  succapprox: "⪸",
  succcurlyeq: "≽",
  succeq: "⪰",
  succnapprox: "⪺",
  succneqq: "⪶",
  succnsim: "⋩",
  succsim: "≿",
  sum: "∑",
  sung: "♪",
  sup1: "¹",
  sup2: "²",
  sup3: "³",
  sup: "⊃",
  supE: "⫆",
  supdot: "⪾",
  supdsub: "⫘",
  supe: "⊇",
  supedot: "⫄",
  suphsol: "⟉",
  suphsub: "⫗",
  suplarr: "⥻",
  supmult: "⫂",
  supnE: "⫌",
  supne: "⊋",
  supplus: "⫀",
  supset: "⊃",
  supseteq: "⊇",
  supseteqq: "⫆",
  supsetneq: "⊋",
  supsetneqq: "⫌",
  supsim: "⫈",
  supsub: "⫔",
  supsup: "⫖",
  swArr: "⇙",
  swarhk: "⤦",
  swarr: "↙",
  swarrow: "↙",
  swnwar: "⤪",
  szlig: "ß",
  target: "⌖",
  tau: "τ",
  tbrk: "⎴",
  tcaron: "ť",
  tcedil: "ţ",
  tcy: "т",
  tdot: "⃛",
  telrec: "⌕",
  tfr: "𝔱",
  there4: "∴",
  therefore: "∴",
  theta: "θ",
  thetasym: "ϑ",
  thetav: "ϑ",
  thickapprox: "≈",
  thicksim: "∼",
  thinsp: " ",
  thkap: "≈",
  thksim: "∼",
  thorn: "þ",
  tilde: "˜",
  times: "×",
  timesb: "⊠",
  timesbar: "⨱",
  timesd: "⨰",
  tint: "∭",
  toea: "⤨",
  top: "⊤",
  topbot: "⌶",
  topcir: "⫱",
  topf: "𝕥",
  topfork: "⫚",
  tosa: "⤩",
  tprime: "‴",
  trade: "™",
  triangle: "▵",
  triangledown: "▿",
  triangleleft: "◃",
  trianglelefteq: "⊴",
  triangleq: "≜",
  triangleright: "▹",
  trianglerighteq: "⊵",
  tridot: "◬",
  trie: "≜",
  triminus: "⨺",
  triplus: "⨹",
  trisb: "⧍",
  tritime: "⨻",
  trpezium: "⏢",
  tscr: "𝓉",
  tscy: "ц",
  tshcy: "ћ",
  tstrok: "ŧ",
  twixt: "≬",
  twoheadleftarrow: "↞",
  twoheadrightarrow: "↠",
  uArr: "⇑",
  uHar: "⥣",
  uacute: "ú",
  uarr: "↑",
  ubrcy: "ў",
  ubreve: "ŭ",
  ucirc: "û",
  ucy: "у",
  udarr: "⇅",
  udblac: "ű",
  udhar: "⥮",
  ufisht: "⥾",
  ufr: "𝔲",
  ugrave: "ù",
  uharl: "↿",
  uharr: "↾",
  uhblk: "▀",
  ulcorn: "⌜",
  ulcorner: "⌜",
  ulcrop: "⌏",
  ultri: "◸",
  umacr: "ū",
  uml: "¨",
  uogon: "ų",
  uopf: "𝕦",
  uparrow: "↑",
  updownarrow: "↕",
  upharpoonleft: "↿",
  upharpoonright: "↾",
  uplus: "⊎",
  upsi: "υ",
  upsih: "ϒ",
  upsilon: "υ",
  upuparrows: "⇈",
  urcorn: "⌝",
  urcorner: "⌝",
  urcrop: "⌎",
  uring: "ů",
  urtri: "◹",
  uscr: "𝓊",
  utdot: "⋰",
  utilde: "ũ",
  utri: "▵",
  utrif: "▴",
  uuarr: "⇈",
  uuml: "ü",
  uwangle: "⦧",
  vArr: "⇕",
  vBar: "⫨",
  vBarv: "⫩",
  vDash: "⊨",
  vangrt: "⦜",
  varepsilon: "ϵ",
  varkappa: "ϰ",
  varnothing: "∅",
  varphi: "ϕ",
  varpi: "ϖ",
  varpropto: "∝",
  varr: "↕",
  varrho: "ϱ",
  varsigma: "ς",
  varsubsetneq: "⊊︀",
  varsubsetneqq: "⫋︀",
  varsupsetneq: "⊋︀",
  varsupsetneqq: "⫌︀",
  vartheta: "ϑ",
  vartriangleleft: "⊲",
  vartriangleright: "⊳",
  vcy: "в",
  vdash: "⊢",
  vee: "∨",
  veebar: "⊻",
  veeeq: "≚",
  vellip: "⋮",
  verbar: "|",
  vert: "|",
  vfr: "𝔳",
  vltri: "⊲",
  vnsub: "⊂⃒",
  vnsup: "⊃⃒",
  vopf: "𝕧",
  vprop: "∝",
  vrtri: "⊳",
  vscr: "𝓋",
  vsubnE: "⫋︀",
  vsubne: "⊊︀",
  vsupnE: "⫌︀",
  vsupne: "⊋︀",
  vzigzag: "⦚",
  wcirc: "ŵ",
  wedbar: "⩟",
  wedge: "∧",
  wedgeq: "≙",
  weierp: "℘",
  wfr: "𝔴",
  wopf: "𝕨",
  wp: "℘",
  wr: "≀",
  wreath: "≀",
  wscr: "𝓌",
  xcap: "⋂",
  xcirc: "◯",
  xcup: "⋃",
  xdtri: "▽",
  xfr: "𝔵",
  xhArr: "⟺",
  xharr: "⟷",
  xi: "ξ",
  xlArr: "⟸",
  xlarr: "⟵",
  xmap: "⟼",
  xnis: "⋻",
  xodot: "⨀",
  xopf: "𝕩",
  xoplus: "⨁",
  xotime: "⨂",
  xrArr: "⟹",
  xrarr: "⟶",
  xscr: "𝓍",
  xsqcup: "⨆",
  xuplus: "⨄",
  xutri: "△",
  xvee: "⋁",
  xwedge: "⋀",
  yacute: "ý",
  yacy: "я",
  ycirc: "ŷ",
  ycy: "ы",
  yen: "¥",
  yfr: "𝔶",
  yicy: "ї",
  yopf: "𝕪",
  yscr: "𝓎",
  yucy: "ю",
  yuml: "ÿ",
  zacute: "ź",
  zcaron: "ž",
  zcy: "з",
  zdot: "ż",
  zeetrf: "ℨ",
  zeta: "ζ",
  zfr: "𝔷",
  zhcy: "ж",
  zigrarr: "⇝",
  zopf: "𝕫",
  zscr: "𝓏",
  zwj: "‍",
  zwnj: "‌"
}, Vn = {}.hasOwnProperty;
function ve(e) {
  return Vn.call(Dt, e) ? Dt[e] : !1;
}
function ae(e, t, n, r) {
  const a = e.length;
  let i = 0, o;
  if (t < 0 ? t = -t > a ? 0 : a + t : t = t > a ? a : t, n = n > 0 ? n : 0, r.length < 1e4)
    o = Array.from(r), o.unshift(t, n), e.splice(...o);
  else
    for (n && e.splice(t, n); i < r.length; )
      o = r.slice(i, i + 1e4), o.unshift(t, 0), e.splice(...o), i += 1e4, t += 1e4;
}
function oe(e, t) {
  return e.length > 0 ? (ae(e, e.length, 0, t), e) : t;
}
const Ot = {}.hasOwnProperty;
function Un(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    Hn(t, e[n]);
  return t;
}
function Hn(e, t) {
  let n;
  for (n in t) {
    const a = (Ot.call(e, n) ? e[n] : void 0) || (e[n] = {}), i = t[n];
    let o;
    if (i)
      for (o in i) {
        Ot.call(a, o) || (a[o] = []);
        const s = i[o];
        Gn(
          // @ts-expect-error Looks like a list.
          a[o],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function Gn(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  ae(e, 0, 0, r);
}
function pn(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || /* eslint-disable no-bitwise */
    (n & 65535) === 65535 || (n & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    n > 1114111 ? "�" : String.fromCodePoint(n)
  );
}
function qe(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const he = Se(/[A-Za-z]/), ce = Se(/[\dA-Za-z]/), jn = Se(/[#-'*+\--9=?A-Z^-~]/);
function xt(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const bt = Se(/\d/), $n = Se(/[\dA-Fa-f]/), Wn = Se(/[!-/:-@[-`{-~]/);
function _(e) {
  return e !== null && e < -2;
}
function W(e) {
  return e !== null && (e < 0 || e === 32);
}
function v(e) {
  return e === -2 || e === -1 || e === 32;
}
const Qn = Se(new RegExp("\\p{P}|\\p{S}", "u")), be = Se(/\s/);
function Se(e) {
  return t;
  function t(n) {
    return n !== null && n > -1 && e.test(String.fromCharCode(n));
  }
}
function H(e, t, n, r) {
  const a = r ? r - 1 : Number.POSITIVE_INFINITY;
  let i = 0;
  return o;
  function o(c) {
    return v(c) ? (e.enter(n), s(c)) : t(c);
  }
  function s(c) {
    return v(c) && i++ < a ? (e.consume(c), s) : (e.exit(n), t(c));
  }
}
const Yn = {
  tokenize: Kn
};
function Kn(e) {
  const t = e.attempt(this.parser.constructs.contentInitial, r, a);
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), H(e, t, "linePrefix");
  }
  function a(s) {
    return e.enter("paragraph"), i(s);
  }
  function i(s) {
    const c = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = c), n = c, o(s);
  }
  function o(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return _(s) ? (e.consume(s), e.exit("chunkText"), i) : (e.consume(s), o);
  }
}
const Zn = {
  tokenize: Xn
}, _t = {
  tokenize: er
};
function Xn(e) {
  const t = this, n = [];
  let r = 0, a, i, o;
  return s;
  function s(y) {
    if (r < n.length) {
      const E = n[r];
      return t.containerState = E[1], e.attempt(E[0].continuation, c, l)(y);
    }
    return l(y);
  }
  function c(y) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, a && D();
      const E = t.events.length;
      let I = E, w;
      for (; I--; )
        if (t.events[I][0] === "exit" && t.events[I][1].type === "chunkFlow") {
          w = t.events[I][1].end;
          break;
        }
      x(r);
      let k = E;
      for (; k < t.events.length; )
        t.events[k][1].end = {
          ...w
        }, k++;
      return ae(t.events, I + 1, 0, t.events.slice(E)), t.events.length = k, l(y);
    }
    return s(y);
  }
  function l(y) {
    if (r === n.length) {
      if (!a)
        return m(y);
      if (a.currentConstruct && a.currentConstruct.concrete)
        return T(y);
      t.interrupt = !!(a.currentConstruct && !a._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(_t, g, f)(y);
  }
  function g(y) {
    return a && D(), x(r), m(y);
  }
  function f(y) {
    return t.parser.lazy[t.now().line] = r !== n.length, o = t.now().offset, T(y);
  }
  function m(y) {
    return t.containerState = {}, e.attempt(_t, p, T)(y);
  }
  function p(y) {
    return r++, n.push([t.currentConstruct, t.containerState]), m(y);
  }
  function T(y) {
    if (y === null) {
      a && D(), x(0), e.consume(y);
      return;
    }
    return a = a || t.parser.flow(t.now()), e.enter("chunkFlow", {
      _tokenizer: a,
      contentType: "flow",
      previous: i
    }), C(y);
  }
  function C(y) {
    if (y === null) {
      q(e.exit("chunkFlow"), !0), x(0), e.consume(y);
      return;
    }
    return _(y) ? (e.consume(y), q(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(y), C);
  }
  function q(y, E) {
    const I = t.sliceStream(y);
    if (E && I.push(null), y.previous = i, i && (i.next = y), i = y, a.defineSkip(y.start), a.write(I), t.parser.lazy[y.start.line]) {
      let w = a.events.length;
      for (; w--; )
        if (
          // The token starts before the line ending…
          a.events[w][1].start.offset < o && // …and either is not ended yet…
          (!a.events[w][1].end || // …or ends after it.
          a.events[w][1].end.offset > o)
        )
          return;
      const k = t.events.length;
      let A = k, L, z;
      for (; A--; )
        if (t.events[A][0] === "exit" && t.events[A][1].type === "chunkFlow") {
          if (L) {
            z = t.events[A][1].end;
            break;
          }
          L = !0;
        }
      for (x(r), w = k; w < t.events.length; )
        t.events[w][1].end = {
          ...z
        }, w++;
      ae(t.events, A + 1, 0, t.events.slice(k)), t.events.length = w;
    }
  }
  function x(y) {
    let E = n.length;
    for (; E-- > y; ) {
      const I = n[E];
      t.containerState = I[1], I[0].exit.call(t, e);
    }
    n.length = y;
  }
  function D() {
    a.write([null]), i = void 0, a = void 0, t.containerState._closeFlow = void 0;
  }
}
function er(e, t, n) {
  return H(e, e.attempt(this.parser.constructs.document, t, n), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function nt(e) {
  if (e === null || W(e) || be(e))
    return 1;
  if (Qn(e))
    return 2;
}
function it(e, t, n) {
  const r = [];
  let a = -1;
  for (; ++a < e.length; ) {
    const i = e[a].resolveAll;
    i && !r.includes(i) && (t = i(t, n), r.push(i));
  }
  return t;
}
const yt = {
  name: "attention",
  resolveAll: tr,
  tokenize: nr
};
function tr(e, t) {
  let n = -1, r, a, i, o, s, c, l, g;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          c = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = {
            ...e[r][1].end
          }, m = {
            ...e[n][1].start
          };
          zt(f, -c), zt(m, c), o = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: {
              ...e[r][1].end
            }
          }, s = {
            type: c > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...e[n][1].start
            },
            end: m
          }, i = {
            type: c > 1 ? "strongText" : "emphasisText",
            start: {
              ...e[r][1].end
            },
            end: {
              ...e[n][1].start
            }
          }, a = {
            type: c > 1 ? "strong" : "emphasis",
            start: {
              ...o.start
            },
            end: {
              ...s.end
            }
          }, e[r][1].end = {
            ...o.start
          }, e[n][1].start = {
            ...s.end
          }, l = [], e[r][1].end.offset - e[r][1].start.offset && (l = oe(l, [["enter", e[r][1], t], ["exit", e[r][1], t]])), l = oe(l, [["enter", a, t], ["enter", o, t], ["exit", o, t], ["enter", i, t]]), l = oe(l, it(t.parser.constructs.insideSpan.null, e.slice(r + 1, n), t)), l = oe(l, [["exit", i, t], ["enter", s, t], ["exit", s, t], ["exit", a, t]]), e[n][1].end.offset - e[n][1].start.offset ? (g = 2, l = oe(l, [["enter", e[n][1], t], ["exit", e[n][1], t]])) : g = 0, ae(e, r - 1, n - r + 3, l), n = r + l.length - g - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function nr(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, a = nt(r);
  let i;
  return o;
  function o(c) {
    return i = c, e.enter("attentionSequence"), s(c);
  }
  function s(c) {
    if (c === i)
      return e.consume(c), s;
    const l = e.exit("attentionSequence"), g = nt(c), f = !g || g === 2 && a || n.includes(c), m = !a || a === 2 && g || n.includes(r);
    return l._open = !!(i === 42 ? f : f && (a || !m)), l._close = !!(i === 42 ? m : m && (g || !f)), t(c);
  }
}
function zt(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const rr = {
  name: "autolink",
  tokenize: ir
};
function ir(e, t, n) {
  let r = 0;
  return a;
  function a(p) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), i;
  }
  function i(p) {
    return he(p) ? (e.consume(p), o) : p === 64 ? n(p) : l(p);
  }
  function o(p) {
    return p === 43 || p === 45 || p === 46 || ce(p) ? (r = 1, s(p)) : l(p);
  }
  function s(p) {
    return p === 58 ? (e.consume(p), r = 0, c) : (p === 43 || p === 45 || p === 46 || ce(p)) && r++ < 32 ? (e.consume(p), s) : (r = 0, l(p));
  }
  function c(p) {
    return p === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : p === null || p === 32 || p === 60 || xt(p) ? n(p) : (e.consume(p), c);
  }
  function l(p) {
    return p === 64 ? (e.consume(p), g) : jn(p) ? (e.consume(p), l) : n(p);
  }
  function g(p) {
    return ce(p) ? f(p) : n(p);
  }
  function f(p) {
    return p === 46 ? (e.consume(p), r = 0, g) : p === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(p), e.exit("autolinkMarker"), e.exit("autolink"), t) : m(p);
  }
  function m(p) {
    if ((p === 45 || ce(p)) && r++ < 63) {
      const T = p === 45 ? m : f;
      return e.consume(p), T;
    }
    return n(p);
  }
}
const at = {
  partial: !0,
  tokenize: ar
};
function ar(e, t, n) {
  return r;
  function r(i) {
    return v(i) ? H(e, a, "linePrefix")(i) : a(i);
  }
  function a(i) {
    return i === null || _(i) ? t(i) : n(i);
  }
}
const fn = {
  continuation: {
    tokenize: sr
  },
  exit: ur,
  name: "blockQuote",
  tokenize: or
};
function or(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    if (o === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(o), e.exit("blockQuoteMarker"), i;
    }
    return n(o);
  }
  function i(o) {
    return v(o) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(o), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(o));
  }
}
function sr(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return v(o) ? H(e, i, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(o) : i(o);
  }
  function i(o) {
    return e.attempt(fn, t, n)(o);
  }
}
function ur(e) {
  e.exit("blockQuote");
}
const hn = {
  name: "characterEscape",
  tokenize: lr
};
function lr(e, t, n) {
  return r;
  function r(i) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(i), e.exit("escapeMarker"), a;
  }
  function a(i) {
    return Wn(i) ? (e.enter("characterEscapeValue"), e.consume(i), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(i);
  }
}
const dn = {
  name: "characterReference",
  tokenize: cr
};
function cr(e, t, n) {
  const r = this;
  let a = 0, i, o;
  return s;
  function s(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), c;
  }
  function c(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), l) : (e.enter("characterReferenceValue"), i = 31, o = ce, g(f));
  }
  function l(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), i = 6, o = $n, g) : (e.enter("characterReferenceValue"), i = 7, o = bt, g(f));
  }
  function g(f) {
    if (f === 59 && a) {
      const m = e.exit("characterReferenceValue");
      return o === ce && !ve(r.sliceSerialize(m)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return o(f) && a++ < i ? (e.consume(f), g) : n(f);
  }
}
const Ft = {
  partial: !0,
  tokenize: fr
}, Mt = {
  concrete: !0,
  name: "codeFenced",
  tokenize: pr
};
function pr(e, t, n) {
  const r = this, a = {
    partial: !0,
    tokenize: I
  };
  let i = 0, o = 0, s;
  return c;
  function c(w) {
    return l(w);
  }
  function l(w) {
    const k = r.events[r.events.length - 1];
    return i = k && k[1].type === "linePrefix" ? k[2].sliceSerialize(k[1], !0).length : 0, s = w, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), g(w);
  }
  function g(w) {
    return w === s ? (o++, e.consume(w), g) : o < 3 ? n(w) : (e.exit("codeFencedFenceSequence"), v(w) ? H(e, f, "whitespace")(w) : f(w));
  }
  function f(w) {
    return w === null || _(w) ? (e.exit("codeFencedFence"), r.interrupt ? t(w) : e.check(Ft, C, E)(w)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), m(w));
  }
  function m(w) {
    return w === null || _(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(w)) : v(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), H(e, p, "whitespace")(w)) : w === 96 && w === s ? n(w) : (e.consume(w), m);
  }
  function p(w) {
    return w === null || _(w) ? f(w) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), T(w));
  }
  function T(w) {
    return w === null || _(w) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(w)) : w === 96 && w === s ? n(w) : (e.consume(w), T);
  }
  function C(w) {
    return e.attempt(a, E, q)(w);
  }
  function q(w) {
    return e.enter("lineEnding"), e.consume(w), e.exit("lineEnding"), x;
  }
  function x(w) {
    return i > 0 && v(w) ? H(e, D, "linePrefix", i + 1)(w) : D(w);
  }
  function D(w) {
    return w === null || _(w) ? e.check(Ft, C, E)(w) : (e.enter("codeFlowValue"), y(w));
  }
  function y(w) {
    return w === null || _(w) ? (e.exit("codeFlowValue"), D(w)) : (e.consume(w), y);
  }
  function E(w) {
    return e.exit("codeFenced"), t(w);
  }
  function I(w, k, A) {
    let L = 0;
    return z;
    function z(B) {
      return w.enter("lineEnding"), w.consume(B), w.exit("lineEnding"), N;
    }
    function N(B) {
      return w.enter("codeFencedFence"), v(B) ? H(w, R, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(B) : R(B);
    }
    function R(B) {
      return B === s ? (w.enter("codeFencedFenceSequence"), O(B)) : A(B);
    }
    function O(B) {
      return B === s ? (L++, w.consume(B), O) : L >= o ? (w.exit("codeFencedFenceSequence"), v(B) ? H(w, V, "whitespace")(B) : V(B)) : A(B);
    }
    function V(B) {
      return B === null || _(B) ? (w.exit("codeFencedFence"), k(B)) : A(B);
    }
  }
}
function fr(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return o === null ? n(o) : (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i);
  }
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
const ct = {
  name: "codeIndented",
  tokenize: dr
}, hr = {
  partial: !0,
  tokenize: gr
};
function dr(e, t, n) {
  const r = this;
  return a;
  function a(l) {
    return e.enter("codeIndented"), H(e, i, "linePrefix", 5)(l);
  }
  function i(l) {
    const g = r.events[r.events.length - 1];
    return g && g[1].type === "linePrefix" && g[2].sliceSerialize(g[1], !0).length >= 4 ? o(l) : n(l);
  }
  function o(l) {
    return l === null ? c(l) : _(l) ? e.attempt(hr, o, c)(l) : (e.enter("codeFlowValue"), s(l));
  }
  function s(l) {
    return l === null || _(l) ? (e.exit("codeFlowValue"), o(l)) : (e.consume(l), s);
  }
  function c(l) {
    return e.exit("codeIndented"), t(l);
  }
}
function gr(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return r.parser.lazy[r.now().line] ? n(o) : _(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), a) : H(e, i, "linePrefix", 5)(o);
  }
  function i(o) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : _(o) ? a(o) : n(o);
  }
}
const mr = {
  name: "codeText",
  previous: br,
  resolve: xr,
  tokenize: yr
};
function xr(e) {
  let t = e.length - 4, n = 3, r, a;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    a === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (a = r) : (r === t || e[r][1].type === "lineEnding") && (e[a][1].type = "codeTextData", r !== a + 2 && (e[a][1].end = e[r - 1][1].end, e.splice(a + 2, r - a - 2), t -= r - a - 2, r = a + 2), a = void 0);
  return e;
}
function br(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function yr(e, t, n) {
  let r = 0, a, i;
  return o;
  function o(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(f);
  }
  function s(f) {
    return f === 96 ? (e.consume(f), r++, s) : (e.exit("codeTextSequence"), c(f));
  }
  function c(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), c) : f === 96 ? (i = e.enter("codeTextSequence"), a = 0, g(f)) : _(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), c) : (e.enter("codeTextData"), l(f));
  }
  function l(f) {
    return f === null || f === 32 || f === 96 || _(f) ? (e.exit("codeTextData"), c(f)) : (e.consume(f), l);
  }
  function g(f) {
    return f === 96 ? (e.consume(f), a++, g) : a === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (i.type = "codeTextData", l(f));
  }
}
class wr {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(t) {
    this.left = t ? [...t] : [], this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(t) {
    if (t < 0 || t >= this.left.length + this.right.length)
      throw new RangeError("Cannot access index `" + t + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    return t < this.left.length ? this.left[t] : this.right[this.right.length - t + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    return this.setCursor(0), this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(t, n) {
    const r = n ?? Number.POSITIVE_INFINITY;
    return r < this.left.length ? this.left.slice(t, r) : t > this.left.length ? this.right.slice(this.right.length - r + this.left.length, this.right.length - t + this.left.length).reverse() : this.left.slice(t).concat(this.right.slice(this.right.length - r + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(t, n, r) {
    const a = n || 0;
    this.setCursor(Math.trunc(t));
    const i = this.right.splice(this.right.length - a, Number.POSITIVE_INFINITY);
    return r && Me(this.left, r), i.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    return this.setCursor(Number.POSITIVE_INFINITY), this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(t) {
    this.setCursor(Number.POSITIVE_INFINITY), this.left.push(t);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(t) {
    this.setCursor(Number.POSITIVE_INFINITY), Me(this.left, t);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(t) {
    this.setCursor(0), this.right.push(t);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(t) {
    this.setCursor(0), Me(this.right, t.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(t) {
    if (!(t === this.left.length || t > this.left.length && this.right.length === 0 || t < 0 && this.left.length === 0))
      if (t < this.left.length) {
        const n = this.left.splice(t, Number.POSITIVE_INFINITY);
        Me(this.right, n.reverse());
      } else {
        const n = this.right.splice(this.left.length + this.right.length - t, Number.POSITIVE_INFINITY);
        Me(this.left, n.reverse());
      }
  }
}
function Me(e, t) {
  let n = 0;
  if (t.length < 1e4)
    e.push(...t);
  else
    for (; n < t.length; )
      e.push(...t.slice(n, n + 1e4)), n += 1e4;
}
function gn(e) {
  const t = {};
  let n = -1, r, a, i, o, s, c, l;
  const g = new wr(e);
  for (; ++n < g.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = g.get(n), n && r[1].type === "chunkFlow" && g.get(n - 1)[1].type === "listItemPrefix" && (c = r[1]._tokenizer.events, i = 0, i < c.length && c[i][1].type === "lineEndingBlank" && (i += 2), i < c.length && c[i][1].type === "content"))
      for (; ++i < c.length && c[i][1].type !== "content"; )
        c[i][1].type === "chunkText" && (c[i][1]._isInFirstContentOfListItem = !0, i++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, kr(g, n)), n = t[n], l = !0);
    else if (r[1]._container) {
      for (i = n, a = void 0; i-- && (o = g.get(i), o[1].type === "lineEnding" || o[1].type === "lineEndingBlank"); )
        o[0] === "enter" && (a && (g.get(a)[1].type = "lineEndingBlank"), o[1].type = "lineEnding", a = i);
      a && (r[1].end = {
        ...g.get(a)[1].start
      }, s = g.slice(a, n), s.unshift(r), g.splice(a, n - a + 1, s));
    }
  }
  return ae(e, 0, Number.POSITIVE_INFINITY, g.slice(0)), !l;
}
function kr(e, t) {
  const n = e.get(t)[1], r = e.get(t)[2];
  let a = t - 1;
  const i = [], o = n._tokenizer || r.parser[n.contentType](n.start), s = o.events, c = [], l = {};
  let g, f, m = -1, p = n, T = 0, C = 0;
  const q = [C];
  for (; p; ) {
    for (; e.get(++a)[1] !== p; )
      ;
    i.push(a), p._tokenizer || (g = r.sliceStream(p), p.next || g.push(null), f && o.defineSkip(p.start), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = !0), o.write(g), p._isInFirstContentOfListItem && (o._gfmTasklistFirstContentOfListItem = void 0)), f = p, p = p.next;
  }
  for (p = n; ++m < s.length; )
    // Find a void token that includes a break.
    s[m][0] === "exit" && s[m - 1][0] === "enter" && s[m][1].type === s[m - 1][1].type && s[m][1].start.line !== s[m][1].end.line && (C = m + 1, q.push(C), p._tokenizer = void 0, p.previous = void 0, p = p.next);
  for (o.events = [], p ? (p._tokenizer = void 0, p.previous = void 0) : q.pop(), m = q.length; m--; ) {
    const x = s.slice(q[m], q[m + 1]), D = i.pop();
    c.push([D, D + x.length - 1]), e.splice(D, 2, x);
  }
  for (c.reverse(), m = -1; ++m < c.length; )
    l[T + c[m][0]] = T + c[m][1], T += c[m][1] - c[m][0] - 1;
  return l;
}
const Er = {
  resolve: Tr,
  tokenize: Ar
}, Sr = {
  partial: !0,
  tokenize: Cr
};
function Tr(e) {
  return gn(e), e;
}
function Ar(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), a(s);
  }
  function a(s) {
    return s === null ? i(s) : _(s) ? e.check(Sr, o, i)(s) : (e.consume(s), a);
  }
  function i(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function o(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, a;
  }
}
function Cr(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), H(e, i, "linePrefix");
  }
  function i(o) {
    if (o === null || _(o))
      return n(o);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(o) : e.interrupt(r.parser.constructs.flow, n, t)(o);
  }
}
function mn(e, t, n, r, a, i, o, s, c) {
  const l = c || Number.POSITIVE_INFINITY;
  let g = 0;
  return f;
  function f(x) {
    return x === 60 ? (e.enter(r), e.enter(a), e.enter(i), e.consume(x), e.exit(i), m) : x === null || x === 32 || x === 41 || xt(x) ? n(x) : (e.enter(r), e.enter(o), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), C(x));
  }
  function m(x) {
    return x === 62 ? (e.enter(i), e.consume(x), e.exit(i), e.exit(a), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), p(x));
  }
  function p(x) {
    return x === 62 ? (e.exit("chunkString"), e.exit(s), m(x)) : x === null || x === 60 || _(x) ? n(x) : (e.consume(x), x === 92 ? T : p);
  }
  function T(x) {
    return x === 60 || x === 62 || x === 92 ? (e.consume(x), p) : p(x);
  }
  function C(x) {
    return !g && (x === null || x === 41 || W(x)) ? (e.exit("chunkString"), e.exit(s), e.exit(o), e.exit(r), t(x)) : g < l && x === 40 ? (e.consume(x), g++, C) : x === 41 ? (e.consume(x), g--, C) : x === null || x === 32 || x === 40 || xt(x) ? n(x) : (e.consume(x), x === 92 ? q : C);
  }
  function q(x) {
    return x === 40 || x === 41 || x === 92 ? (e.consume(x), C) : C(x);
  }
}
function xn(e, t, n, r, a, i) {
  const o = this;
  let s = 0, c;
  return l;
  function l(p) {
    return e.enter(r), e.enter(a), e.consume(p), e.exit(a), e.enter(i), g;
  }
  function g(p) {
    return s > 999 || p === null || p === 91 || p === 93 && !c || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    p === 94 && !s && "_hiddenFootnoteSupport" in o.parser.constructs ? n(p) : p === 93 ? (e.exit(i), e.enter(a), e.consume(p), e.exit(a), e.exit(r), t) : _(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), g) : (e.enter("chunkString", {
      contentType: "string"
    }), f(p));
  }
  function f(p) {
    return p === null || p === 91 || p === 93 || _(p) || s++ > 999 ? (e.exit("chunkString"), g(p)) : (e.consume(p), c || (c = !v(p)), p === 92 ? m : f);
  }
  function m(p) {
    return p === 91 || p === 92 || p === 93 ? (e.consume(p), s++, f) : f(p);
  }
}
function bn(e, t, n, r, a, i) {
  let o;
  return s;
  function s(m) {
    return m === 34 || m === 39 || m === 40 ? (e.enter(r), e.enter(a), e.consume(m), e.exit(a), o = m === 40 ? 41 : m, c) : n(m);
  }
  function c(m) {
    return m === o ? (e.enter(a), e.consume(m), e.exit(a), e.exit(r), t) : (e.enter(i), l(m));
  }
  function l(m) {
    return m === o ? (e.exit(i), c(o)) : m === null ? n(m) : _(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), H(e, l, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), g(m));
  }
  function g(m) {
    return m === o || m === null || _(m) ? (e.exit("chunkString"), l(m)) : (e.consume(m), m === 92 ? f : g);
  }
  function f(m) {
    return m === o || m === 92 ? (e.consume(m), g) : g(m);
  }
}
function Pe(e, t) {
  let n;
  return r;
  function r(a) {
    return _(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), n = !0, r) : v(a) ? H(e, r, n ? "linePrefix" : "lineSuffix")(a) : t(a);
  }
}
const Ir = {
  name: "definition",
  tokenize: Nr
}, Lr = {
  partial: !0,
  tokenize: Rr
};
function Nr(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(p) {
    return e.enter("definition"), o(p);
  }
  function o(p) {
    return xn.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(p);
  }
  function s(p) {
    return a = qe(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)), p === 58 ? (e.enter("definitionMarker"), e.consume(p), e.exit("definitionMarker"), c) : n(p);
  }
  function c(p) {
    return W(p) ? Pe(e, l)(p) : l(p);
  }
  function l(p) {
    return mn(
      e,
      g,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(p);
  }
  function g(p) {
    return e.attempt(Lr, f, f)(p);
  }
  function f(p) {
    return v(p) ? H(e, m, "whitespace")(p) : m(p);
  }
  function m(p) {
    return p === null || _(p) ? (e.exit("definition"), r.parser.defined.push(a), t(p)) : n(p);
  }
}
function Rr(e, t, n) {
  return r;
  function r(s) {
    return W(s) ? Pe(e, a)(s) : n(s);
  }
  function a(s) {
    return bn(e, i, n, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(s);
  }
  function i(s) {
    return v(s) ? H(e, o, "whitespace")(s) : o(s);
  }
  function o(s) {
    return s === null || _(s) ? t(s) : n(s);
  }
}
const qr = {
  name: "hardBreakEscape",
  tokenize: Dr
};
function Dr(e, t, n) {
  return r;
  function r(i) {
    return e.enter("hardBreakEscape"), e.consume(i), a;
  }
  function a(i) {
    return _(i) ? (e.exit("hardBreakEscape"), t(i)) : n(i);
  }
}
const Or = {
  name: "headingAtx",
  resolve: _r,
  tokenize: zr
};
function _r(e, t) {
  let n = e.length - 2, r = 3, a, i;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (a = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, i = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, ae(e, r, n - r + 1, [["enter", a, t], ["enter", i, t], ["exit", i, t], ["exit", a, t]])), e;
}
function zr(e, t, n) {
  let r = 0;
  return a;
  function a(g) {
    return e.enter("atxHeading"), i(g);
  }
  function i(g) {
    return e.enter("atxHeadingSequence"), o(g);
  }
  function o(g) {
    return g === 35 && r++ < 6 ? (e.consume(g), o) : g === null || W(g) ? (e.exit("atxHeadingSequence"), s(g)) : n(g);
  }
  function s(g) {
    return g === 35 ? (e.enter("atxHeadingSequence"), c(g)) : g === null || _(g) ? (e.exit("atxHeading"), t(g)) : v(g) ? H(e, s, "whitespace")(g) : (e.enter("atxHeadingText"), l(g));
  }
  function c(g) {
    return g === 35 ? (e.consume(g), c) : (e.exit("atxHeadingSequence"), s(g));
  }
  function l(g) {
    return g === null || g === 35 || W(g) ? (e.exit("atxHeadingText"), s(g)) : (e.consume(g), l);
  }
}
const Fr = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], Bt = ["pre", "script", "style", "textarea"], Mr = {
  concrete: !0,
  name: "htmlFlow",
  resolveTo: vr,
  tokenize: Jr
}, Br = {
  partial: !0,
  tokenize: Ur
}, Pr = {
  partial: !0,
  tokenize: Vr
};
function vr(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function Jr(e, t, n) {
  const r = this;
  let a, i, o, s, c;
  return l;
  function l(d) {
    return g(d);
  }
  function g(d) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(d), f;
  }
  function f(d) {
    return d === 33 ? (e.consume(d), m) : d === 47 ? (e.consume(d), i = !0, C) : d === 63 ? (e.consume(d), a = 3, r.interrupt ? t : h) : he(d) ? (e.consume(d), o = String.fromCharCode(d), q) : n(d);
  }
  function m(d) {
    return d === 45 ? (e.consume(d), a = 2, p) : d === 91 ? (e.consume(d), a = 5, s = 0, T) : he(d) ? (e.consume(d), a = 4, r.interrupt ? t : h) : n(d);
  }
  function p(d) {
    return d === 45 ? (e.consume(d), r.interrupt ? t : h) : n(d);
  }
  function T(d) {
    const ne = "CDATA[";
    return d === ne.charCodeAt(s++) ? (e.consume(d), s === ne.length ? r.interrupt ? t : R : T) : n(d);
  }
  function C(d) {
    return he(d) ? (e.consume(d), o = String.fromCharCode(d), q) : n(d);
  }
  function q(d) {
    if (d === null || d === 47 || d === 62 || W(d)) {
      const ne = d === 47, pe = o.toLowerCase();
      return !ne && !i && Bt.includes(pe) ? (a = 1, r.interrupt ? t(d) : R(d)) : Fr.includes(o.toLowerCase()) ? (a = 6, ne ? (e.consume(d), x) : r.interrupt ? t(d) : R(d)) : (a = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(d) : i ? D(d) : y(d));
    }
    return d === 45 || ce(d) ? (e.consume(d), o += String.fromCharCode(d), q) : n(d);
  }
  function x(d) {
    return d === 62 ? (e.consume(d), r.interrupt ? t : R) : n(d);
  }
  function D(d) {
    return v(d) ? (e.consume(d), D) : z(d);
  }
  function y(d) {
    return d === 47 ? (e.consume(d), z) : d === 58 || d === 95 || he(d) ? (e.consume(d), E) : v(d) ? (e.consume(d), y) : z(d);
  }
  function E(d) {
    return d === 45 || d === 46 || d === 58 || d === 95 || ce(d) ? (e.consume(d), E) : I(d);
  }
  function I(d) {
    return d === 61 ? (e.consume(d), w) : v(d) ? (e.consume(d), I) : y(d);
  }
  function w(d) {
    return d === null || d === 60 || d === 61 || d === 62 || d === 96 ? n(d) : d === 34 || d === 39 ? (e.consume(d), c = d, k) : v(d) ? (e.consume(d), w) : A(d);
  }
  function k(d) {
    return d === c ? (e.consume(d), c = null, L) : d === null || _(d) ? n(d) : (e.consume(d), k);
  }
  function A(d) {
    return d === null || d === 34 || d === 39 || d === 47 || d === 60 || d === 61 || d === 62 || d === 96 || W(d) ? I(d) : (e.consume(d), A);
  }
  function L(d) {
    return d === 47 || d === 62 || v(d) ? y(d) : n(d);
  }
  function z(d) {
    return d === 62 ? (e.consume(d), N) : n(d);
  }
  function N(d) {
    return d === null || _(d) ? R(d) : v(d) ? (e.consume(d), N) : n(d);
  }
  function R(d) {
    return d === 45 && a === 2 ? (e.consume(d), j) : d === 60 && a === 1 ? (e.consume(d), M) : d === 62 && a === 4 ? (e.consume(d), te) : d === 63 && a === 3 ? (e.consume(d), h) : d === 93 && a === 5 ? (e.consume(d), se) : _(d) && (a === 6 || a === 7) ? (e.exit("htmlFlowData"), e.check(Br, ue, O)(d)) : d === null || _(d) ? (e.exit("htmlFlowData"), O(d)) : (e.consume(d), R);
  }
  function O(d) {
    return e.check(Pr, V, ue)(d);
  }
  function V(d) {
    return e.enter("lineEnding"), e.consume(d), e.exit("lineEnding"), B;
  }
  function B(d) {
    return d === null || _(d) ? O(d) : (e.enter("htmlFlowData"), R(d));
  }
  function j(d) {
    return d === 45 ? (e.consume(d), h) : R(d);
  }
  function M(d) {
    return d === 47 ? (e.consume(d), o = "", K) : R(d);
  }
  function K(d) {
    if (d === 62) {
      const ne = o.toLowerCase();
      return Bt.includes(ne) ? (e.consume(d), te) : R(d);
    }
    return he(d) && o.length < 8 ? (e.consume(d), o += String.fromCharCode(d), K) : R(d);
  }
  function se(d) {
    return d === 93 ? (e.consume(d), h) : R(d);
  }
  function h(d) {
    return d === 62 ? (e.consume(d), te) : d === 45 && a === 2 ? (e.consume(d), h) : R(d);
  }
  function te(d) {
    return d === null || _(d) ? (e.exit("htmlFlowData"), ue(d)) : (e.consume(d), te);
  }
  function ue(d) {
    return e.exit("htmlFlow"), t(d);
  }
}
function Vr(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return _(o) ? (e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), i) : n(o);
  }
  function i(o) {
    return r.parser.lazy[r.now().line] ? n(o) : t(o);
  }
}
function Ur(e, t, n) {
  return r;
  function r(a) {
    return e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), e.attempt(at, t, n);
  }
}
const Hr = {
  name: "htmlText",
  tokenize: Gr
};
function Gr(e, t, n) {
  const r = this;
  let a, i, o;
  return s;
  function s(h) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(h), c;
  }
  function c(h) {
    return h === 33 ? (e.consume(h), l) : h === 47 ? (e.consume(h), I) : h === 63 ? (e.consume(h), y) : he(h) ? (e.consume(h), A) : n(h);
  }
  function l(h) {
    return h === 45 ? (e.consume(h), g) : h === 91 ? (e.consume(h), i = 0, T) : he(h) ? (e.consume(h), D) : n(h);
  }
  function g(h) {
    return h === 45 ? (e.consume(h), p) : n(h);
  }
  function f(h) {
    return h === null ? n(h) : h === 45 ? (e.consume(h), m) : _(h) ? (o = f, M(h)) : (e.consume(h), f);
  }
  function m(h) {
    return h === 45 ? (e.consume(h), p) : f(h);
  }
  function p(h) {
    return h === 62 ? j(h) : h === 45 ? m(h) : f(h);
  }
  function T(h) {
    const te = "CDATA[";
    return h === te.charCodeAt(i++) ? (e.consume(h), i === te.length ? C : T) : n(h);
  }
  function C(h) {
    return h === null ? n(h) : h === 93 ? (e.consume(h), q) : _(h) ? (o = C, M(h)) : (e.consume(h), C);
  }
  function q(h) {
    return h === 93 ? (e.consume(h), x) : C(h);
  }
  function x(h) {
    return h === 62 ? j(h) : h === 93 ? (e.consume(h), x) : C(h);
  }
  function D(h) {
    return h === null || h === 62 ? j(h) : _(h) ? (o = D, M(h)) : (e.consume(h), D);
  }
  function y(h) {
    return h === null ? n(h) : h === 63 ? (e.consume(h), E) : _(h) ? (o = y, M(h)) : (e.consume(h), y);
  }
  function E(h) {
    return h === 62 ? j(h) : y(h);
  }
  function I(h) {
    return he(h) ? (e.consume(h), w) : n(h);
  }
  function w(h) {
    return h === 45 || ce(h) ? (e.consume(h), w) : k(h);
  }
  function k(h) {
    return _(h) ? (o = k, M(h)) : v(h) ? (e.consume(h), k) : j(h);
  }
  function A(h) {
    return h === 45 || ce(h) ? (e.consume(h), A) : h === 47 || h === 62 || W(h) ? L(h) : n(h);
  }
  function L(h) {
    return h === 47 ? (e.consume(h), j) : h === 58 || h === 95 || he(h) ? (e.consume(h), z) : _(h) ? (o = L, M(h)) : v(h) ? (e.consume(h), L) : j(h);
  }
  function z(h) {
    return h === 45 || h === 46 || h === 58 || h === 95 || ce(h) ? (e.consume(h), z) : N(h);
  }
  function N(h) {
    return h === 61 ? (e.consume(h), R) : _(h) ? (o = N, M(h)) : v(h) ? (e.consume(h), N) : L(h);
  }
  function R(h) {
    return h === null || h === 60 || h === 61 || h === 62 || h === 96 ? n(h) : h === 34 || h === 39 ? (e.consume(h), a = h, O) : _(h) ? (o = R, M(h)) : v(h) ? (e.consume(h), R) : (e.consume(h), V);
  }
  function O(h) {
    return h === a ? (e.consume(h), a = void 0, B) : h === null ? n(h) : _(h) ? (o = O, M(h)) : (e.consume(h), O);
  }
  function V(h) {
    return h === null || h === 34 || h === 39 || h === 60 || h === 61 || h === 96 ? n(h) : h === 47 || h === 62 || W(h) ? L(h) : (e.consume(h), V);
  }
  function B(h) {
    return h === 47 || h === 62 || W(h) ? L(h) : n(h);
  }
  function j(h) {
    return h === 62 ? (e.consume(h), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(h);
  }
  function M(h) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(h), e.exit("lineEnding"), K;
  }
  function K(h) {
    return v(h) ? H(e, se, "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(h) : se(h);
  }
  function se(h) {
    return e.enter("htmlTextData"), o(h);
  }
}
const Ct = {
  name: "labelEnd",
  resolveAll: Qr,
  resolveTo: Yr,
  tokenize: Kr
}, jr = {
  tokenize: Zr
}, $r = {
  tokenize: Xr
}, Wr = {
  tokenize: ei
};
function Qr(e) {
  let t = -1;
  const n = [];
  for (; ++t < e.length; ) {
    const r = e[t][1];
    if (n.push(e[t]), r.type === "labelImage" || r.type === "labelLink" || r.type === "labelEnd") {
      const a = r.type === "labelImage" ? 4 : 2;
      r.type = "data", t += a;
    }
  }
  return e.length !== n.length && ae(e, 0, e.length, n), e;
}
function Yr(e, t) {
  let n = e.length, r = 0, a, i, o, s;
  for (; n--; )
    if (a = e[n][1], i) {
      if (a.type === "link" || a.type === "labelLink" && a._inactive)
        break;
      e[n][0] === "enter" && a.type === "labelLink" && (a._inactive = !0);
    } else if (o) {
      if (e[n][0] === "enter" && (a.type === "labelImage" || a.type === "labelLink") && !a._balanced && (i = n, a.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else a.type === "labelEnd" && (o = n);
  const c = {
    type: e[i][1].type === "labelLink" ? "link" : "image",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  }, l = {
    type: "label",
    start: {
      ...e[i][1].start
    },
    end: {
      ...e[o][1].end
    }
  }, g = {
    type: "labelText",
    start: {
      ...e[i + r + 2][1].end
    },
    end: {
      ...e[o - 2][1].start
    }
  };
  return s = [["enter", c, t], ["enter", l, t]], s = oe(s, e.slice(i + 1, i + r + 3)), s = oe(s, [["enter", g, t]]), s = oe(s, it(t.parser.constructs.insideSpan.null, e.slice(i + r + 4, o - 3), t)), s = oe(s, [["exit", g, t], e[o - 2], e[o - 1], ["exit", l, t]]), s = oe(s, e.slice(o + 1)), s = oe(s, [["exit", c, t]]), ae(e, i, e.length, s), e;
}
function Kr(e, t, n) {
  const r = this;
  let a = r.events.length, i, o;
  for (; a--; )
    if ((r.events[a][1].type === "labelImage" || r.events[a][1].type === "labelLink") && !r.events[a][1]._balanced) {
      i = r.events[a][1];
      break;
    }
  return s;
  function s(m) {
    return i ? i._inactive ? f(m) : (o = r.parser.defined.includes(qe(r.sliceSerialize({
      start: i.end,
      end: r.now()
    }))), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(m), e.exit("labelMarker"), e.exit("labelEnd"), c) : n(m);
  }
  function c(m) {
    return m === 40 ? e.attempt(jr, g, o ? g : f)(m) : m === 91 ? e.attempt($r, g, o ? l : f)(m) : o ? g(m) : f(m);
  }
  function l(m) {
    return e.attempt(Wr, g, f)(m);
  }
  function g(m) {
    return t(m);
  }
  function f(m) {
    return i._balanced = !0, n(m);
  }
}
function Zr(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), a;
  }
  function a(f) {
    return W(f) ? Pe(e, i)(f) : i(f);
  }
  function i(f) {
    return f === 41 ? g(f) : mn(e, o, s, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(f);
  }
  function o(f) {
    return W(f) ? Pe(e, c)(f) : g(f);
  }
  function s(f) {
    return n(f);
  }
  function c(f) {
    return f === 34 || f === 39 || f === 40 ? bn(e, l, n, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(f) : g(f);
  }
  function l(f) {
    return W(f) ? Pe(e, g)(f) : g(f);
  }
  function g(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function Xr(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return xn.call(r, e, i, o, "reference", "referenceMarker", "referenceString")(s);
  }
  function i(s) {
    return r.parser.defined.includes(qe(r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1))) ? t(s) : n(s);
  }
  function o(s) {
    return n(s);
  }
}
function ei(e, t, n) {
  return r;
  function r(i) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), a;
  }
  function a(i) {
    return i === 93 ? (e.enter("referenceMarker"), e.consume(i), e.exit("referenceMarker"), e.exit("reference"), t) : n(i);
  }
}
const ti = {
  name: "labelStartImage",
  resolveAll: Ct.resolveAll,
  tokenize: ni
};
function ni(e, t, n) {
  const r = this;
  return a;
  function a(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), i;
  }
  function i(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), o) : n(s);
  }
  function o(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const ri = {
  name: "labelStartLink",
  resolveAll: Ct.resolveAll,
  tokenize: ii
};
function ii(e, t, n) {
  const r = this;
  return a;
  function a(o) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(o), e.exit("labelMarker"), e.exit("labelLink"), i;
  }
  function i(o) {
    return o === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(o) : t(o);
  }
}
const pt = {
  name: "lineEnding",
  tokenize: ai
};
function ai(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), H(e, t, "linePrefix");
  }
}
const et = {
  name: "thematicBreak",
  tokenize: oi
};
function oi(e, t, n) {
  let r = 0, a;
  return i;
  function i(l) {
    return e.enter("thematicBreak"), o(l);
  }
  function o(l) {
    return a = l, s(l);
  }
  function s(l) {
    return l === a ? (e.enter("thematicBreakSequence"), c(l)) : r >= 3 && (l === null || _(l)) ? (e.exit("thematicBreak"), t(l)) : n(l);
  }
  function c(l) {
    return l === a ? (e.consume(l), r++, c) : (e.exit("thematicBreakSequence"), v(l) ? H(e, s, "whitespace")(l) : s(l));
  }
}
const X = {
  continuation: {
    tokenize: ci
  },
  exit: fi,
  name: "list",
  tokenize: li
}, si = {
  partial: !0,
  tokenize: hi
}, ui = {
  partial: !0,
  tokenize: pi
};
function li(e, t, n) {
  const r = this, a = r.events[r.events.length - 1];
  let i = a && a[1].type === "linePrefix" ? a[2].sliceSerialize(a[1], !0).length : 0, o = 0;
  return s;
  function s(p) {
    const T = r.containerState.type || (p === 42 || p === 43 || p === 45 ? "listUnordered" : "listOrdered");
    if (T === "listUnordered" ? !r.containerState.marker || p === r.containerState.marker : bt(p)) {
      if (r.containerState.type || (r.containerState.type = T, e.enter(T, {
        _container: !0
      })), T === "listUnordered")
        return e.enter("listItemPrefix"), p === 42 || p === 45 ? e.check(et, n, l)(p) : l(p);
      if (!r.interrupt || p === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), c(p);
    }
    return n(p);
  }
  function c(p) {
    return bt(p) && ++o < 10 ? (e.consume(p), c) : (!r.interrupt || o < 2) && (r.containerState.marker ? p === r.containerState.marker : p === 41 || p === 46) ? (e.exit("listItemValue"), l(p)) : n(p);
  }
  function l(p) {
    return e.enter("listItemMarker"), e.consume(p), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || p, e.check(
      at,
      // Can’t be empty when interrupting.
      r.interrupt ? n : g,
      e.attempt(si, m, f)
    );
  }
  function g(p) {
    return r.containerState.initialBlankLine = !0, i++, m(p);
  }
  function f(p) {
    return v(p) ? (e.enter("listItemPrefixWhitespace"), e.consume(p), e.exit("listItemPrefixWhitespace"), m) : n(p);
  }
  function m(p) {
    return r.containerState.size = i + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(p);
  }
}
function ci(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(at, a, i);
  function a(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, H(e, t, "listItemIndent", r.containerState.size + 1)(s);
  }
  function i(s) {
    return r.containerState.furtherBlankLines || !v(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, o(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(ui, t, o)(s));
  }
  function o(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, H(e, e.attempt(X, t, n), "linePrefix", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(s);
  }
}
function pi(e, t, n) {
  const r = this;
  return H(e, a, "listItemIndent", r.containerState.size + 1);
  function a(i) {
    const o = r.events[r.events.length - 1];
    return o && o[1].type === "listItemIndent" && o[2].sliceSerialize(o[1], !0).length === r.containerState.size ? t(i) : n(i);
  }
}
function fi(e) {
  e.exit(this.containerState.type);
}
function hi(e, t, n) {
  const r = this;
  return H(e, a, "listItemPrefixWhitespace", r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 5);
  function a(i) {
    const o = r.events[r.events.length - 1];
    return !v(i) && o && o[1].type === "listItemPrefixWhitespace" ? t(i) : n(i);
  }
}
const Pt = {
  name: "setextUnderline",
  resolveTo: di,
  tokenize: gi
};
function di(e, t) {
  let n = e.length, r, a, i;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (a = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !i && e[n][1].type === "definition" && (i = n);
  const o = {
    type: "setextHeading",
    start: {
      ...e[a][1].start
    },
    end: {
      ...e[e.length - 1][1].end
    }
  };
  return e[a][1].type = "setextHeadingText", i ? (e.splice(a, 0, ["enter", o, t]), e.splice(i + 1, 0, ["exit", e[r][1], t]), e[r][1].end = {
    ...e[i][1].end
  }) : e[r][1] = o, e.push(["exit", o, t]), e;
}
function gi(e, t, n) {
  const r = this;
  let a;
  return i;
  function i(l) {
    let g = r.events.length, f;
    for (; g--; )
      if (r.events[g][1].type !== "lineEnding" && r.events[g][1].type !== "linePrefix" && r.events[g][1].type !== "content") {
        f = r.events[g][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), a = l, o(l)) : n(l);
  }
  function o(l) {
    return e.enter("setextHeadingLineSequence"), s(l);
  }
  function s(l) {
    return l === a ? (e.consume(l), s) : (e.exit("setextHeadingLineSequence"), v(l) ? H(e, c, "lineSuffix")(l) : c(l));
  }
  function c(l) {
    return l === null || _(l) ? (e.exit("setextHeadingLine"), t(l)) : n(l);
  }
}
const mi = {
  tokenize: xi
};
function xi(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    at,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(this.parser.constructs.flowInitial, a, H(e, e.attempt(this.parser.constructs.flow, a, e.attempt(Er, a)), "linePrefix"))
  );
  return n;
  function r(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(i), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function a(i) {
    if (i === null) {
      e.consume(i);
      return;
    }
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const bi = {
  resolveAll: wn()
}, yi = yn("string"), wi = yn("text");
function yn(e) {
  return {
    resolveAll: wn(e === "text" ? ki : void 0),
    tokenize: t
  };
  function t(n) {
    const r = this, a = this.parser.constructs[e], i = n.attempt(a, o, s);
    return o;
    function o(g) {
      return l(g) ? i(g) : s(g);
    }
    function s(g) {
      if (g === null) {
        n.consume(g);
        return;
      }
      return n.enter("data"), n.consume(g), c;
    }
    function c(g) {
      return l(g) ? (n.exit("data"), i(g)) : (n.consume(g), c);
    }
    function l(g) {
      if (g === null)
        return !0;
      const f = a[g];
      let m = -1;
      if (f)
        for (; ++m < f.length; ) {
          const p = f[m];
          if (!p.previous || p.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function wn(e) {
  return t;
  function t(n, r) {
    let a = -1, i;
    for (; ++a <= n.length; )
      i === void 0 ? n[a] && n[a][1].type === "data" && (i = a, a++) : (!n[a] || n[a][1].type !== "data") && (a !== i + 2 && (n[i][1].end = n[a - 1][1].end, n.splice(i + 2, a - i - 2), a = i + 2), i = void 0);
    return e ? e(n, r) : n;
  }
}
function ki(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], a = t.sliceStream(r);
      let i = a.length, o = -1, s = 0, c;
      for (; i--; ) {
        const l = a[i];
        if (typeof l == "string") {
          for (o = l.length; l.charCodeAt(o - 1) === 32; )
            s++, o--;
          if (o) break;
          o = -1;
        } else if (l === -2)
          c = !0, s++;
        else if (l !== -1) {
          i++;
          break;
        }
      }
      if (s) {
        const l = {
          type: n === e.length || c || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: i ? o : r.start._bufferIndex + o,
            _index: r.start._index + i,
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s
          },
          end: {
            ...r.end
          }
        };
        r.end = {
          ...l.start
        }, r.start.offset === r.end.offset ? Object.assign(r, l) : (e.splice(n, 0, ["enter", l, t], ["exit", l, t]), n += 2);
      }
      n++;
    }
  return e;
}
const Ei = {
  42: X,
  43: X,
  45: X,
  48: X,
  49: X,
  50: X,
  51: X,
  52: X,
  53: X,
  54: X,
  55: X,
  56: X,
  57: X,
  62: fn
}, Si = {
  91: Ir
}, Ti = {
  [-2]: ct,
  [-1]: ct,
  32: ct
}, Ai = {
  35: Or,
  42: et,
  45: [Pt, et],
  60: Mr,
  61: Pt,
  95: et,
  96: Mt,
  126: Mt
}, Ci = {
  38: dn,
  92: hn
}, Ii = {
  [-5]: pt,
  [-4]: pt,
  [-3]: pt,
  33: ti,
  38: dn,
  42: yt,
  60: [rr, Hr],
  91: ri,
  92: [qr, hn],
  93: Ct,
  95: yt,
  96: mr
}, Li = {
  null: [yt, bi]
}, Ni = {
  null: [42, 95]
}, Ri = {
  null: []
}, qi = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Ni,
  contentInitial: Si,
  disable: Ri,
  document: Ei,
  flow: Ai,
  flowInitial: Ti,
  insideSpan: Li,
  string: Ci,
  text: Ii
}, Symbol.toStringTag, { value: "Module" }));
function Di(e, t, n) {
  let r = {
    _bufferIndex: -1,
    _index: 0,
    line: n && n.line || 1,
    column: n && n.column || 1,
    offset: n && n.offset || 0
  };
  const a = {}, i = [];
  let o = [], s = [];
  const c = {
    attempt: k(I),
    check: k(w),
    consume: D,
    enter: y,
    exit: E,
    interrupt: k(w, {
      interrupt: !0
    })
  }, l = {
    code: null,
    containerState: {},
    defineSkip: C,
    events: [],
    now: T,
    parser: e,
    previous: null,
    sliceSerialize: m,
    sliceStream: p,
    write: f
  };
  let g = t.tokenize.call(l, c);
  return t.resolveAll && i.push(t), l;
  function f(N) {
    return o = oe(o, N), q(), o[o.length - 1] !== null ? [] : (A(t, 0), l.events = it(i, l.events, l), l.events);
  }
  function m(N, R) {
    return _i(p(N), R);
  }
  function p(N) {
    return Oi(o, N);
  }
  function T() {
    const {
      _bufferIndex: N,
      _index: R,
      line: O,
      column: V,
      offset: B
    } = r;
    return {
      _bufferIndex: N,
      _index: R,
      line: O,
      column: V,
      offset: B
    };
  }
  function C(N) {
    a[N.line] = N.column, z();
  }
  function q() {
    let N;
    for (; r._index < o.length; ) {
      const R = o[r._index];
      if (typeof R == "string")
        for (N = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === N && r._bufferIndex < R.length; )
          x(R.charCodeAt(r._bufferIndex));
      else
        x(R);
    }
  }
  function x(N) {
    g = g(N);
  }
  function D(N) {
    _(N) ? (r.line++, r.column = 1, r.offset += N === -3 ? 2 : 1, z()) : N !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
    // strings.
    /** @type {string} */
    o[r._index].length && (r._bufferIndex = -1, r._index++)), l.previous = N;
  }
  function y(N, R) {
    const O = R || {};
    return O.type = N, O.start = T(), l.events.push(["enter", O, l]), s.push(O), O;
  }
  function E(N) {
    const R = s.pop();
    return R.end = T(), l.events.push(["exit", R, l]), R;
  }
  function I(N, R) {
    A(N, R.from);
  }
  function w(N, R) {
    R.restore();
  }
  function k(N, R) {
    return O;
    function O(V, B, j) {
      let M, K, se, h;
      return Array.isArray(V) ? (
        /* c8 ignore next 1 */
        ue(V)
      ) : "tokenize" in V ? (
        // Looks like a construct.
        ue([
          /** @type {Construct} */
          V
        ])
      ) : te(V);
      function te(Q) {
        return Te;
        function Te(fe) {
          const ge = fe !== null && Q[fe], ye = fe !== null && Q.null, re = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(ge) ? ge : ge ? [ge] : [],
            ...Array.isArray(ye) ? ye : ye ? [ye] : []
          ];
          return ue(re)(fe);
        }
      }
      function ue(Q) {
        return M = Q, K = 0, Q.length === 0 ? j : d(Q[K]);
      }
      function d(Q) {
        return Te;
        function Te(fe) {
          return h = L(), se = Q, Q.partial || (l.currentConstruct = Q), Q.name && l.parser.constructs.disable.null.includes(Q.name) ? pe() : Q.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            R ? Object.assign(Object.create(l), R) : l,
            c,
            ne,
            pe
          )(fe);
        }
      }
      function ne(Q) {
        return N(se, h), B;
      }
      function pe(Q) {
        return h.restore(), ++K < M.length ? d(M[K]) : j;
      }
    }
  }
  function A(N, R) {
    N.resolveAll && !i.includes(N) && i.push(N), N.resolve && ae(l.events, R, l.events.length - R, N.resolve(l.events.slice(R), l)), N.resolveTo && (l.events = N.resolveTo(l.events, l));
  }
  function L() {
    const N = T(), R = l.previous, O = l.currentConstruct, V = l.events.length, B = Array.from(s);
    return {
      from: V,
      restore: j
    };
    function j() {
      r = N, l.previous = R, l.currentConstruct = O, l.events.length = V, s = B, z();
    }
  }
  function z() {
    r.line in a && r.column < 2 && (r.column = a[r.line], r.offset += a[r.line] - 1);
  }
}
function Oi(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, a = t.end._index, i = t.end._bufferIndex;
  let o;
  if (n === a)
    o = [e[n].slice(r, i)];
  else {
    if (o = e.slice(n, a), r > -1) {
      const s = o[0];
      typeof s == "string" ? o[0] = s.slice(r) : o.shift();
    }
    i > 0 && o.push(e[a].slice(0, i));
  }
  return o;
}
function _i(e, t) {
  let n = -1;
  const r = [];
  let a;
  for (; ++n < e.length; ) {
    const i = e[n];
    let o;
    if (typeof i == "string")
      o = i;
    else switch (i) {
      case -5: {
        o = "\r";
        break;
      }
      case -4: {
        o = `
`;
        break;
      }
      case -3: {
        o = `\r
`;
        break;
      }
      case -2: {
        o = t ? " " : "	";
        break;
      }
      case -1: {
        if (!t && a) continue;
        o = " ";
        break;
      }
      default:
        o = String.fromCharCode(i);
    }
    a = i === -2, r.push(o);
  }
  return r.join("");
}
function zi(e) {
  const r = {
    constructs: (
      /** @type {FullNormalizedExtension} */
      Un([qi, ...(e || {}).extensions || []])
    ),
    content: a(Yn),
    defined: [],
    document: a(Zn),
    flow: a(mi),
    lazy: {},
    string: a(yi),
    text: a(wi)
  };
  return r;
  function a(i) {
    return o;
    function o(s) {
      return Di(r, i, s);
    }
  }
}
function Fi(e) {
  for (; !gn(e); )
    ;
  return e;
}
const vt = /[\0\t\n\r]/g;
function Mi() {
  let e = 1, t = "", n = !0, r;
  return a;
  function a(i, o, s) {
    const c = [];
    let l, g, f, m, p;
    for (i = t + (typeof i == "string" ? i.toString() : new TextDecoder(o || void 0).decode(i)), f = 0, t = "", n && (i.charCodeAt(0) === 65279 && f++, n = void 0); f < i.length; ) {
      if (vt.lastIndex = f, l = vt.exec(i), m = l && l.index !== void 0 ? l.index : i.length, p = i.charCodeAt(m), !l) {
        t = i.slice(f);
        break;
      }
      if (p === 10 && f === m && r)
        c.push(-3), r = void 0;
      else
        switch (r && (c.push(-5), r = void 0), f < m && (c.push(i.slice(f, m)), e += m - f), p) {
          case 0: {
            c.push(65533), e++;
            break;
          }
          case 9: {
            for (g = Math.ceil(e / 4) * 4, c.push(-2); e++ < g; ) c.push(-1);
            break;
          }
          case 10: {
            c.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = m + 1;
    }
    return s && (r && c.push(-5), t && c.push(t), c.push(null)), c;
  }
}
const Bi = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function Pi(e) {
  return e.replace(Bi, vi);
}
function vi(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const a = n.charCodeAt(1), i = a === 120 || a === 88;
    return pn(n.slice(i ? 2 : 1), i ? 16 : 10);
  }
  return ve(n) || e;
}
function tt(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Jt(e.position) : "start" in e || "end" in e ? Jt(e) : "line" in e || "column" in e ? wt(e) : "";
}
function wt(e) {
  return Vt(e && e.line) + ":" + Vt(e && e.column);
}
function Jt(e) {
  return wt(e && e.start) + "-" + wt(e && e.end);
}
function Vt(e) {
  return e && typeof e == "number" ? e : 1;
}
const kn = {}.hasOwnProperty;
function Ji(e, t, n) {
  return typeof t != "string" && (n = t, t = void 0), Vi(n)(Fi(zi(n).document().write(Mi()(e, t, !0))));
}
function Vi(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: i(Ge),
      autolinkProtocol: L,
      autolinkEmail: L,
      atxHeading: i(Ve),
      blockQuote: i(ye),
      characterEscape: L,
      characterReference: L,
      codeFenced: i(re),
      codeFencedFenceInfo: o,
      codeFencedFenceMeta: o,
      codeIndented: i(re, o),
      codeText: i(ot, o),
      codeTextData: L,
      data: L,
      codeFlowValue: L,
      definition: i(Je),
      definitionDestinationString: o,
      definitionLabelString: o,
      definitionTitleString: o,
      emphasis: i(st),
      hardBreakEscape: i(Oe),
      hardBreakTrailing: i(Oe),
      htmlFlow: i(Ue, o),
      htmlFlowData: L,
      htmlText: i(Ue, o),
      htmlTextData: L,
      image: i(He),
      label: o,
      link: i(Ge),
      listItem: i(je),
      listItemValue: m,
      listOrdered: i(Ie, f),
      listUnordered: i(Ie),
      paragraph: i(ut),
      reference: d,
      referenceString: o,
      resourceDestinationString: o,
      resourceTitleString: o,
      setextHeading: i(Ve),
      strong: i(Le),
      thematicBreak: i($e)
    },
    exit: {
      atxHeading: c(),
      atxHeadingSequence: I,
      autolink: c(),
      autolinkEmail: ge,
      autolinkProtocol: fe,
      blockQuote: c(),
      characterEscapeValue: z,
      characterReferenceMarkerHexadecimal: pe,
      characterReferenceMarkerNumeric: pe,
      characterReferenceValue: Q,
      characterReference: Te,
      codeFenced: c(q),
      codeFencedFence: C,
      codeFencedFenceInfo: p,
      codeFencedFenceMeta: T,
      codeFlowValue: z,
      codeIndented: c(x),
      codeText: c(B),
      codeTextData: z,
      data: z,
      definition: c(),
      definitionDestinationString: E,
      definitionLabelString: D,
      definitionTitleString: y,
      emphasis: c(),
      hardBreakEscape: c(R),
      hardBreakTrailing: c(R),
      htmlFlow: c(O),
      htmlFlowData: z,
      htmlText: c(V),
      htmlTextData: z,
      image: c(M),
      label: se,
      labelText: K,
      lineEnding: N,
      link: c(j),
      listItem: c(),
      listOrdered: c(),
      listUnordered: c(),
      paragraph: c(),
      referenceString: ne,
      resourceDestinationString: h,
      resourceTitleString: te,
      resource: ue,
      setextHeading: c(A),
      setextHeadingLineSequence: k,
      setextHeadingText: w,
      strong: c(),
      thematicBreak: c()
    }
  };
  En(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(b) {
    let S = {
      type: "root",
      children: []
    };
    const u = {
      stack: [S],
      tokenStack: [],
      config: t,
      enter: s,
      exit: l,
      buffer: o,
      resume: g,
      data: n
    }, F = [];
    let J = -1;
    for (; ++J < b.length; )
      if (b[J][1].type === "listOrdered" || b[J][1].type === "listUnordered")
        if (b[J][0] === "enter")
          F.push(J);
        else {
          const Z = F.pop();
          J = a(b, Z, J);
        }
    for (J = -1; ++J < b.length; ) {
      const Z = t[b[J][0]];
      kn.call(Z, b[J][1].type) && Z[b[J][1].type].call(Object.assign({
        sliceSerialize: b[J][2].sliceSerialize
      }, u), b[J][1]);
    }
    if (u.tokenStack.length > 0) {
      const Z = u.tokenStack[u.tokenStack.length - 1];
      (Z[1] || Ut).call(u, void 0, Z[0]);
    }
    for (S.position = {
      start: we(b.length > 0 ? b[0][1].start : {
        line: 1,
        column: 1,
        offset: 0
      }),
      end: we(b.length > 0 ? b[b.length - 2][1].end : {
        line: 1,
        column: 1,
        offset: 0
      })
    }, J = -1; ++J < t.transforms.length; )
      S = t.transforms[J](S) || S;
    return S;
  }
  function a(b, S, u) {
    let F = S - 1, J = -1, Z = !1, Ae, me, _e, ze;
    for (; ++F <= u; ) {
      const ie = b[F];
      switch (ie[1].type) {
        case "listUnordered":
        case "listOrdered":
        case "blockQuote": {
          ie[0] === "enter" ? J++ : J--, ze = void 0;
          break;
        }
        case "lineEndingBlank": {
          ie[0] === "enter" && (Ae && !ze && !J && !_e && (_e = F), ze = void 0);
          break;
        }
        case "linePrefix":
        case "listItemValue":
        case "listItemMarker":
        case "listItemPrefix":
        case "listItemPrefixWhitespace":
          break;
        default:
          ze = void 0;
      }
      if (!J && ie[0] === "enter" && ie[1].type === "listItemPrefix" || J === -1 && ie[0] === "exit" && (ie[1].type === "listUnordered" || ie[1].type === "listOrdered")) {
        if (Ae) {
          let Ne = F;
          for (me = void 0; Ne--; ) {
            const xe = b[Ne];
            if (xe[1].type === "lineEnding" || xe[1].type === "lineEndingBlank") {
              if (xe[0] === "exit") continue;
              me && (b[me][1].type = "lineEndingBlank", Z = !0), xe[1].type = "lineEnding", me = Ne;
            } else if (!(xe[1].type === "linePrefix" || xe[1].type === "blockQuotePrefix" || xe[1].type === "blockQuotePrefixWhitespace" || xe[1].type === "blockQuoteMarker" || xe[1].type === "listItemIndent")) break;
          }
          _e && (!me || _e < me) && (Ae._spread = !0), Ae.end = Object.assign({}, me ? b[me][1].start : ie[1].end), b.splice(me || F, 0, ["exit", Ae, ie[2]]), F++, u++;
        }
        if (ie[1].type === "listItemPrefix") {
          const Ne = {
            type: "listItem",
            _spread: !1,
            start: Object.assign({}, ie[1].start),
            // @ts-expect-error: we’ll add `end` in a second.
            end: void 0
          };
          Ae = Ne, b.splice(F, 0, ["enter", Ne, ie[2]]), F++, u++, _e = void 0, ze = !0;
        }
      }
    }
    return b[S][1]._spread = Z, u;
  }
  function i(b, S) {
    return u;
    function u(F) {
      s.call(this, b(F), F), S && S.call(this, F);
    }
  }
  function o() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function s(b, S, u) {
    this.stack[this.stack.length - 1].children.push(b), this.stack.push(b), this.tokenStack.push([S, u || void 0]), b.position = {
      start: we(S.start),
      // @ts-expect-error: `end` will be patched later.
      end: void 0
    };
  }
  function c(b) {
    return S;
    function S(u) {
      b && b.call(this, u), l.call(this, u);
    }
  }
  function l(b, S) {
    const u = this.stack.pop(), F = this.tokenStack.pop();
    if (F)
      F[0].type !== b.type && (S ? S.call(this, b, F[0]) : (F[1] || Ut).call(this, b, F[0]));
    else throw new Error("Cannot close `" + b.type + "` (" + tt({
      start: b.start,
      end: b.end
    }) + "): it’s not open");
    u.position.end = we(b.end);
  }
  function g() {
    return vn(this.stack.pop());
  }
  function f() {
    this.data.expectingFirstListItemValue = !0;
  }
  function m(b) {
    if (this.data.expectingFirstListItemValue) {
      const S = this.stack[this.stack.length - 2];
      S.start = Number.parseInt(this.sliceSerialize(b), 10), this.data.expectingFirstListItemValue = void 0;
    }
  }
  function p() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.lang = b;
  }
  function T() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.meta = b;
  }
  function C() {
    this.data.flowCodeInside || (this.buffer(), this.data.flowCodeInside = !0);
  }
  function q() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = b.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), this.data.flowCodeInside = void 0;
  }
  function x() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = b.replace(/(\r?\n|\r)$/g, "");
  }
  function D(b) {
    const S = this.resume(), u = this.stack[this.stack.length - 1];
    u.label = S, u.identifier = qe(this.sliceSerialize(b)).toLowerCase();
  }
  function y() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.title = b;
  }
  function E() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.url = b;
  }
  function I(b) {
    const S = this.stack[this.stack.length - 1];
    if (!S.depth) {
      const u = this.sliceSerialize(b).length;
      S.depth = u;
    }
  }
  function w() {
    this.data.setextHeadingSlurpLineEnding = !0;
  }
  function k(b) {
    const S = this.stack[this.stack.length - 1];
    S.depth = this.sliceSerialize(b).codePointAt(0) === 61 ? 1 : 2;
  }
  function A() {
    this.data.setextHeadingSlurpLineEnding = void 0;
  }
  function L(b) {
    const u = this.stack[this.stack.length - 1].children;
    let F = u[u.length - 1];
    (!F || F.type !== "text") && (F = $(), F.position = {
      start: we(b.start),
      // @ts-expect-error: we’ll add `end` later.
      end: void 0
    }, u.push(F)), this.stack.push(F);
  }
  function z(b) {
    const S = this.stack.pop();
    S.value += this.sliceSerialize(b), S.position.end = we(b.end);
  }
  function N(b) {
    const S = this.stack[this.stack.length - 1];
    if (this.data.atHardBreak) {
      const u = S.children[S.children.length - 1];
      u.position.end = we(b.end), this.data.atHardBreak = void 0;
      return;
    }
    !this.data.setextHeadingSlurpLineEnding && t.canContainEols.includes(S.type) && (L.call(this, b), z.call(this, b));
  }
  function R() {
    this.data.atHardBreak = !0;
  }
  function O() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = b;
  }
  function V() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = b;
  }
  function B() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.value = b;
  }
  function j() {
    const b = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const S = this.data.referenceType || "shortcut";
      b.type += "Reference", b.referenceType = S, delete b.url, delete b.title;
    } else
      delete b.identifier, delete b.label;
    this.data.referenceType = void 0;
  }
  function M() {
    const b = this.stack[this.stack.length - 1];
    if (this.data.inReference) {
      const S = this.data.referenceType || "shortcut";
      b.type += "Reference", b.referenceType = S, delete b.url, delete b.title;
    } else
      delete b.identifier, delete b.label;
    this.data.referenceType = void 0;
  }
  function K(b) {
    const S = this.sliceSerialize(b), u = this.stack[this.stack.length - 2];
    u.label = Pi(S), u.identifier = qe(S).toLowerCase();
  }
  function se() {
    const b = this.stack[this.stack.length - 1], S = this.resume(), u = this.stack[this.stack.length - 1];
    if (this.data.inReference = !0, u.type === "link") {
      const F = b.children;
      u.children = F;
    } else
      u.alt = S;
  }
  function h() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.url = b;
  }
  function te() {
    const b = this.resume(), S = this.stack[this.stack.length - 1];
    S.title = b;
  }
  function ue() {
    this.data.inReference = void 0;
  }
  function d() {
    this.data.referenceType = "collapsed";
  }
  function ne(b) {
    const S = this.resume(), u = this.stack[this.stack.length - 1];
    u.label = S, u.identifier = qe(this.sliceSerialize(b)).toLowerCase(), this.data.referenceType = "full";
  }
  function pe(b) {
    this.data.characterReferenceType = b.type;
  }
  function Q(b) {
    const S = this.sliceSerialize(b), u = this.data.characterReferenceType;
    let F;
    u ? (F = pn(S, u === "characterReferenceMarkerNumeric" ? 10 : 16), this.data.characterReferenceType = void 0) : F = ve(S);
    const J = this.stack[this.stack.length - 1];
    J.value += F;
  }
  function Te(b) {
    const S = this.stack.pop();
    S.position.end = we(b.end);
  }
  function fe(b) {
    z.call(this, b);
    const S = this.stack[this.stack.length - 1];
    S.url = this.sliceSerialize(b);
  }
  function ge(b) {
    z.call(this, b);
    const S = this.stack[this.stack.length - 1];
    S.url = "mailto:" + this.sliceSerialize(b);
  }
  function ye() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function re() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function ot() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function Je() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function st() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function Ve() {
    return {
      type: "heading",
      // @ts-expect-error `depth` will be set later.
      depth: 0,
      children: []
    };
  }
  function Oe() {
    return {
      type: "break"
    };
  }
  function Ue() {
    return {
      type: "html",
      value: ""
    };
  }
  function He() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ge() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function Ie(b) {
    return {
      type: "list",
      ordered: b.type === "listOrdered",
      start: null,
      spread: b._spread,
      children: []
    };
  }
  function je(b) {
    return {
      type: "listItem",
      spread: b._spread,
      checked: null,
      children: []
    };
  }
  function ut() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function Le() {
    return {
      type: "strong",
      children: []
    };
  }
  function $() {
    return {
      type: "text",
      value: ""
    };
  }
  function $e() {
    return {
      type: "thematicBreak"
    };
  }
}
function we(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function En(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? En(e, r) : Ui(e, r);
  }
}
function Ui(e, t) {
  let n;
  for (n in t)
    if (kn.call(t, n))
      switch (n) {
        case "canContainEols": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "transforms": {
          const r = t[n];
          r && e[n].push(...r);
          break;
        }
        case "enter":
        case "exit": {
          const r = t[n];
          r && Object.assign(e[n], r);
          break;
        }
      }
}
function Ut(e, t) {
  throw e ? new Error("Cannot close `" + e.type + "` (" + tt({
    start: e.start,
    end: e.end
  }) + "): a different token (`" + t.type + "`, " + tt({
    start: t.start,
    end: t.end
  }) + ") is open") : new Error("Cannot close document, a token (`" + t.type + "`, " + tt({
    start: t.start,
    end: t.end
  }) + ") is still open");
}
function Hi(e) {
  let n = {}.singleTilde;
  const r = {
    name: "strikethrough",
    tokenize: i,
    resolveAll: a
  };
  return n == null && (n = !0), {
    text: {
      126: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function a(o, s) {
    let c = -1;
    for (; ++c < o.length; )
      if (o[c][0] === "enter" && o[c][1].type === "strikethroughSequenceTemporary" && o[c][1]._close) {
        let l = c;
        for (; l--; )
          if (o[l][0] === "exit" && o[l][1].type === "strikethroughSequenceTemporary" && o[l][1]._open && // If the sizes are the same:
          o[c][1].end.offset - o[c][1].start.offset === o[l][1].end.offset - o[l][1].start.offset) {
            o[c][1].type = "strikethroughSequence", o[l][1].type = "strikethroughSequence";
            const g = {
              type: "strikethrough",
              start: Object.assign({}, o[l][1].start),
              end: Object.assign({}, o[c][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, o[l][1].end),
              end: Object.assign({}, o[c][1].start)
            }, m = [["enter", g, s], ["enter", o[l][1], s], ["exit", o[l][1], s], ["enter", f, s]], p = s.parser.constructs.insideSpan.null;
            p && ae(m, m.length, 0, it(p, o.slice(l + 1, c), s)), ae(m, m.length, 0, [["exit", f, s], ["enter", o[c][1], s], ["exit", o[c][1], s], ["exit", g, s]]), ae(o, l - 1, c - l + 3, m), c = l + m.length - 2;
            break;
          }
      }
    for (c = -1; ++c < o.length; )
      o[c][1].type === "strikethroughSequenceTemporary" && (o[c][1].type = "data");
    return o;
  }
  function i(o, s, c) {
    const l = this.previous, g = this.events;
    let f = 0;
    return m;
    function m(T) {
      return l === 126 && g[g.length - 1][1].type !== "characterEscape" ? c(T) : (o.enter("strikethroughSequenceTemporary"), p(T));
    }
    function p(T) {
      const C = nt(l);
      if (T === 126)
        return f > 1 ? c(T) : (o.consume(T), f++, p);
      if (f < 2 && !n) return c(T);
      const q = o.exit("strikethroughSequenceTemporary"), x = nt(T);
      return q._open = !x || x === 2 && !!C, q._close = !C || C === 2 && !!x, s(T);
    }
  }
}
function Gi() {
  return {
    canContainEols: ["delete"],
    enter: { strikethrough: ji },
    exit: { strikethrough: $i }
  };
}
function ji(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function $i(e) {
  this.exit(e);
}
const Wi = /[$_\p{ID_Start}]/u, Qi = /[$_\u{200C}\u{200D}\p{ID_Continue}]/u, Yi = /[-$_\u{200C}\u{200D}\p{ID_Continue}]/u, Ki = {};
function le(e) {
  return e ? Wi.test(String.fromCodePoint(e)) : !1;
}
function Be(e, t) {
  const r = (t || Ki).jsx ? Yi : Qi;
  return e ? r.test(String.fromCodePoint(e)) : !1;
}
function Zi(e) {
  return "\x1B[33m" + e + "\x1B[39m";
}
const Xi = {}.hasOwnProperty, ea = Symbol("continue"), ft = Symbol("exit"), ta = Symbol("skip");
function na(e, t) {
  let n, r;
  typeof t == "function" ? n = t : typeof t == "object" && (t.enter && (n = t.enter), t.leave && (r = t.leave)), a(e, void 0, void 0, [])();
  function a(i, o, s, c) {
    return ht(i) && (l.displayName = "node (" + Zi(i.type) + ")"), l;
    function l() {
      const g = n ? Ht(n(i, o, s, c)) : [];
      if (g[0] === ft)
        return g;
      if (g[0] !== ta) {
        let f;
        for (f in i)
          if (Xi.call(i, f) && i[f] && typeof i[f] == "object" && // @ts-expect-error: custom esast extension.
          f !== "data" && // @ts-expect-error: custom esast extension.
          f !== "position") {
            const m = c.concat(i), p = i[f];
            if (Array.isArray(p)) {
              const T = (
                /** @type {Array<unknown>} */
                p
              );
              let C = 0;
              for (; C > -1 && C < T.length; ) {
                const q = T[C];
                if (ht(q)) {
                  const x = a(
                    q,
                    f,
                    C,
                    m
                  )();
                  if (x[0] === ft) return x;
                  C = typeof x[1] == "number" ? x[1] : C + 1;
                } else
                  C++;
              }
            } else if (ht(p)) {
              const T = a(p, f, void 0, m)();
              if (T[0] === ft) return T;
            }
          }
      }
      return r ? Ht(r(i, o, s, c)) : g;
    }
  }
}
function Ht(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [ea, e] : [e];
}
function ht(e) {
  return !!(e && typeof e == "object" && "type" in e && typeof e.type == "string" && e.type.length > 0);
}
function ra(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? Gt(e.position) : "start" in e || "end" in e ? Gt(e) : "line" in e || "column" in e ? kt(e) : "";
}
function kt(e) {
  return jt(e && e.line) + ":" + jt(e && e.column);
}
function Gt(e) {
  return kt(e && e.start) + "-" + kt(e && e.end);
}
function jt(e) {
  return e && typeof e == "number" ? e : 1;
}
class U extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(t, n, r) {
    super(), typeof n == "string" && (r = n, n = void 0);
    let a = "", i = {}, o = !1;
    if (n && ("line" in n && "column" in n ? i = { place: n } : "start" in n && "end" in n ? i = { place: n } : "type" in n ? i = {
      ancestors: [n],
      place: n.position
    } : i = { ...n }), typeof t == "string" ? a = t : !i.cause && t && (o = !0, a = t.message, i.cause = t), !i.ruleId && !i.source && typeof r == "string") {
      const c = r.indexOf(":");
      c === -1 ? i.ruleId = r : (i.source = r.slice(0, c), i.ruleId = r.slice(c + 1));
    }
    if (!i.place && i.ancestors && i.ancestors) {
      const c = i.ancestors[i.ancestors.length - 1];
      c && (i.place = c.position);
    }
    const s = i.place && "start" in i.place ? i.place.start : i.place;
    this.ancestors = i.ancestors || void 0, this.cause = i.cause || void 0, this.column = s ? s.column : void 0, this.fatal = void 0, this.file, this.message = a, this.line = s ? s.line : void 0, this.name = ra(i.place) || "1:1", this.place = i.place || void 0, this.reason = this.message, this.ruleId = i.ruleId || void 0, this.source = i.source || void 0, this.stack = o && i.cause && typeof i.cause.stack == "string" ? i.cause.stack : "", this.actual, this.expected, this.note, this.url;
  }
}
U.prototype.file = "";
U.prototype.name = "";
U.prototype.reason = "";
U.prototype.message = "";
U.prototype.stack = "";
U.prototype.column = void 0;
U.prototype.line = void 0;
U.prototype.ancestors = void 0;
U.prototype.cause = void 0;
U.prototype.fatal = void 0;
U.prototype.place = void 0;
U.prototype.ruleId = void 0;
U.prototype.source = void 0;
function ia(e, t) {
  const n = t.prefix || "", r = t.suffix || "", a = Object.assign({}, t.acornOptions), i = [], o = [], s = a.onComment, c = a.onToken;
  let l = !1, g, f;
  const m = Object.assign({}, a, {
    onComment: i,
    preserveParens: !0
  });
  c && (m.onToken = o);
  const p = aa(e, t.tokenTypes), T = p.value, C = n + T + r, q = $t(T);
  if (q && !t.allowEmpty)
    throw new U("Unexpected empty expression", {
      place: D(0),
      ruleId: "unexpected-empty-expression",
      source: "micromark-extension-mdx-expression"
    });
  try {
    g = t.expression && !q ? t.acorn.parseExpressionAt(C, 0, m) : t.acorn.parse(C, m);
  } catch (y) {
    const E = (
      /** @type {AcornError} */
      y
    ), I = D(E.pos);
    E.message = String(E.message).replace(/ \(\d+:\d+\)$/, ""), E.pos = I.offset, E.loc = {
      line: I.line,
      column: I.column - 1
    }, f = E, l = E.raisedAt >= n.length + T.length || // Broken comments are raised at their start, not their end.
    E.message === "Unterminated comment";
  }
  if (g && t.expression && !q)
    if ($t(C.slice(g.end, C.length - r.length)))
      g = {
        type: "Program",
        start: 0,
        end: n.length + T.length,
        // @ts-expect-error: It’s good.
        body: [{
          type: "ExpressionStatement",
          expression: g,
          start: 0,
          end: n.length + T.length
        }],
        sourceType: "module",
        comments: []
      };
    else {
      const y = D(g.end), E = (
        /** @type {AcornError} */
        new Error("Unexpected content after expression")
      );
      E.pos = y.offset, E.loc = {
        line: y.line,
        column: y.column - 1
      }, f = E, g = void 0;
    }
  if (g) {
    if (g.comments = i, na(g, function(y, E, I, w) {
      let k = (
        /** @type {AcornNode | Array<AcornNode>} */
        w[w.length - 1]
      ), A = E;
      y.type === "ParenthesizedExpression" && k && A && (typeof I == "number" && (k = k[A], A = I), k[A] = y.expression), x(y);
    }), Array.isArray(s))
      s.push(...i);
    else if (typeof s == "function")
      for (const y of i)
        s(y.type === "Block", y.value, y.start, y.end, y.loc.start, y.loc.end);
    for (const y of o)
      y.end <= n.length || y.start - n.length >= T.length || (x(y), Array.isArray(c) ? c.push(y) : c(y));
  }
  return {
    estree: g,
    error: f,
    swallow: l
  };
  function x(y) {
    const E = D(y.start), I = D(y.end);
    y.start = E.offset, y.end = I.offset, y.loc = {
      start: {
        line: E.line,
        column: E.column - 1,
        offset: E.offset
      },
      end: {
        line: I.line,
        column: I.column - 1,
        offset: I.offset
      }
    }, y.range = [y.start, y.end];
  }
  function D(y) {
    let E = y - n.length;
    E < 0 ? E = 0 : E > T.length && (E = T.length);
    let I = oa(p.stops, E);
    return I || (I = {
      line: t.start.line,
      column: t.start.column,
      offset: t.start.offset
    }), I;
  }
}
function $t(e) {
  return /^\s*$/.test(e.replace(/\/\*[\s\S]*?\*\//g, "").replace(/\/\/[^\r\n]*(\r\n|\n|\r)/g, ""));
}
function aa(e, t) {
  const n = {
    value: "",
    stops: []
  };
  let r = -1;
  for (; ++r < e.length; ) {
    const a = e[r];
    if (a[0] === "enter") {
      const i = a[1].type;
      if (i === "lineEnding" || t.includes(i)) {
        const o = a[2].sliceStream(a[1]);
        for (; o.length > 0 && o[0] === -1; )
          o.shift();
        const s = sa(o);
        n.stops.push([n.value.length, a[1].start]), n.value += s, n.stops.push([n.value.length, a[1].end]);
      }
    }
  }
  return n;
}
function oa(e, t) {
  let n = 0;
  for (; n < e.length && e[n][0] <= t; )
    n += 1;
  if (n === 0)
    return;
  const [r, a] = e[n - 1], i = t - r;
  return {
    line: a.line,
    column: a.column + i,
    offset: a.offset + i
  };
}
function sa(e) {
  let t = -1;
  const n = [];
  let r;
  for (; ++t < e.length; ) {
    const a = e[t];
    let i;
    if (typeof a == "string")
      i = a;
    else switch (a) {
      case -5: {
        i = "\r";
        break;
      }
      case -4: {
        i = `
`;
        break;
      }
      case -3: {
        i = `\r
`;
        break;
      }
      case -2: {
        i = "	";
        break;
      }
      case -1: {
        if (r) continue;
        i = " ";
        break;
      }
      default:
        i = String.fromCharCode(a);
    }
    r = a === -2, n.push(i);
  }
  return n.join("");
}
function dt(e) {
  const t = e || {}, n = t.loc || {}, r = t.range || [void 0, void 0], a = Wt(n.start, r[0] || t.start), i = Wt(n.end, r[1] || t.end);
  if (a && i)
    return { start: a, end: i };
}
function Wt(e, t) {
  if (e && typeof e == "object") {
    const n = "line" in e ? gt(e.line) : void 0, r = "column" in e ? gt(e.column) : void 0;
    if (n && r !== void 0)
      return {
        line: n,
        column: r + 1,
        offset: gt(t)
      };
  }
}
function gt(e) {
  return typeof e == "number" && e > -1 ? e : void 0;
}
const ua = 2, Re = "https://github.com/micromark/micromark-extension-mdx-expression/tree/main/packages/micromark-extension-mdx-expression", la = "#unexpected-end-of-file-in-expression-expected-a-corresponding-closing-brace-for-", ca = "#unexpected-lazy-line-in-expression-in-container-expected-line-to-be-prefixed", Qt = "#unexpected-type-in-code-expected-an-object-spread-spread", pa = "#unexpected-extra-content-in-spread-only-a-single-spread-is-supported", fa = "#could-not-parse-expression-with-acorn";
function Yt(e, t, n, r, a, i, o, s, c, l, g) {
  const f = this, m = this.events.length + 3;
  let p = 0, T, C;
  return q;
  function q(E) {
    return e.enter(n), e.enter(r), e.consume(E), e.exit(r), T = f.now(), x;
  }
  function x(E) {
    if (E === null) {
      if (C) throw C;
      const I = new U("Unexpected end of file in expression, expected a corresponding closing brace for `{`", {
        place: f.now(),
        ruleId: "unexpected-eof",
        source: "micromark-extension-mdx-expression"
      });
      throw I.url = Re + la, I;
    }
    if (_(E))
      return e.enter("lineEnding"), e.consume(E), e.exit("lineEnding"), y;
    if (E === 125 && p === 0) {
      const I = i ? ha.call(f, i, o, a, m, T, l || !1, c || !1) : {
        type: "ok",
        estree: void 0
      };
      if (I.type === "ok") {
        e.enter(r), e.consume(E), e.exit(r);
        const w = e.exit(n);
        return s && I.estree && Object.assign(w, {
          estree: I.estree
        }), t;
      }
      return C = I.message, e.enter(a), e.consume(E), D;
    }
    return e.enter(a), D(E);
  }
  function D(E) {
    return E === 125 && p === 0 || E === null || _(E) ? (e.exit(a), x(E)) : (E === 123 && !i ? p += 1 : E === 125 && (p -= 1), e.consume(E), D);
  }
  function y(E) {
    const I = f.now();
    if (I.line !== T.line && !g && f.parser.lazy[I.line]) {
      const w = new U("Unexpected lazy line in expression in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", {
        place: f.now(),
        ruleId: "unexpected-lazy",
        source: "micromark-extension-mdx-expression"
      });
      throw w.url = Re + ca, w;
    }
    return v(E) ? H(e, x, "linePrefix", ua + 1)(E) : x(E);
  }
}
function ha(e, t, n, r, a, i, o) {
  const s = ia(this.events.slice(r), {
    acorn: e,
    tokenTypes: [n],
    acornOptions: t,
    start: a,
    expression: !0,
    allowEmpty: i,
    prefix: o ? "({" : "",
    suffix: o ? "})" : ""
  }), c = s.estree;
  if (o && c) {
    const l = c.body[0];
    if (l.type !== "ExpressionStatement" || l.expression.type !== "ObjectExpression") {
      const g = dt(l), f = new U("Unexpected `" + l.type + "` in code: expected an object spread (`{...spread}`)", {
        place: g.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw f.url = Re + Qt, f;
    }
    if (l.expression.properties[1]) {
      const g = dt(l.expression.properties[1]), f = new U("Unexpected extra content in spread: only a single spread is supported", {
        place: g.start,
        ruleId: "spread-extra",
        source: "micromark-extension-mdx-expression"
      });
      throw f.url = Re + pa, f;
    }
    if (l.expression.properties[0] && l.expression.properties[0].type !== "SpreadElement") {
      const g = dt(l.expression.properties[0]), f = new U("Unexpected `" + l.expression.properties[0].type + "` in code: only spread elements are supported", {
        place: g.start,
        ruleId: "non-spread",
        source: "micromark-extension-mdx-expression"
      });
      throw f.url = Re + Qt, f;
    }
  }
  if (s.error) {
    const l = new U("Could not parse expression with acorn", {
      cause: s.error,
      place: {
        line: s.error.loc.line,
        column: s.error.loc.column + 1,
        offset: s.error.pos
      },
      ruleId: "acorn",
      source: "micromark-extension-mdx-expression"
    });
    return l.url = Re + fa, {
      type: "nok",
      message: l
    };
  }
  return {
    type: "ok",
    estree: c
  };
}
const Kt = "https://github.com/micromark/micromark-extension-mdx-jsx";
function Sn(e, t, n, r, a, i, o, s, c, l, g, f, m, p, T, C, q, x, D, y, E, I, w, k, A, L, z, N, R, O, V, B) {
  const j = this;
  let M, K;
  return se;
  function se(u) {
    return e.enter(s), e.enter(c), e.consume(u), e.exit(c), h;
  }
  function h(u) {
    return W(u) ? n(u) : (M = te, $(u));
  }
  function te(u) {
    if (u === 47)
      return e.enter(l), e.consume(u), e.exit(l), M = ue, $;
    if (u === 62)
      return Le(u);
    if (u !== null && u >= 0 && le(u))
      return e.enter(f), e.enter(m), e.consume(u), d;
    S(u, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (u === 33 ? " (note: to create a comment in MDX, use `{/* text */}`)" : ""));
  }
  function ue(u) {
    if (u === 62)
      return Le(u);
    if (u !== null && u >= 0 && le(u))
      return e.enter(f), e.enter(m), e.consume(u), d;
    S(u, "before name", "a character that can start a name, such as a letter, `$`, or `_`" + (u === 42 || u === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function d(u) {
    if (u !== null && u >= 0 && Be(u, {
      jsx: !0
    }))
      return e.consume(u), d;
    if (u === 46 || u === 47 || u === 58 || u === 62 || u === 123 || W(u) || be(u))
      return e.exit(m), M = ne, $(u);
    S(u, "in name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (u === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function ne(u) {
    if (u === 46)
      return e.enter(p), e.consume(u), e.exit(p), M = pe, $;
    if (u === 58)
      return e.enter(C), e.consume(u), e.exit(C), M = fe, $;
    if (u === 47 || u === 62 || u === 123 || u !== null && u >= 0 && le(u))
      return e.exit(f), re(u);
    S(u, "after name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function pe(u) {
    if (u !== null && u >= 0 && le(u))
      return e.enter(T), e.consume(u), Q;
    S(u, "before member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function Q(u) {
    if (u !== null && u >= 0 && Be(u, {
      jsx: !0
    }))
      return e.consume(u), Q;
    if (u === 46 || u === 47 || u === 62 || u === 123 || W(u) || be(u))
      return e.exit(T), M = Te, $(u);
    S(u, "in member name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag" + (u === 64 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function Te(u) {
    if (u === 46)
      return e.enter(p), e.consume(u), e.exit(p), M = pe, $;
    if (u === 47 || u === 62 || u === 123 || u !== null && u >= 0 && le(u))
      return e.exit(f), re(u);
    S(u, "after member name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function fe(u) {
    if (u !== null && u >= 0 && le(u))
      return e.enter(q), e.consume(u), ge;
    S(u, "before local name", "a character that can start a name, such as a letter, `$`, or `_`" + (u === 43 || u !== null && u > 46 && u < 58 ? " (note: to create a link in MDX, use `[text](url)`)" : ""));
  }
  function ge(u) {
    if (u !== null && u >= 0 && Be(u, {
      jsx: !0
    }))
      return e.consume(u), ge;
    if (u === 47 || u === 62 || u === 123 || W(u) || be(u))
      return e.exit(q), M = ye, $(u);
    S(u, "in local name", "a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ye(u) {
    if (u === 47 || u === 62 || u === 123 || u !== null && u >= 0 && le(u))
      return e.exit(f), re(u);
    S(u, "after local name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function re(u) {
    if (u === 47)
      return e.enter(g), e.consume(u), e.exit(g), M = ut, $;
    if (u === 62)
      return Le(u);
    if (u === 123)
      return Yt.call(j, e, ot, x, D, y, r, a, i, !0, !1, o)(u);
    if (u !== null && u >= 0 && le(u))
      return e.enter(E), e.enter(I), e.enter(w), e.consume(u), Je;
    S(u, "before attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag");
  }
  function ot(u) {
    return M = re, $(u);
  }
  function Je(u) {
    if (u !== null && u >= 0 && Be(u, {
      jsx: !0
    }))
      return e.consume(u), Je;
    if (u === 47 || u === 58 || u === 61 || u === 62 || u === 123 || W(u) || be(u))
      return e.exit(w), M = st, $(u);
    S(u, "in attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function st(u) {
    if (u === 58)
      return e.enter(k), e.consume(u), e.exit(k), M = Ve, $;
    if (u === 61)
      return e.exit(I), e.enter(L), e.consume(u), e.exit(L), M = He, $;
    if (u === 47 || u === 62 || u === 123 || W(u) || be(u) || u !== null && u >= 0 && le(u))
      return e.exit(I), e.exit(E), M = re, $(u);
    S(u, "after attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Ve(u) {
    if (u !== null && u >= 0 && le(u))
      return e.enter(A), e.consume(u), Oe;
    S(u, "before local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function Oe(u) {
    if (u !== null && u >= 0 && Be(u, {
      jsx: !0
    }))
      return e.consume(u), Oe;
    if (u === 47 || u === 61 || u === 62 || u === 123 || W(u) || be(u))
      return e.exit(A), e.exit(I), M = Ue, $(u);
    S(u, "in local attribute name", "an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag");
  }
  function Ue(u) {
    if (u === 61)
      return e.enter(L), e.consume(u), e.exit(L), M = He, $;
    if (u === 47 || u === 62 || u === 123 || u !== null && u >= 0 && le(u))
      return e.exit(E), re(u);
    S(u, "after local attribute name", "a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag");
  }
  function He(u) {
    if (u === 34 || u === 39)
      return e.enter(z), e.enter(N), e.consume(u), e.exit(N), K = u, Ie;
    if (u === 123)
      return Yt.call(j, e, Ge, O, V, B, r, a, i, !1, !1, o)(u);
    S(u, "before attribute value", "a character that can start an attribute value, such as `\"`, `'`, or `{`" + (u === 60 ? " (note: to use an element or fragment as a prop value in MDX, use `{<element />}`)" : ""));
  }
  function Ge(u) {
    return e.exit(E), M = re, $(u);
  }
  function Ie(u) {
    return u === null && S(u, "in attribute value", "a corresponding closing quote `" + String.fromCodePoint(K) + "`"), u === K ? (e.enter(N), e.consume(u), e.exit(N), e.exit(z), e.exit(E), K = void 0, M = re, $) : _(u) ? (M = Ie, $(u)) : (e.enter(R), je(u));
  }
  function je(u) {
    return u === null || u === K || _(u) ? (e.exit(R), Ie(u)) : (e.consume(u), je);
  }
  function ut(u) {
    if (u === 62)
      return Le(u);
    S(u, "after self-closing slash", "`>` to end the tag" + (u === 42 || u === 47 ? " (note: JS comments in JSX tags are not supported in MDX)" : ""));
  }
  function Le(u) {
    return e.enter(c), e.consume(u), e.exit(c), e.exit(s), t;
  }
  function $(u) {
    return _(u) ? (e.enter("lineEnding"), e.consume(u), e.exit("lineEnding"), b) : v(u) || be(u) ? (e.enter("esWhitespace"), $e(u)) : M(u);
  }
  function $e(u) {
    return _(u) ? (e.exit("esWhitespace"), $(u)) : v(u) || be(u) ? (e.consume(u), $e) : (e.exit("esWhitespace"), M(u));
  }
  function b(u) {
    if (!o && j.parser.lazy[j.now().line]) {
      const F = new U("Unexpected lazy line in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc", j.now(), "micromark-extension-mdx-jsx:unexpected-lazy");
      throw F.url = Kt + "#unexpected-lazy-line-in-container-expected-line-to-be", F;
    }
    return $(u);
  }
  function S(u, F, J) {
    const Z = new U("Unexpected " + (u === null ? "end of file" : "character `" + (u === 96 ? "` ` `" : String.fromCodePoint(u)) + "` (" + da(u) + ")") + " " + F + ", expected " + J, j.now(), "micromark-extension-mdx-jsx:unexpected-" + (u === null ? "eof" : "character"));
    throw Z.url = Kt + (u === null ? "#unexpected-end-of-file-at-expected-expect" : "#unexpected-character-at-expected-expect"), Z;
  }
}
function da(e) {
  return "U+" + e.toString(16).toUpperCase().padStart(4, "0");
}
function ga(e, t) {
  return {
    name: "mdxJsxTextTag",
    tokenize: n
  };
  function n(r, a, i) {
    return Sn.call(this, r, a, i, e, t.acornOptions, t.addResult, !0, "mdxJsxTextTag", "mdxJsxTextTagMarker", "mdxJsxTextTagClosingMarker", "mdxJsxTextTagSelfClosingMarker", "mdxJsxTextTagName", "mdxJsxTextTagNamePrimary", "mdxJsxTextTagNameMemberMarker", "mdxJsxTextTagNameMember", "mdxJsxTextTagNamePrefixMarker", "mdxJsxTextTagNameLocal", "mdxJsxTextTagExpressionAttribute", "mdxJsxTextTagExpressionAttributeMarker", "mdxJsxTextTagExpressionAttributeValue", "mdxJsxTextTagAttribute", "mdxJsxTextTagAttributeName", "mdxJsxTextTagAttributeNamePrimary", "mdxJsxTextTagAttributeNamePrefixMarker", "mdxJsxTextTagAttributeNameLocal", "mdxJsxTextTagAttributeInitializerMarker", "mdxJsxTextTagAttributeValueLiteral", "mdxJsxTextTagAttributeValueLiteralMarker", "mdxJsxTextTagAttributeValueLiteralValue", "mdxJsxTextTagAttributeValueExpression", "mdxJsxTextTagAttributeValueExpressionMarker", "mdxJsxTextTagAttributeValueExpressionValue");
  }
}
function ma(e, t) {
  return {
    name: "mdxJsxFlowTag",
    tokenize: n,
    concrete: !0
  };
  function n(r, a, i) {
    const o = this;
    return s;
    function s(f) {
      return c(f);
    }
    function c(f) {
      return Sn.call(o, r, l, i, e, t.acornOptions, t.addResult, !1, "mdxJsxFlowTag", "mdxJsxFlowTagMarker", "mdxJsxFlowTagClosingMarker", "mdxJsxFlowTagSelfClosingMarker", "mdxJsxFlowTagName", "mdxJsxFlowTagNamePrimary", "mdxJsxFlowTagNameMemberMarker", "mdxJsxFlowTagNameMember", "mdxJsxFlowTagNamePrefixMarker", "mdxJsxFlowTagNameLocal", "mdxJsxFlowTagExpressionAttribute", "mdxJsxFlowTagExpressionAttributeMarker", "mdxJsxFlowTagExpressionAttributeValue", "mdxJsxFlowTagAttribute", "mdxJsxFlowTagAttributeName", "mdxJsxFlowTagAttributeNamePrimary", "mdxJsxFlowTagAttributeNamePrefixMarker", "mdxJsxFlowTagAttributeNameLocal", "mdxJsxFlowTagAttributeInitializerMarker", "mdxJsxFlowTagAttributeValueLiteral", "mdxJsxFlowTagAttributeValueLiteralMarker", "mdxJsxFlowTagAttributeValueLiteralValue", "mdxJsxFlowTagAttributeValueExpression", "mdxJsxFlowTagAttributeValueExpressionMarker", "mdxJsxFlowTagAttributeValueExpressionValue")(f);
    }
    function l(f) {
      return v(f) ? H(r, g, "whitespace")(f) : g(f);
    }
    function g(f) {
      const m = o.parser.constructs.flow[123], T = (Array.isArray(m) ? m : m ? [m] : []).find((C) => C.name === "mdxFlowExpression");
      return f === 60 ? (
        // We can’t just say: fine. Lines of blocks have to be parsed until an eol/eof.
        s(f)
      ) : f === 123 && T ? r.attempt(T, g, i)(f) : f === null || _(f) ? a(f) : i(f);
    }
  }
}
function xa(e) {
  const t = {}, n = t.acorn;
  let r;
  if (n) {
    if (!n.parse || !n.parseExpressionAt)
      throw new Error("Expected a proper `acorn` instance passed in as `options.acorn`");
    r = Object.assign({
      ecmaVersion: 2024,
      sourceType: "module"
    }, t.acornOptions, {
      locations: !0
    });
  } else if (t.acornOptions || t.addResult)
    throw new Error("Expected an `acorn` instance passed in as `options.acorn`");
  return {
    flow: {
      60: ma(n || void 0, {
        acornOptions: r,
        addResult: t.addResult || void 0
      })
    },
    text: {
      60: ga(n || void 0, {
        acornOptions: r,
        addResult: t.addResult || void 0
      })
    }
  };
}
const ba = [
  "AElig",
  "AMP",
  "Aacute",
  "Acirc",
  "Agrave",
  "Aring",
  "Atilde",
  "Auml",
  "COPY",
  "Ccedil",
  "ETH",
  "Eacute",
  "Ecirc",
  "Egrave",
  "Euml",
  "GT",
  "Iacute",
  "Icirc",
  "Igrave",
  "Iuml",
  "LT",
  "Ntilde",
  "Oacute",
  "Ocirc",
  "Ograve",
  "Oslash",
  "Otilde",
  "Ouml",
  "QUOT",
  "REG",
  "THORN",
  "Uacute",
  "Ucirc",
  "Ugrave",
  "Uuml",
  "Yacute",
  "aacute",
  "acirc",
  "acute",
  "aelig",
  "agrave",
  "amp",
  "aring",
  "atilde",
  "auml",
  "brvbar",
  "ccedil",
  "cedil",
  "cent",
  "copy",
  "curren",
  "deg",
  "divide",
  "eacute",
  "ecirc",
  "egrave",
  "eth",
  "euml",
  "frac12",
  "frac14",
  "frac34",
  "gt",
  "iacute",
  "icirc",
  "iexcl",
  "igrave",
  "iquest",
  "iuml",
  "laquo",
  "lt",
  "macr",
  "micro",
  "middot",
  "nbsp",
  "not",
  "ntilde",
  "oacute",
  "ocirc",
  "ograve",
  "ordf",
  "ordm",
  "oslash",
  "otilde",
  "ouml",
  "para",
  "plusmn",
  "pound",
  "quot",
  "raquo",
  "reg",
  "sect",
  "shy",
  "sup1",
  "sup2",
  "sup3",
  "szlig",
  "thorn",
  "times",
  "uacute",
  "ucirc",
  "ugrave",
  "uml",
  "uuml",
  "yacute",
  "yen",
  "yuml"
], Zt = {
  0: "�",
  128: "€",
  130: "‚",
  131: "ƒ",
  132: "„",
  133: "…",
  134: "†",
  135: "‡",
  136: "ˆ",
  137: "‰",
  138: "Š",
  139: "‹",
  140: "Œ",
  142: "Ž",
  145: "‘",
  146: "’",
  147: "“",
  148: "”",
  149: "•",
  150: "–",
  151: "—",
  152: "˜",
  153: "™",
  154: "š",
  155: "›",
  156: "œ",
  158: "ž",
  159: "Ÿ"
};
function Tn(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 48 && t <= 57;
}
function ya(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 102 || t >= 65 && t <= 70 || t >= 48 && t <= 57;
}
function wa(e) {
  const t = typeof e == "string" ? e.charCodeAt(0) : e;
  return t >= 97 && t <= 122 || t >= 65 && t <= 90;
}
function Xt(e) {
  return wa(e) || Tn(e);
}
const ka = [
  "",
  /* 1: Non terminated (named) */
  "Named character references must be terminated by a semicolon",
  /* 2: Non terminated (numeric) */
  "Numeric character references must be terminated by a semicolon",
  /* 3: Empty (named) */
  "Named character references cannot be empty",
  /* 4: Empty (numeric) */
  "Numeric character references cannot be empty",
  /* 5: Unknown (named) */
  "Named character references must be known",
  /* 6: Disallowed (numeric) */
  "Numeric character references cannot be disallowed",
  /* 7: Prohibited (numeric) */
  "Numeric character references cannot be outside the permissible Unicode range"
];
function Ea(e, t) {
  const n = t, r = typeof n.additional == "string" ? n.additional.charCodeAt(0) : n.additional, a = [];
  let i = 0, o = -1, s = "", c, l;
  n.position && ("start" in n.position || "indent" in n.position ? (l = n.position.indent, c = n.position.start) : c = n.position);
  let g = (c ? c.line : 0) || 1, f = (c ? c.column : 0) || 1, m = T(), p;
  for (i--; ++i <= e.length; )
    if (p === 10 && (f = (l ? l[o] : 0) || 1), p = e.charCodeAt(i), p === 38) {
      const x = e.charCodeAt(i + 1);
      if (x === 9 || x === 10 || x === 12 || x === 32 || x === 38 || x === 60 || Number.isNaN(x) || r && x === r) {
        s += String.fromCharCode(p), f++;
        continue;
      }
      const D = i + 1;
      let y = D, E = D, I;
      if (x === 35) {
        E = ++y;
        const O = e.charCodeAt(E);
        O === 88 || O === 120 ? (I = "hexadecimal", E = ++y) : I = "decimal";
      } else
        I = "named";
      let w = "", k = "", A = "";
      const L = I === "named" ? Xt : I === "decimal" ? Tn : ya;
      for (E--; ++E <= e.length; ) {
        const O = e.charCodeAt(E);
        if (!L(O))
          break;
        A += String.fromCharCode(O), I === "named" && ba.includes(A) && (w = A, k = ve(A));
      }
      let z = e.charCodeAt(E) === 59;
      if (z) {
        E++;
        const O = I === "named" ? ve(A) : !1;
        O && (w = A, k = O);
      }
      let N = 1 + E - D, R = "";
      if (!(!z && n.nonTerminated === !1)) if (!A)
        I !== "named" && C(4, N);
      else if (I === "named") {
        if (z && !k)
          C(5, 1);
        else if (w !== A && (E = y + w.length, N = 1 + E - y, z = !1), !z) {
          const O = w ? 1 : 3;
          if (n.attribute) {
            const V = e.charCodeAt(E);
            V === 61 ? (C(O, N), k = "") : Xt(V) ? k = "" : C(O, N);
          } else
            C(O, N);
        }
        R = k;
      } else {
        z || C(2, N);
        let O = Number.parseInt(
          A,
          I === "hexadecimal" ? 16 : 10
        );
        if (Sa(O))
          C(7, N), R = "�";
        else if (O in Zt)
          C(6, N), R = Zt[O];
        else {
          let V = "";
          Ta(O) && C(6, N), O > 65535 && (O -= 65536, V += String.fromCharCode(
            O >>> 10 | 55296
          ), O = 56320 | O & 1023), R = V + String.fromCharCode(O);
        }
      }
      if (R) {
        q(), m = T(), i = E - 1, f += E - D + 1, a.push(R);
        const O = T();
        O.offset++, n.reference && n.reference.call(
          n.referenceContext || void 0,
          R,
          { start: m, end: O },
          e.slice(D - 1, E)
        ), m = O;
      } else
        A = e.slice(D - 1, E), s += A, f += A.length, i = E - 1;
    } else
      p === 10 && (g++, o++, f = 0), Number.isNaN(p) ? q() : (s += String.fromCharCode(p), f++);
  return a.join("");
  function T() {
    return {
      line: g,
      column: f,
      offset: i + ((c ? c.offset : 0) || 0)
    };
  }
  function C(x, D) {
    let y;
    n.warning && (y = T(), y.column += D, y.offset += D, n.warning.call(
      n.warningContext || void 0,
      ka[x],
      y,
      x
    ));
  }
  function q() {
    s && (a.push(s), n.text && n.text.call(n.textContext || void 0, s, {
      start: m,
      end: T()
    }), s = "");
  }
}
function Sa(e) {
  return e >= 55296 && e <= 57343 || e > 1114111;
}
function Ta(e) {
  return e >= 1 && e <= 8 || e === 11 || e >= 13 && e <= 31 || e >= 127 && e <= 159 || e >= 64976 && e <= 65007 || (e & 65535) === 65535 || (e & 65535) === 65534;
}
function Qe(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? en(e.position) : "start" in e || "end" in e ? en(e) : "line" in e || "column" in e ? Et(e) : "";
}
function Et(e) {
  return tn(e && e.line) + ":" + tn(e && e.column);
}
function en(e) {
  return Et(e && e.start) + "-" + Et(e && e.end);
}
function tn(e) {
  return e && typeof e == "number" ? e : 1;
}
function Aa() {
  return {
    canContainEols: ["mdxJsxTextElement"],
    enter: {
      mdxJsxFlowTag: r,
      mdxJsxFlowTagClosingMarker: a,
      mdxJsxFlowTagAttribute: f,
      mdxJsxFlowTagExpressionAttribute: m,
      mdxJsxFlowTagAttributeValueLiteral: e,
      mdxJsxFlowTagAttributeValueExpression: e,
      mdxJsxFlowTagSelfClosingMarker: o,
      mdxJsxTextTag: r,
      mdxJsxTextTagClosingMarker: a,
      mdxJsxTextTagAttribute: f,
      mdxJsxTextTagExpressionAttribute: m,
      mdxJsxTextTagAttributeValueLiteral: e,
      mdxJsxTextTagAttributeValueExpression: e,
      mdxJsxTextTagSelfClosingMarker: o
    },
    exit: {
      mdxJsxFlowTagClosingMarker: s,
      mdxJsxFlowTagNamePrimary: c,
      mdxJsxFlowTagNameMember: l,
      mdxJsxFlowTagNameLocal: g,
      mdxJsxFlowTagExpressionAttribute: p,
      mdxJsxFlowTagExpressionAttributeValue: n,
      mdxJsxFlowTagAttributeNamePrimary: T,
      mdxJsxFlowTagAttributeNameLocal: C,
      mdxJsxFlowTagAttributeValueLiteral: q,
      mdxJsxFlowTagAttributeValueLiteralValue: n,
      mdxJsxFlowTagAttributeValueExpression: x,
      mdxJsxFlowTagAttributeValueExpressionValue: n,
      mdxJsxFlowTagSelfClosingMarker: D,
      mdxJsxFlowTag: y,
      mdxJsxTextTagClosingMarker: s,
      mdxJsxTextTagNamePrimary: c,
      mdxJsxTextTagNameMember: l,
      mdxJsxTextTagNameLocal: g,
      mdxJsxTextTagExpressionAttribute: p,
      mdxJsxTextTagExpressionAttributeValue: n,
      mdxJsxTextTagAttributeNamePrimary: T,
      mdxJsxTextTagAttributeNameLocal: C,
      mdxJsxTextTagAttributeValueLiteral: q,
      mdxJsxTextTagAttributeValueLiteralValue: n,
      mdxJsxTextTagAttributeValueExpression: x,
      mdxJsxTextTagAttributeValueExpressionValue: n,
      mdxJsxTextTagSelfClosingMarker: D,
      mdxJsxTextTag: y
    }
  };
  function e() {
    this.buffer();
  }
  function t(k) {
    return { line: k.line, column: k.column, offset: k.offset };
  }
  function n(k) {
    this.config.enter.data.call(this, k), this.config.exit.data.call(this, k);
  }
  function r(k) {
    const A = {
      name: void 0,
      attributes: [],
      close: !1,
      selfClosing: !1,
      start: k.start,
      end: k.end
    };
    this.data.mdxJsxTagStack || (this.data.mdxJsxTagStack = []), this.data.mdxJsxTag = A, this.buffer();
  }
  function a(k) {
    if (this.data.mdxJsxTagStack.length === 0)
      throw new U(
        "Unexpected closing slash `/` in tag, expected an open tag first",
        { start: k.start, end: k.end },
        "mdast-util-mdx-jsx:unexpected-closing-slash"
      );
  }
  function i(k) {
    if (this.data.mdxJsxTag.close)
      throw new U(
        "Unexpected attribute in closing tag, expected the end of the tag",
        { start: k.start, end: k.end },
        "mdast-util-mdx-jsx:unexpected-attribute"
      );
  }
  function o(k) {
    if (this.data.mdxJsxTag.close)
      throw new U(
        "Unexpected self-closing slash `/` in closing tag, expected the end of the tag",
        { start: k.start, end: k.end },
        "mdast-util-mdx-jsx:unexpected-self-closing-slash"
      );
  }
  function s() {
    const k = this.data.mdxJsxTag;
    k.close = !0;
  }
  function c(k) {
    const A = this.data.mdxJsxTag;
    A.name = this.sliceSerialize(k);
  }
  function l(k) {
    const A = this.data.mdxJsxTag;
    A.name += "." + this.sliceSerialize(k);
  }
  function g(k) {
    const A = this.data.mdxJsxTag;
    A.name += ":" + this.sliceSerialize(k);
  }
  function f(k) {
    const A = this.data.mdxJsxTag;
    i.call(this, k), A.attributes.push({
      type: "mdxJsxAttribute",
      name: "",
      value: null,
      position: {
        start: t(k.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    });
  }
  function m(k) {
    const A = this.data.mdxJsxTag;
    i.call(this, k), A.attributes.push({
      type: "mdxJsxExpressionAttribute",
      value: "",
      position: {
        start: t(k.start),
        // @ts-expect-error: `end` will be patched later.
        end: void 0
      }
    }), this.buffer();
  }
  function p(k) {
    const A = this.data.mdxJsxTag, L = A.attributes[A.attributes.length - 1];
    L.type;
    const z = k.estree;
    L.value = this.resume(), L.position, L.position.end = t(k.end), z && (L.data = { estree: z });
  }
  function T(k) {
    const A = this.data.mdxJsxTag, L = A.attributes[A.attributes.length - 1];
    L.type, L.name = this.sliceSerialize(k), L.position, L.position.end = t(k.end);
  }
  function C(k) {
    const A = this.data.mdxJsxTag, L = A.attributes[A.attributes.length - 1];
    L.type, L.name += ":" + this.sliceSerialize(k), L.position, L.position.end = t(k.end);
  }
  function q(k) {
    const A = this.data.mdxJsxTag, L = A.attributes[A.attributes.length - 1];
    L.value = Ea(this.resume(), { nonTerminated: !1 }), L.position, L.position.end = t(k.end);
  }
  function x(k) {
    const A = this.data.mdxJsxTag, L = A.attributes[A.attributes.length - 1];
    L.type;
    const z = { type: "mdxJsxAttributeValueExpression", value: this.resume() }, N = k.estree;
    N && (z.data = { estree: N }), L.value = z, L.position, L.position.end = t(k.end);
  }
  function D() {
    const k = this.data.mdxJsxTag;
    k.selfClosing = !0;
  }
  function y(k) {
    const A = this.data.mdxJsxTag, L = this.data.mdxJsxTagStack, z = L[L.length - 1];
    if (A.close && z.name !== A.name)
      throw new U(
        "Unexpected closing tag `" + w(A) + "`, expected corresponding closing tag for `" + w(z) + "` (" + Qe(z) + ")",
        { start: k.start, end: k.end },
        "mdast-util-mdx-jsx:end-tag-mismatch"
      );
    this.resume(), A.close ? L.pop() : this.enter(
      {
        type: k.type === "mdxJsxTextTag" ? "mdxJsxTextElement" : "mdxJsxFlowElement",
        name: A.name || null,
        attributes: A.attributes,
        children: []
      },
      k,
      E
    ), A.selfClosing || A.close ? this.exit(k, I) : L.push(A);
  }
  function E(k, A) {
    const L = this.data.mdxJsxTagStack, z = L[L.length - 1], N = k ? " before the end of `" + k.type + "`" : "", R = k ? { start: k.start, end: k.end } : void 0;
    throw new U(
      "Expected a closing tag for `" + w(z) + "` (" + Qe({ start: A.start, end: A.end }) + ")" + N,
      R,
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function I(k, A) {
    const L = this.data.mdxJsxTag;
    throw new U(
      "Expected the closing tag `" + w(L) + "` either after the end of `" + A.type + "` (" + Qe(A.end) + ") or another opening tag after the start of `" + A.type + "` (" + Qe(A.start) + ")",
      { start: k.start, end: k.end },
      "mdast-util-mdx-jsx:end-tag-mismatch"
    );
  }
  function w(k) {
    return "<" + (k.close ? "/" : "") + (k.name || "") + ">";
  }
}
function Ca(e) {
  return Ji(e, Ia);
}
const Ia = {
  extensions: [Hi(), xa()],
  mdastExtensions: [Gi(), Aa()]
};
var De = /* @__PURE__ */ ((e) => (e.CLOSE_READING = "CLOSE_READING", e.CLOZE_DROPDOWN = "CLOZE_DROPDOWN", e.FREE_RESPONSE = "FREE_RESPONSE", e.IMAGE_LABELING = "IMAGE_LABELING", e.MULTIPLE_CHOICE = "MULTIPLE_CHOICE", e.MULTIPLE_SELECT = "MULTIPLE_SELECT", e))(De || {}), Ce = /* @__PURE__ */ ((e) => (e.IMAGE = "IMAGE", e))(Ce || {}), La = /* @__PURE__ */ ((e) => (e.Text = "Text", e.Input = "Input", e))(La || {});
function Na(e) {
  var r;
  const t = [];
  let n = 0;
  for (const a of e.matchAll(/\{\{response\[\d+\]\}\}/g)) {
    const i = a[0], o = a.index, s = e.substring(n, o);
    if (s && t.push({
      type: "Text",
      text: s
    }), i.length) {
      const c = (r = i.match(/\d+/)) == null ? void 0 : r[0];
      c != null && c.length && t.push({ type: "Input", inputId: c });
    }
    n = (o ?? 0) + i.length;
  }
  return n !== e.length && t.push({
    type: "Text",
    text: e.substring(n, e.length)
  }), t;
}
function _a(e) {
  return e.map((t) => t.type === "Text" ? t.text : t.type === "Input" ? `{{response[${t.inputId}]}}` : "").join("");
}
function Ra(e) {
  const t = [];
  return Na(e).forEach((n) => {
    n.type === "Input" && t.push(n.inputId);
  }), t;
}
let Ye;
const de = {
  CLOSE_READING: {
    getSchema: (e) => {
      if (Ye)
        return Ye;
      const t = new e(
        {
          type: P(String, {
            enum: Y.ANNOTATION_TOOL
          }),
          colors: [{ type: String, enum: Y.COLOR }]
        },
        { _id: !1 }
      ), n = new e(
        {
          tool: {
            type: String,
            enum: [...Object.keys(Y.ANNOTATION_TOOL), null],
            required: !1
          },
          color: {
            type: String,
            enum: [...Object.keys(Y.COLOR), null],
            required: !1
          }
        },
        { _id: !1 }
      ), r = new e(
        {
          score: P(Number),
          required: P(Boolean),
          range: P({
            start: P(Number),
            end: P(Number)
          }),
          buffer: P({
            start: P(Number),
            end: P(Number)
          }),
          style: P(n)
        },
        { _id: !1 }
      ), a = new e(
        {
          type: P(String, { enum: Y.GRADING }),
          requiredScore: Number
        },
        { _id: !1 }
      );
      return Ye = new e(
        {
          phrase: P(String),
          textBody: P(String),
          annotationLimit: Number,
          requiredAnnotations: Number,
          grading: P(a),
          matchType: P(String, { enum: Y.MATCH_TYPE }),
          availableAnnotationTools: Fe(
            t,
            "Available annotation tools must be provided"
          ),
          targetAnnotations: [r]
        },
        { _id: !1 }
      ), Ye;
    },
    grade: (e, t, n) => {
      if (e.type !== "CLOSE_READING" || t.type !== "CLOSE_READING" || e.grading.type === Y.GRADING.NONE) return;
      const { annotations: r } = t.value;
      let a;
      if (e.matchType === Y.MATCH_TYPE.WORD) {
        if (!(n != null && n.markdownAST))
          throw new Error(
            "Missing markdownAST for word range transformer in close reading question"
          );
        a = On(n.markdownAST);
      } else
        throw new Error("Unsupported match type for close reading question");
      if (e.requiredAnnotations && e.requiredAnnotations > r.length || e.annotationLimit && e.annotationLimit < r.length)
        return 0;
      const { score: i, allRequiredTargetsSatisfied: o } = ln(
        e.targetAnnotations,
        r,
        a
      );
      return !o || e.grading.type === Y.GRADING.PASS_FAIL && e.grading.requiredScore > i ? 0 : i;
    },
    getBestPossibleScore: (e) => e.grading.type === Y.GRADING.PARTIAL_CREDIT ? e.targetAnnotations.reduce(
      (t, n) => t += n.score,
      0
    ) : e.grading.type === Y.GRADING.PASS_FAIL ? e.grading.requiredScore : 1,
    // Validate a close reading question
    validate: (e) => {
      try {
        if (G(e.phrase, "string", "phrase"), G(e.textBody, "string", "textBody"), G(e.grading, "object", "grading"), G(e.matchType, Y.MATCH_TYPE, "matchType"), G(
          e.availableAnnotationTools,
          "array-non-empty",
          "availableAnnotationTools"
        ), e.annotationLimit != null && G(e.annotationLimit, "number", "annotationLimit"), e.requiredAnnotations != null) {
          G(
            e.requiredAnnotations,
            "number",
            "requiredAnnotations"
          );
          const c = e.requiredAnnotations, l = e.annotationLimit;
          if (l != null && c > l)
            throw new ee(
              "requiredAnnotations must be less than or equal to annotationLimit",
              "requiredAnnotations"
            );
        }
        const t = e.grading;
        G(t.type, Y.GRADING, "grading.type");
        const n = t.type === Y.GRADING.NONE;
        G(
          e.targetAnnotations,
          n ? "array" : "array-non-empty",
          "targetAnnotations"
        );
        const r = e.textBody, a = e.availableAnnotationTools;
        t.type === Y.GRADING.PASS_FAIL && G(
          t.requiredScore,
          "number",
          "grading.requiredScore"
        );
        const i = e.targetAnnotations, o = {};
        a.forEach((c, l) => {
          G(c, "object", `availableAnnotationTools[${l}]`), G(
            c.type,
            Y.ANNOTATION_TOOL,
            `availableAnnotationTools[${l}].type`
          );
          const g = c.type;
          if (c.colors) {
            G(
              c.colors,
              "array-non-empty",
              `availableAnnotationTools[${l}].colors`
            );
            const f = c.colors;
            f.map(
              (m, p) => G(
                m,
                Y.COLOR,
                `availableAnnotationTools[${l}].colors[${p}]`
              )
            ), o[g] = f;
          }
        });
        const s = new Set(
          Object.values(o).flat()
        );
        i.forEach((c, l) => {
          G(c, "object", `targetAnnotations[${l}]`), G(
            c.score,
            "number",
            `targetAnnotations[${l}].score`
          ), G(
            c.required,
            "boolean",
            `targetAnnotations[${l}].required`
          ), G(
            c.range,
            "object",
            `targetAnnotations[${l}].range`
          ), G(
            c.buffer,
            "object",
            `targetAnnotations[${l}].buffer`
          ), G(
            c.style,
            "object",
            `targetAnnotations[${l}].style`
          );
          const g = c.range, f = c.buffer;
          G(
            g.start,
            "number",
            `targetAnnotations[${l}].range.start`
          ), G(
            g.end,
            "number",
            `targetAnnotations[${l}].range.end`
          ), G(
            f.start,
            "number",
            `targetAnnotations[${l}].range.start`
          ), G(
            f.end,
            "number",
            `targetAnnotations[${l}].range.end`
          );
          const m = g.start, p = g.end, T = f.start, C = f.end;
          if (r[m] == null || r[p] == null || r[T] == null || r[C] == null)
            throw new ee(
              "range values are out of bounds of text",
              `targetAnnotations[${l}].range`
            );
          if (m >= p)
            throw new ee(
              "range start occurs after range end",
              `targetAnnotations[${l}].range`
            );
          if (T >= C)
            throw new ee(
              "buffer start occurs after buffer end",
              `targetAnnotations[${l}].buffer`
            );
          if (m < T || p > C)
            throw new ee(
              "range must be within buffer",
              `targetAnnotations[${l}].range`
            );
          const q = c.style;
          if (q.tool)
            if (G(
              q.tool,
              Y.ANNOTATION_TOOL,
              `targetAnnotations[${l}].style.tool`
            ), o[q.tool]) {
              const x = o[q.tool];
              if (q.color && (!x || !x.includes(
                q.color
              )))
                throw new ee(
                  "color is not available for tool",
                  `targetAnnotations[${l}].style.color`
                );
            } else
              throw new ee(
                "tool is not available",
                `targetAnnotations[${l}].style.tool`
              );
          if (q.color && (G(
            q.color,
            Y.COLOR,
            `targetAnnotations[${l}].style.color`
          ), !s.has(
            q.color
          )))
            throw new ee(
              "target color is not available for annotation",
              `targetAnnotations[${l}].style.color`
            );
        });
      } catch (t) {
        if (t instanceof ee)
          return { error: t.message, field: t.field };
        throw t;
      }
    },
    getClassScores: (e, t) => {
      e.type;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCorrectAnswer: (e) => {
    },
    updateMedia: (e) => e
  },
  CLOZE_DROPDOWN: {
    getSchema: (e) => {
      const t = new e(
        {
          templateResponseKey: P(String),
          choices: P([Xe(e)])
        },
        { _id: !1 }
      );
      return new e({
        template: P(String),
        dropdowns: Fe(
          t,
          "Question must contain at least one drop-down"
        )
      });
    },
    getClassScores: (e, t) => {
      if (e.type === "CLOZE_DROPDOWN")
        return an(e, t);
    },
    getCorrectAnswer: (e) => {
      if (e.type !== "CLOZE_DROPDOWN")
        return;
      const t = {};
      if (e.dropdowns.forEach((n) => {
        var a;
        const r = (a = n.choices.find((i) => i.answer)) == null ? void 0 : a._id;
        r && (t[n.templateResponseKey] = String(r));
      }), Object.keys(t).length === e.dropdowns.length)
        return {
          type: "CLOZE_DROPDOWN",
          value: t
        };
    },
    updateMedia: rn,
    validate: (e) => {
      if (!e.template)
        return { error: "missing text", field: "template" };
      if (!ke(e.template))
        return { error: "incorrect format", field: "template" };
      const t = e.template, n = new Set(Ra(t));
      if (!n.size)
        return { error: "at least one dropdown is required", field: "template" };
      if (!Array.isArray(e.dropdowns) || e.dropdowns.length === 0)
        return {
          error: "at least one dropdown is required",
          field: "dropdowns"
        };
      for (const r of e.dropdowns) {
        if (!r.templateResponseKey || !ke(r.templateResponseKey))
          return {
            error: "a dropdown key is badly formatted",
            field: "dropdowns"
          };
        if (!n.has(r.templateResponseKey))
          return {
            error: "a dropdown created is no longer in the phrase",
            field: "dropdowns"
          };
        n.delete(r.templateResponseKey);
        const a = Ke(r.choices);
        if (a.error)
          return {
            error: `${a.error} for dropdown with key ${r.templateResponseKey}`,
            field: "dropdowns"
          };
        if (a.answerCount !== 1)
          return {
            error: `too many answers marked as correct for dropdown with key ${r.templateResponseKey}`,
            field: "dropdowns"
          };
      }
      if (n.size > 0)
        return {
          error: "phrase references a dropdown that does not exist",
          field: "template"
        };
    },
    grade: (e, t) => {
      if (t.type === "CLOZE_DROPDOWN" && Ee(t.value) && e.type === "CLOZE_DROPDOWN")
        return nn(
          e.dropdowns,
          (n) => n.templateResponseKey,
          t
        );
    }
  },
  FREE_RESPONSE: {
    getSchema: (e) => new e({
      phrase: P(String),
      answer: String
    }),
    grade: () => null,
    updateMedia: (e) => e,
    getClassScores: () => {
    },
    getCorrectAnswer: (e) => {
      if (e.type === "FREE_RESPONSE")
        return {
          type: "FREE_RESPONSE",
          value: e.answer || ""
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return {
          error: "missing text",
          field: "phrase"
        };
      if (!ke(e.phrase))
        return { error: "incorrectly formatted", field: "phrase" };
      if (e.answer != null && !ke(e.answer))
        return { error: "incorrectly formatted", field: "answer" };
    }
  },
  IMAGE_LABELING: {
    getSchema: (e) => {
      const t = new e(
        {
          x: P(Number),
          y: P(Number),
          choices: Fe(
            Xe(e),
            "A dropdown is missing options"
          )
        },
        { _id: !1 }
      );
      return new e({
        media: Fe(
          At(e),
          "Question must contain an image"
        ),
        phrase: P(String),
        imageProperties: P(
          new e(
            {
              width: P(Number),
              height: P(Number)
            },
            { _id: !1 }
          ),
          { default: { width: 550, height: 250 } }
        ),
        dropdowns: Fe(
          t,
          "Question must contain at least one drop-down"
        )
      });
    },
    grade: (e, t) => {
      if (t.type === "IMAGE_LABELING" && Ee(t.value) && e.type === "IMAGE_LABELING")
        return nn(e.dropdowns, mt, t);
    },
    getClassScores: (e, t) => {
      if (e.type === "IMAGE_LABELING")
        return an(e, t);
    },
    updateMedia: rn,
    getCorrectAnswer: (e) => {
      if (e.type !== "IMAGE_LABELING")
        return;
      const t = {};
      if (e.dropdowns.forEach((n) => {
        var a;
        const r = (a = n.choices.find((i) => i.answer)) == null ? void 0 : a._id;
        r || (t[mt(n)] = String(r));
      }), Object.keys(t).length === e.dropdowns.length)
        return {
          type: "IMAGE_LABELING",
          value: t
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return {
          error: "missing text",
          field: "phrase"
        };
      if (!ke(e.phrase))
        return { error: "incorrectly formatted", field: "phrase" };
      if (e.media && (!Array.isArray(e.media) || e.media[0].type !== "IMAGE"))
        return { error: "unknown media format", field: "media" };
      if (!e.media || Array.isArray(e.media) && e.media.length === 0)
        return { error: "missing a valid image", field: "media" };
      if (Array.isArray(e.media) && e.media.length > 1)
        return {
          error: "only one media image is allowed",
          field: "media"
        };
      const t = e.imageProperties;
      if (!Ee(t) || !t.hasOwnProperty("width") || !t.hasOwnProperty("height") || typeof t.width != "number" || typeof t.height != "number" || t.width <= 0 || t.height <= 0)
        return {
          error: "failed to validate image properties",
          field: "imageProperties"
        };
      const n = t;
      if (!Array.isArray(e.dropdowns) || e.dropdowns.length === 0)
        return {
          error: "at least one dropdown is required",
          field: "dropdowns"
        };
      const r = /* @__PURE__ */ new Set();
      let a = 0;
      for (const i of e.dropdowns) {
        if (a += 1, typeof i != "object" || !i)
          return {
            error: "a dropdown is incorrectly formatted",
            field: "dropdowns"
          };
        const o = mt(i);
        if (r.has(o))
          return {
            error: `dropdown ${a} is in the same location on the image as another dropdown`,
            field: "dropdowns"
          };
        if (typeof i.x != "number" || typeof i.y != "number" || // Check to make sure coordinates are within the imageProperty width and height
        !(i.x >= 0 && i.x <= n.width) || !(i.y >= 0 && i.y <= n.height))
          return {
            error: `the coordinates for dropdown ${a} are outside of the image`,
            field: "dropdowns"
          };
        r.add(o);
        const s = Ke(i.choices);
        if (s.error)
          return {
            error: `${s.error} for dropdown ${a}`,
            field: "dropdowns"
          };
        if (s.answerCount !== 1)
          return {
            error: `too many answers marked as correct for dropdown ${a}`,
            field: "dropdowns"
          };
      }
    }
  },
  MULTIPLE_CHOICE: {
    getSchema: (e) => new e({
      phrase: P(String),
      choices: P([Xe(e)])
    }),
    grade: (e, t) => {
      if (e.type !== "MULTIPLE_CHOICE" || t.type !== "MULTIPLE_CHOICE") return;
      const n = e.choices.find((r) => String(r._id) === String(t.value));
      return n ? n.answer ? 1 : 0 : void 0;
    },
    updateMedia: (e, t) => (e.type !== "MULTIPLE_CHOICE" || (e.choices = St(e.choices, t)), e),
    getClassScores: (e, t) => {
      if (e.type === "MULTIPLE_CHOICE")
        return on(e, t);
    },
    getCorrectAnswer: (e) => {
      var n;
      if (e.type !== "MULTIPLE_CHOICE")
        return;
      const t = (n = e.choices.find(({ answer: r }) => r)) == null ? void 0 : n._id;
      if (t)
        return {
          type: "MULTIPLE_CHOICE",
          value: String(t)
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return {
          error: "missing text",
          field: "phrase"
        };
      if (!ke(e.phrase))
        return {
          error: "incorrectly formatted",
          field: "phrase"
        };
      const t = Ke(e.choices);
      if (t.error)
        return { error: t.error, field: "choices" };
      if (t.answerCount !== 1)
        return { error: "too many answers marked as correct", field: "choices" };
    }
  },
  MULTIPLE_SELECT: {
    getSchema: (e) => new e({
      phrase: P(String),
      choices: P([Xe(e)])
    }),
    grade: (e, t) => {
      if (t.type !== "MULTIPLE_SELECT" || !Array.isArray(t.value) || e.type !== "MULTIPLE_SELECT") return;
      const n = /* @__PURE__ */ new Set(), r = t.value, a = e.choices.reduce((i, o) => (o.answer === !0 && n.add(String(o._id)), { ...i, [String(o._id)]: o }), {});
      if (!(!Array.isArray(r) || r.some((i) => !a[String(i)]))) {
        for (const i of r) {
          const o = String(i);
          if (n.has(o))
            n.delete(o);
          else
            return 0;
        }
        return n.size === 0 ? 1 : 0;
      }
    },
    updateMedia: (e, t) => (e.type !== "MULTIPLE_SELECT" || (e.choices = St(e.choices, t)), e),
    getClassScores: (e, t) => {
      if (e.type === "MULTIPLE_SELECT")
        return on(e, t);
    },
    getCorrectAnswer: (e) => {
      if (e.type !== "MULTIPLE_SELECT")
        return;
      const t = e.choices.filter(({ answer: n }) => n).map(({ _id: n }) => String(n));
      if (t.length)
        return {
          type: "MULTIPLE_SELECT",
          value: t
        };
    },
    validate: (e) => {
      if (!e.phrase)
        return { error: "missing text", field: "phrase" };
      if (!ke(e.phrase))
        return { error: "incorrectly formatted", field: "phrase" };
      const t = Ke(e.choices);
      if (t.error)
        return { error: t.error, field: "choices" };
    }
  }
};
function mt(e) {
  return `${e.x}-${e.y}`;
}
function nn(e, t, n) {
  const r = n.value, a = e.reduce(
    (i, o) => {
      if (i === void 0) return i;
      const s = r[t(o)];
      if (!s)
        return;
      const c = o.choices.find((l) => String(l._id) === String(s));
      if (c)
        return i + (c.answer ? 1 : 0);
    },
    0
  );
  if (!(a === void 0 || e.length === 0))
    return a / e.length;
}
function St(e, t) {
  return e.map((n) => n.media ? {
    ...n,
    media: n.media.map((r) => t(r))
  } : n);
}
function rn(e, t) {
  return e.type !== "CLOZE_DROPDOWN" && e.type !== "IMAGE_LABELING" ? e : {
    ...e,
    dropdowns: e.dropdowns.map((n) => ({
      ...n,
      choices: St(n.choices, t)
    }))
  };
}
function Ke(e) {
  var r;
  let t = 0, n = 0;
  if (e && Array.isArray(e) && e.length > 0)
    for (const a of e) {
      if (n += 1, !a) return { error: `choice ${n} is undefined` };
      let i = !1;
      if (a.media && Array.isArray(a.media) && (i = (r = a.media) == null ? void 0 : r.find(Boolean)), i && !An(a.media))
        return { error: `media is badly formatted for choice ${n}` };
      if (!a.text && !i)
        return { error: `no media or text exists for choice ${n}` };
      if (a.text && !ke(a.text))
        return {
          error: `text for choice ${n} is incorrectly formatted`
        };
      a.answer && t++;
    }
  return n === 0 ? { error: "at least one choice is required" } : t ? { answerCount: t } : { error: "no choice was marked as correct" };
}
class ee extends Error {
  constructor(n, r) {
    super(n);
    It(this, "field");
    this.field = r;
  }
}
function G(e, t, n) {
  if (e == null)
    throw new ee("missing field", n);
  if (typeof t == "string" && t.includes("array")) {
    if (!Array.isArray(e))
      throw new ee("expected array", n);
    if (t === "array-non-empty" && e.length == 0)
      throw new ee("array must not be empty", n);
  } else if (typeof t == "string") {
    if (typeof e !== t)
      throw new ee(`expected ${t}`, n);
    return;
  } else if (!Object.values(t).includes(e))
    throw new ee("wrong enum value", n);
}
let Ze = null;
function Xe(e) {
  return Ze || (Ze = new e({
    text: {
      type: String,
      required: function() {
        var t;
        return !this.media || ((t = this.media) == null ? void 0 : t.length) == 0;
      }
    },
    media: {
      type: [At(e)],
      // only require media if there is no text
      required: function() {
        return !this.text;
      }
    },
    answer: P(Boolean)
  }), Ze);
}
function an(e, t) {
  if (t.some((i) => i.type !== e.type))
    return;
  const n = t, r = {}, a = {};
  return n.forEach((i) => {
    const o = i.value;
    typeof o != "object" || Array.isArray(o) || Object.keys(o).forEach((s) => {
      const c = o[s];
      a[s] = (a[s] || 0) + 1, r[s] = r[s] || {}, r[s][c] = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      (r[s][c] || 0) + 1;
    });
  }), {
    type: e.type,
    optionScores: Object.keys(r).map((i) => ({
      templateResponsekey: i,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      choices: Object.keys(r[i]).map((o) => ({
        _id: o,
        score: (
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          r[i][o] / (a[i] || 1)
        )
      }))
    }))
  };
}
function on(e, t) {
  const n = t.filter(
    (a) => a.type === e.type
  ), r = {};
  return n.forEach((a) => {
    const i = a.value;
    if (typeof i != "string" && !Array.isArray(i))
      return;
    (Array.isArray(i) ? i : [i]).forEach((s) => {
      typeof s == "string" && (r[s] = (r[s] || 0) + 1);
    });
  }), {
    type: e.type,
    optionScores: Object.keys(r).map((a) => ({
      _id: a,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      score: r[a] / (t.length || 1)
    }))
  };
}
function Ee(e) {
  return typeof e == "object" && e != null;
}
function ke(e) {
  return typeof e == "string";
}
function An(e) {
  return e ? Array.isArray(e) ? e.every((t) => {
    if ((Ee(t) || Ee(t)) && typeof t.type == "string" && t.type in Ce) {
      if (Ee(t) && t.url)
        return typeof t.url == "string";
      if (Ee(t) && t.file)
        return (typeof window < "u" ? t.file instanceof File : !0) && typeof t.localUrl == "string";
    }
  }) : !1 : !0;
}
function za(e) {
  return Ee(e) ? An(e.media) ? typeof e.type != "string" || !(e.type in De) ? { error: "question type is not supported", field: "type" } : de[e.type].validate(e) : { error: "unknown media format", field: "media" } : { error: "unknown format" };
}
const Fa = De;
function Ma(e, t) {
  return de[e].getSchema(t);
}
function Ba(e, t, n) {
  let r;
  if (t && de[e.type]) {
    r = de[e.type].grade(e, t, n);
    const a = qa(e);
    return r === void 0 ? void 0 : { score: r, perfectScore: a };
  }
}
function Pa(e, t) {
  const n = { ...e };
  return n.media && (n.media = n.media.map((r) => t(r))), de[n.type] ? de[n.type].updateMedia(n, t) : n;
}
function va(e, t) {
  Tt(e, "", t);
}
function Ja(e, t) {
  t.forEach(({ referenceKey: n, url: r }) => {
    const a = n.split(".");
    let i = e;
    a.forEach((o, s) => {
      const c = parseInt(o, 10), l = isNaN(c) ? o : c;
      if (!i[l])
        throw Error(
          `Reference ${n} was not formed properly when media references were encoded, or questions have changed since last encoding.`
        );
      if (s + 1 === a.length) {
        if (a[s - 1] !== "media")
          throw Error(
            `${n} does not point to a media object in an array of media objects.`
          );
        if (i[l].type !== Ce.IMAGE)
          throw Error(
            `Support for referencing a media type other than ${Ce.IMAGE} is not implemented in decodeMediaReferences (reference key: ${n})`
          );
        i[l] = {
          type: Ce.IMAGE,
          url: r
        };
      } else
        i = i[l];
    });
  });
}
function Va(e) {
  return de[e.type].getCorrectAnswer(e);
}
function Ua(e, t) {
  return de[e.type].getClassScores(e, t);
}
const Ha = {
  rangeTransformers: {
    selectWholeElementRangeTransformer: un,
    selectWithinElementRangeTransformer: _n
  },
  gradeAnnotations: ln,
  selectableRangesGenerators: {
    getVisibleWordsFromAst: sn
  },
  parseMarkdownToAST: Ca,
  getIndicesOfClosestSelectableElements: rt
};
function Tt(e, t, n) {
  if (e) {
    if (Array.isArray(e)) {
      e.forEach(
        (r, a) => Tt(r, t + `${a}.`, n)
      );
      return;
    }
    if (typeof e == "object" && e !== null && e !== void 0) {
      const r = e;
      Object.keys(r).forEach((a) => {
        if (a === "media") {
          const i = r.media;
          Array.isArray(i) && i.forEach((o, s) => {
            o.type === Ce.IMAGE && o.file && n.append(
              "files",
              o.file,
              t + `media.${s}`
            );
          });
        } else
          Tt(r[a], t + `${a}.`, n);
      });
    }
  }
}
function qa(e) {
  return e.type === De.CLOSE_READING ? de[De.CLOSE_READING].getBestPossibleScore(
    e
  ) : e.scoreValue ?? 1;
}
export {
  Ha as CLOSE_ANNOTATION_HELPERS,
  Y as CLOSE_READING,
  Ce as MediaType,
  La as TemplateSegmentType,
  _a as convertTemplateSegmentsToTemplateString,
  Ja as decodeMediaReferences,
  va as encodeMediaFiles,
  Ua as getClassScores,
  Va as getCorrectAnswerForQuestion,
  mt as getImageDropdownKey,
  Ma as getIndividualSchema,
  Oa as getModel,
  Ra as getTemplateKeys,
  Ba as grade,
  Na as parseTemplateStringIntoSegments,
  Pa as updateMedia,
  za as validate,
  Fa as variantTypes
};
//# sourceMappingURL=index.js.map
